import React, { useState, useEffect } from "react";
import "./Checkout.css";
import axios from "axios";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import getImageUrl from "../../utils/getImageUrl";
const Checkout = () => {
  const formRef = useRef(null);
  const navigate = useNavigate();
  const [city, setCity] = useState("");
  const [shippingRates, setShippingRates] = useState([]);
  const [selectedCourier, setSelectedCourier] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [sameAddress, setSameAddress] = useState(false);
  const [stateAreaMap, setStateAreaMap] = useState();
  const [enteredPinCode, setEnteredPinCode] = useState("");
  const [shippingAddress, setShippingAddress] = useState({
    fullName: "",
    phoneNumber: "",
    email: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    area: "",
    pinCode: "",
  });

  const [billingAddress, setBillingAddress] = useState({
    fullName: "",
    phoneNumber: "",
    email: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    pinCode: "",
  });
  const [cities, setCities] = useState([]);
  const convertVolumeToWeight = (volume) => {
    if (!volume) return 0; // Handle missing input

    // Convert to lowercase and trim spaces
    const cleanVolume = volume.toLowerCase().trim();

    // Convert 'l' to '000' and remove 'ml' to get numeric value in ml
    const numericVolume = parseFloat(
      cleanVolume.replace("l", "000").replace("ml", "")
    );
    if (isNaN(numericVolume) || numericVolume <= 0) return 0; // Handle invalid values

    return numericVolume / 1000; // Convert to liters but DO NOT multiply by 1.2
  };

  const calculateTotalWeight = (items) => {
    if (!Array.isArray(items)) return 0; // Ensure valid input

    let totalWeight = items.reduce((total, item) => {
      if (!item || !item.size) return total; // Skip invalid items

      const itemWeight =
        convertVolumeToWeight(item.size) * (item.quantity || 1);
      return total + itemWeight; // Accumulate total weight
    }, 0);

    // **Apply the final weight adjustments**
    if (totalWeight <= 0.5) return 0.5; // If total weight ≤ 500g, set it to 500g (0.5kg)
    if (totalWeight > 0.5 && totalWeight < 1) return 1; // If between 500g and 1kg, set it to 1kg
    return totalWeight + 0.2; // If more than 1kg, add extra 200g (0.2kg)
  };

  const fetchCityFromIndiaPost = async (pincode) => {
    const url = `https://api.postalpincode.in/pincode/${pincode}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data[0].Status === "Success" && data[0].PostOffice) {
        console.log(data[0].PostOffice[0]);
        const cityNames = data[0].PostOffice.map((office) => office.Name);
        setStateAreaMap(cityNames);
        console.log("cities", cityNames);

        setShippingAddress((prev) => ({
          ...prev,
          state: data[0].PostOffice[0].State,
        })); // Extract state
        setShippingAddress((prev) => ({
          ...prev,
          country: data[0].PostOffice[0].Country,
        })); // Extract country
        return data[0].PostOffice[0].District; // Extract district (city)
      }
      return "City not found";
    } catch (error) {
      console.error("India Post API Error:", error);
      return "City not found";
    }
  };

  const fetchCity = async (pincode) => {

    if (pincode.length !== 6) {
      setCity("");
      return;
    }
    const cityName = await fetchCityFromIndiaPost(pincode);
    console.log(cityName);
  };

  const fetchShippingRates = async () => {
    setLoading(true);
    fetchCity(shippingAddress.pinCode);
    try {
      const totalWeight = calculateTotalWeight(cartItems);
      console.log("total weight", totalWeight);
      // Fetch rates from Shiprocket
      const ratesResponse = await axios.post(
        "/api/shipping-rates",
        {
          pickup_postcode: "560043", // Your warehouse pincode
          delivery_postcode: shippingAddress.pinCode,
          weight: totalWeight,
          cod: 0, // Assuming no cash on delivery
        }
      );

      // Sort rates by cost
      // const sortedRates =
      //   ratesResponse.data.data.available_courier_companies.sort(
      //     (a, b) => a.rate - b.rate
      //   );



      const sortedRates = ratesResponse.data.data.available_courier_companies
        .filter(courier => !courier.courier_name.toLowerCase().includes("india post"))
        .sort((a, b) => a.rate - b.rate);

      console.log("sortedRates", sortedRates)
      setShippingRates(sortedRates);
      const courierDetails = sortedRates.map((courier) => ({
        id: courier.courier_company_id,
        name: courier.courier_name,
      }));
      console.log("Courier IDs:", courierDetails);
      // Auto-select the cheapest option
      if (sortedRates.length > 0) {
        setSelectedCourier(sortedRates[0]);
      }
    } catch (error) {
      console.error("Error fetching shipping rates:", error);
      alert("Failed to fetch shipping rates. Please try again.");
    }
    setLoading(false);
  };

  useEffect(() => {
    const storedCartItems = JSON.parse(
      localStorage.getItem("cartItems") || "[]"
    );
    setCartItems(storedCartItems);
    console.log("checkout", storedCartItems);
    const phoneNumber = localStorage.getItem("phoneNumber");
    if (phoneNumber) {
      setShippingAddress((prev) => ({ ...prev, phoneNumber }));
      setBillingAddress((prev) => ({ ...prev, phoneNumber }));
    }
  }, []);

  useEffect(() => {
    if (sameAddress) {
      setBillingAddress(shippingAddress);
    } else {
      setBillingAddress({
        fullName: "",
        phoneNumber: "",
        email: "",
        addressLine1: "",
        addressLine2: "",
        country: "",
        state: "",
        city: "",
        pinCode: "",
      });
    }
  }, [sameAddress, shippingAddress]);
  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    const fetchAddresses = async () => {
      const phoneNumber = localStorage.getItem("phoneNumber"); // Get phone number from localStorage

      if (phoneNumber) {
        try {
          // Pass phone number directly as a URL parameter
          const response = await axios.get(
            `/api/address/${phoneNumber}`
          );

          // Set the fetched address in the state
          setAddresses(response.data); // We assume there's only one address per user
        } catch (error) {
          console.error("Error fetching addresses:", error);
        }
      }
    };

    fetchAddresses();
  }, []); // Fetch addresses when the component mounts

  const handleAddressClick = (address) => {
    // Only copy the fields we want to show in the form
    setShippingAddress({
      fullName: address.fullName || "",
      phoneNumber: address.phoneNumber || "",
      email: address.email || "",
      addressLine1: address.addressLine1 || "",
      addressLine2: address.addressLine2 || "",
      country: address.country || "",
      state: address.state || "",
      city: address.city || "",
      pinCode: address.pinCode || "",
    });
  };
  const handleShippingChange = (e) => {
    const { name, value } = e.target;

    if (name === "pinCode") {
      if (/^\d{0,6}$/.test(value)) setEnteredPinCode(value); // Restrict to 6 digits
    }

    setShippingAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleBillingChange = (e) => {
    const { name, value } = e.target;
    setBillingAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };
  const fetchOrderId = async (amount) => {
    try {
      const response = await fetch("/api/create-order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount: amount * 100 }),
      });
      const data = await response.json();
      return data.order_id;
    } catch (error) {
      console.error("Failed to fetch order ID:", error);
      alert("Failed to create order. Please try again.");
      return null;
    }
  };
  const createOrderObject = (paymentResponse) => {
    const totalWeight = calculateTotalWeight(cartItems);
    const totalAmount = cartItems.reduce(
      (total, item) => total + parseFloat(item.price) * (item.quantity || 1),
      0
    );

    return {
      orderId: paymentResponse.razorpay_order_id,
      orderDate: new Date().toISOString(),
      customerId: localStorage.getItem("phoneNumber"),
      customerDetails: {
        shippingAddress,
        billingAddress: sameAddress ? shippingAddress : billingAddress,
      },
      products: cartItems.map((item) => ({
        productId: item.productId,
        sizeId: item.sizeId,
        productName: item.productName,
        price: parseFloat(item.price),
        quantity: item.quantity || 1,
        size: item.size,
        image: item.image,
        weight: convertVolumeToWeight(item.size) * item.quantity || 1,
      })),
      shipping: {
        courier: selectedCourier?.courier_name,
        weight: totalWeight,
        cost: selectedCourier?.rate || 0,
        estimatedDays: selectedCourier?.estimated_delivery_days || 0,
      },
      paymentDetails: {
        productPrice: totalAmount,
        shippingCost: selectedCourier?.rate || 0,
        totalAmount: totalAmount + (selectedCourier?.rate || 0),
        status: "completed",
        paymentId: paymentResponse.razorpay_payment_id,
        paymentSignature: paymentResponse.razorpay_signature,
       gstNumber: useGSTInvoice ? gstNumber.trim() : "",
      },
      orderStatus: "confirmed",
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
  };
  const calculateDimensions = (weight) => {
    if (weight <= 1) {
      return { length: 10, breadth: 10, height: 10 };
    } else if (weight <= 5) {
      return { length: 20, breadth: 20, height: 15 };
    } else if (weight <= 10) {
      return { length: 30, breadth: 30, height: 20 };
    } else {
      return { length: 40, breadth: 40, height: 30 };
    }
  };
  const handlePaymentSuccess = async (response) => {
    console.log(response);
    try {
      const orderData = createOrderObject(response);

       console.log("Order Payload with GST:", orderData);
      const { length, breadth, height } = calculateDimensions(
        orderData.shipping.weight
      );
      // Save order to your database
      const savedOrder = await axios.post(
        "/api/orders/create",
        orderData
      );
      console.log(savedOrder);
      // Create order in Shiprocket
      const shiprocketOrder = await axios.post(
        "/api/shiprocket/place-order",
        {
          order_id: savedOrder.data.orderId,
          order_date: new Date(orderData.createdAt)
            .toISOString()
            .replace("T", " ")
            .substring(0, 16),
          pickup_location: "Store",
          channel_id: null,
          billing_customer_name: shippingAddress.fullName,
          billing_last_name: shippingAddress.fullName,
          billing_address: shippingAddress.addressLine1,
          billing_address_2: shippingAddress.addressLine2,
          billing_city: shippingAddress.city,
          billing_state: shippingAddress.state,
          billing_country: shippingAddress.country,
          billing_phone: shippingAddress.phoneNumber,
          billing_pincode: shippingAddress.pinCode,
          shipping_is_billing: true,
          shipping_customer_name: "",
          shipping_last_name: "",
          shipping_address: "",
          shipping_address_2: "",
          shipping_city: "",
          shipping_pincode: "",
          shipping_country: "",
          shipping_state: "",
          shipping_email: "",
          shipping_phone: "",
          order_items: orderData.products.map((item) => ({
            ...item,
            sku: item.sku || item.sizeId, // Ensure SKU is set
            name: item.name || item.productName, // Ensure name field exists
            selling_price: item.selling_price || item.price, // Ensure selling price is set
            units: item.units || item.quantity, // Ensure units field exists
          })),
          payment_method: "Prepaid",
          sub_total: orderData.paymentDetails.totalAmount,

          // shipping_address: shippingAddress,

          courier_id: selectedCourier.courier_company_id,
          weight: orderData.shipping.weight,
          length: length,
          breadth: breadth,
          height: height,
        }
      );

      localStorage.removeItem("cartItems");
      
      navigate("/OrderConfirmation", {
        state: {
          orderId: savedOrder.data.orderId,
          totalAmount: orderData.paymentDetails.totalAmount,
          shippingDetails: orderData.shipping,
        },
      });

      alert("Order placed successfully!");
    } catch (error) {
      console.error("Failed to save order:", error);
      alert(
        "Payment successful but failed to save order. Please contact support."
      );
    }
  };
  const handlePayment = async (e) => {
    e.preventDefault();

    const userId = localStorage.getItem("phoneNumber");
    if (!userId) {
      alert("Please login first");
      navigate("/login");
      return;
    }

     // ✅ GST validation
  if (useGSTInvoice) {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!gstRegex.test(gstNumber.trim())) {
      alert("Please enter a valid 15-character GST number (e.g. 29ABCDE1234F2Z5)");
      return;
    }
  }

    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      alert("Failed to load Razorpay SDK. Please check your connection.");
      return;
    }

    // 🧮 Subtotal (with GST already included in price)
    const subtotalWithGST = cartItems.reduce(
      (total, item) => total + parseFloat(item.price) * (item.quantity || 1),
      0
    );

    const gstRate = 0.18;
    const subtotalWithoutGST = subtotalWithGST / (1 + gstRate);
    const gstAmount = subtotalWithGST - subtotalWithoutGST;
    const shipping = selectedCourier?.rate || 0;
    const finalTotal = subtotalWithGST + shipping;
    console.log("GST Rate:", gstRate);
    console.log("Subtotal (With GST):", subtotalWithGST);
    console.log("Subtotal (Excl. GST):", subtotalWithoutGST);
    console.log("GST Amount:", gstAmount);
    console.log("Shipping:", shipping);
    console.log("Final Total:", finalTotal);

    if (isNaN(finalTotal) || finalTotal <= 0) {
      alert("Invalid amount. Please review your order.");
      return;
    }

    try {
      const orderId = await fetchOrderId(Math.round(finalTotal));
      if (!orderId) return;

      const options = {
        key: "rzp_live_D6CyBokqgdaa8c",
        amount: parseFloat((finalTotal * 100).toFixed(0)), // amount in paise
        currency: "INR",
        name: "TerraClenz",
        image: "/assets/img/icon2.png",
        description: `Order Payment - ₹${finalTotal.toFixed(2)}`,
        order_id: orderId,
        handler: function (response) {
          handlePaymentSuccess(response);
        },
        prefill: {
          name: shippingAddress?.fullName || "",
          email: shippingAddress?.email || "",
          contact: shippingAddress?.phoneNumber || "",
        },
        theme: {
          color: "blue",
        },
        notes: {
          subtotalExclGST: `₹${subtotalWithoutGST.toFixed(2)}`,
          gstAmount: `₹${gstAmount.toFixed(2)}`,
          shipping: `₹${shipping.toFixed(2)}`,
          finalAmount: `₹${finalTotal.toFixed(2)}`,
          ...(useGSTInvoice && gstNumber ? { gstNumber } : {}) // only if entered
        }

      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", (response) => {
        console.error(response.error);
        alert("Payment failed. Reason: " + response.error.reason);
      });
    } catch (error) {
      console.error("Payment initiation failed:", error);
      alert("Failed to initiate payment. Please try again.");
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (enteredPinCode.length === 6 && cartItems.length > 0) {
        fetchShippingRates();
      }
    }, 800);
    return () => clearTimeout(delayDebounceFn);
  }, [enteredPinCode, cartItems]);

  // Place this above your return statement
  const subtotal = cartItems.reduce(
    (total, item) => total + parseFloat(item.price * item.quantity),
    0
  );


  const gstRate = 0.18; // Fixed 18% for all states


  const subtotalWithGST = subtotal; // Assuming product prices already include GST
  const subtotalWithoutGST = subtotalWithGST / (1 + gstRate); // Reverse GST
  const gstAmount = subtotalWithGST - subtotalWithoutGST;

  const shipping = selectedCourier?.rate || 0;
  const finalTotal = subtotalWithGST + shipping; // Final total includes GST


  const [useGSTInvoice, setUseGSTInvoice] = useState(false);
  const [gstNumber, setGstNumber] = useState("");



  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2" >
        <div className="container" style={{ marginBottom: '-90px' }}>
          <div className="breadcrumb-title">
            <h2>Checkout</h2>
            <ul className="breadcrumb-menu list-style">
              <li>
                <Link to="/">Home </Link>
              </li>
              <li>Checkout</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="containerorder">
        <div className="checkoutcon">
          <div className="checkoutcontiner">
            <form id="paymentForm" onSubmit={handlePayment}>
              <div>
                <div className=" card checkoutcard mb-4">
                  <div className="card-header">Shipping Address</div>
                  <div className="card-body">
                    <div className="row">
                      {Object.keys(shippingAddress).map((field) => (
                        <div key={field} className="col-md-6 ">
                          {field === "country" ? (
                            // Country Dropdown
                            <select
                              name="country"
                              value={shippingAddress.country || ""}
                              onChange={handleShippingChange}
                              className="form-control"
                              required
                            >
                              <option value="">Select Country</option>
                              <option value="USA">United States</option>
                              <option value="Canada">Canada</option>
                              <option value="India">India</option>
                              <option value="UK">United Kingdom</option>
                            </select>
                          ) : field === "state" ? (
                            // State Dropdown
                            <select
                              name="state"
                              value={shippingAddress.state || ""}
                              onChange={handleShippingChange}
                              className="form-control"
                              required
                            >
                              <option value="">Select State</option>
                              {shippingAddress.country === "USA" && (
                                <>
                                  <option value="California">California</option>
                                  <option value="Texas">Texas</option>
                                  <option value="New York">New York</option>
                                </>
                              )}
                              {shippingAddress.country === "India" && (
                                <>
                                  <option value="Andhra Pradesh">
                                    Andhra Pradesh
                                  </option>
                                  <option value="Arunachal Pradesh">
                                    Arunachal Pradesh
                                  </option>
                                  <option value="Assam">Assam</option>
                                  <option value="Bihar">Bihar</option>
                                  <option value="Chhattisgarh">
                                    Chhattisgarh
                                  </option>
                                  <option value="Goa">Goa</option>
                                  <option value="Gujarat">Gujarat</option>
                                  <option value="Haryana">Haryana</option>
                                  <option value="Himachal Pradesh">
                                    Himachal Pradesh
                                  </option>
                                  <option value="Jharkhand">Jharkhand</option>
                                  <option value="Karnataka">Karnataka</option>
                                  <option value="Kerala">Kerala</option>
                                  <option value="Madhya Pradesh">
                                    Madhya Pradesh
                                  </option>
                                  <option value="Maharashtra">
                                    Maharashtra
                                  </option>
                                  <option value="Manipur">Manipur</option>
                                  <option value="Meghalaya">Meghalaya</option>
                                  <option value="Mizoram">Mizoram</option>
                                  <option value="Nagaland">Nagaland</option>
                                  <option value="Odisha">Odisha</option>
                                  <option value="Punjab">Punjab</option>
                                  <option value="Rajasthan">Rajasthan</option>
                                  <option value="Sikkim">Sikkim</option>
                                  <option value="Tamil Nadu">Tamil Nadu</option>
                                  <option value="Telangana">Telangana</option>
                                  <option value="Tripura">Tripura</option>
                                  <option value="Uttar Pradesh">
                                    Uttar Pradesh
                                  </option>
                                  <option value="Uttarakhand">
                                    Uttarakhand
                                  </option>
                                  <option value="West Bengal">
                                    West Bengal
                                  </option>

                                  {/* Union Territories */}
                                  <option value="Andaman and Nicobar Islands">
                                    Andaman and Nicobar Islands
                                  </option>
                                  <option value="Chandigarh">Chandigarh</option>
                                  <option value="Dadra and Nagar Haveli and Daman and Diu">
                                    Dadra and Nagar Haveli and Daman and Diu
                                  </option>
                                  <option value="Lakshadweep">
                                    Lakshadweep
                                  </option>
                                  <option value="Delhi">Delhi</option>
                                  <option value="Puducherry">Puducherry</option>
                                  <option value="Jammu and Kashmir">
                                    Jammu and Kashmir
                                  </option>
                                  <option value="Ladakh">Ladakh</option>
                                </>
                              )}
                            </select>
                          ) : field === "city" ? (
                            <>
                              <select
                                name="city"
                                value={shippingAddress.city || ""}
                                onChange={handleShippingChange}
                                className="form-control"
                                required
                              >
                                <option value="">Select City</option>
                                {cities && cities.length > 0 ? (
                                  cities.map((city) => (
                                    <option key={city} value={city}>
                                      {city}
                                    </option>
                                  ))
                                ) : (
                                  <>
                                    {shippingAddress.state === "Karnataka" && (
                                      <>
                                        <option value="Afzalpur">
                                          Afzalpur
                                        </option>
                                        <option value="Ajjampur">
                                          Ajjampur
                                        </option>
                                        <option value="Aland">Aland</option>
                                        <option value="Alnavar">Alnavar</option>
                                        <option value="Alur">Alur</option>
                                        <option value="Anekal">Anekal</option>
                                        <option value="Ankola">Ankola</option>
                                        <option value="Annigeri">
                                          Annigeri
                                        </option>
                                        <option value="Arkalgud">
                                          Arkalgud
                                        </option>
                                        <option value="Arsikere">
                                          Arsikere
                                        </option>
                                        <option value="Athni">Athni</option>
                                        <option value="Aurad">Aurad</option>
                                        <option value="Badami">Badami</option>
                                        <option value="Bagalkot">
                                          Bagalkot
                                        </option>
                                        <option value="Bagepalli">
                                          Bagepalli
                                        </option>
                                        <option value="Bail-Hongal">
                                          Bail-Hongal
                                        </option>
                                        <option value="Ballari">Ballari</option>
                                        <option value="Banavar">Banavar</option>
                                        <option value="Bangalore Rural">
                                          Bangalore Rural
                                        </option>
                                        <option value="Bangalore Urban">
                                          Bangalore Urban
                                        </option>
                                        <option value="Bangarapet">
                                          Bangarapet
                                        </option>
                                        <option value="Bannur">Bannur</option>
                                        <option value="Bantval">Bantval</option>
                                        <option value="Basavakalyan">
                                          Basavakalyan
                                        </option>
                                        <option value="Basavana Bagevadi">
                                          Basavana Bagevadi
                                        </option>
                                        <option value="Belgaum">Belgaum</option>
                                        <option value="Bellary">Bellary</option>
                                        <option value="Belluru">Belluru</option>
                                        <option value="Beltangadi">
                                          Beltangadi
                                        </option>
                                        <option value="Belur">Belur</option>
                                        <option value="Bengaluru">
                                          Bengaluru
                                        </option>
                                        <option value="Bhadravati">
                                          Bhadravati
                                        </option>
                                        <option value="Bhalki">Bhalki</option>
                                        <option value="Bhatkal">Bhatkal</option>
                                        <option value="Bidar">Bidar</option>
                                        <option value="Bijapur">Bijapur</option>
                                        <option value="Bilgi">Bilgi</option>
                                        <option value="Birur">Birur</option>
                                        <option value="Byadgi">Byadgi</option>
                                        <option value="Byndoor">Byndoor</option>
                                        <option value="Canacona">
                                          Canacona
                                        </option>
                                        <option value="Challakere">
                                          Challakere
                                        </option>
                                        <option value="Chamrajnagar">
                                          Chamrajnagar
                                        </option>
                                        <option value="Channagiri">
                                          Channagiri
                                        </option>
                                        <option value="Channapatna">
                                          Channapatna
                                        </option>
                                        <option value="Channarayapatna">
                                          Channarayapatna
                                        </option>
                                        <option value="Chik Ballapur">
                                          Chik Ballapur
                                        </option>
                                        <option value="Chikkaballapur">
                                          Chikkaballapur
                                        </option>
                                        <option value="Chikmagalur">
                                          Chikmagalur
                                        </option>
                                        <option value="Chiknayakanhalli">
                                          Chiknayakanhalli
                                        </option>
                                        <option value="Chikodi">Chikodi</option>
                                        <option value="Chincholi">
                                          Chincholi
                                        </option>
                                        <option value="Chintamani">
                                          Chintamani
                                        </option>
                                        <option value="Chitapur">
                                          Chitapur
                                        </option>
                                        <option value="Chitradurga">
                                          Chitradurga
                                        </option>
                                        <option value="Closepet">
                                          Closepet
                                        </option>
                                        <option value="Coondapoor">
                                          Coondapoor
                                        </option>
                                        <option value="Dakshina Kannada">
                                          Dakshina Kannada
                                        </option>
                                        <option value="Dandeli">Dandeli</option>
                                        <option value="Davanagere">
                                          Davanagere
                                        </option>
                                        <option value="Devanhalli">
                                          Devanhalli
                                        </option>
                                        <option value="Dharwad">Dharwad</option>
                                        <option value="Dod Ballapur">
                                          Dod Ballapur
                                        </option>
                                        <option value="French Rocks">
                                          French Rocks
                                        </option>
                                        <option value="Gadag">Gadag</option>
                                        <option value="Gadag-Betageri">
                                          Gadag-Betageri
                                        </option>
                                        <option value="Gajendragarh">
                                          Gajendragarh
                                        </option>
                                        <option value="Gangawati">
                                          Gangawati
                                        </option>
                                        <option value="Gangolli">
                                          Gangolli
                                        </option>
                                        <option value="Gokak">Gokak</option>
                                        <option value="Gokarna">Gokarna</option>
                                        <option value="Goribidnur">
                                          Goribidnur
                                        </option>
                                        <option value="Gorur">Gorur</option>
                                        <option value="Gubbi">Gubbi</option>
                                        <option value="Gudibanda">
                                          Gudibanda
                                        </option>
                                        <option value="Gulbarga">
                                          Gulbarga
                                        </option>
                                        <option value="Guledagudda">
                                          Guledagudda
                                        </option>
                                        <option value="Gundlupēt">
                                          Gundlupēt
                                        </option>
                                        <option value="Gurmatkal">
                                          Gurmatkal
                                        </option>
                                        <option value="Hadagalli">
                                          Hadagalli
                                        </option>
                                        <option value="Haliyal">Haliyal</option>
                                        <option value="Hampi">Hampi</option>
                                        <option value="Hangal">Hangal</option>
                                        <option value="Harihar">Harihar</option>
                                        <option value="Harpanahalli">
                                          Harpanahalli
                                        </option>
                                        <option value="Hassan">Hassan</option>
                                        <option value="Haveri">Haveri</option>
                                        <option value="Heggadadevankote">
                                          Heggadadevankote
                                        </option>
                                        <option value="Hirekerur">
                                          Hirekerur
                                        </option>
                                        <option value="Hiriyur">Hiriyur</option>
                                        <option value="Holalkere">
                                          Holalkere
                                        </option>
                                        <option value="Hole Narsipur">
                                          Hole Narsipur
                                        </option>
                                        <option value="Homnabad">
                                          Homnabad
                                        </option>
                                        <option value="Honavar">Honavar</option>
                                        <option value="Honnali">Honnali</option>
                                        <option value="Hosanagara">
                                          Hosanagara
                                        </option>
                                        <option value="Hosangadi">
                                          Hosangadi
                                        </option>
                                        <option value="Hosdurga">
                                          Hosdurga
                                        </option>
                                        <option value="Hoskote">Hoskote</option>
                                        <option value="Hospet">Hospet</option>
                                        <option value="Hubli">Hubli</option>
                                        <option value="Hukeri">Hukeri</option>
                                        <option value="Hungund">Hungund</option>
                                        <option value="Hunsur">Hunsur</option>
                                        <option value="Ilkal">Ilkal</option>
                                        <option value="Indi">Indi</option>
                                        <option value="Jagalur">Jagalur</option>
                                        <option value="Jamkhandi">
                                          Jamkhandi
                                        </option>
                                        <option value="Jevargi">Jevargi</option>
                                        <option value="Kadur">Kadur</option>
                                        <option value="Kalghatgi">
                                          Kalghatgi
                                        </option>
                                        <option value="Kampli">Kampli</option>
                                        <option value="Kankanhalli">
                                          Kankanhalli
                                        </option>
                                        <option value="Karkala">Karkala</option>
                                        <option value="Karwar">Karwar</option>
                                        <option value="Kavalur">Kavalur</option>
                                        <option value="Kerur">Kerur</option>
                                        <option value="Khanapur">
                                          Khanapur
                                        </option>
                                        <option value="Kodagu">Kodagu</option>
                                        <option value="Kodigenahalli">
                                          Kodigenahalli
                                        </option>
                                        <option value="Kodlipet">
                                          Kodlipet
                                        </option>
                                        <option value="Kolar">Kolar</option>
                                        <option value="Kollegal">
                                          Kollegal
                                        </option>
                                        <option value="Konanur">Konanur</option>
                                        <option value="Konnur">Konnur</option>
                                        <option value="Koppa">Koppa</option>
                                        <option value="Koppal">Koppal</option>
                                        <option value="Koratagere">
                                          Koratagere
                                        </option>
                                        <option value="Kotturu">Kotturu</option>
                                        <option value="Krishnarajpet">
                                          Krishnarajpet
                                        </option>
                                        <option value="Kudachi">Kudachi</option>
                                        <option value="Kudligi">Kudligi</option>
                                        <option value="Kumsi">Kumsi</option>
                                        <option value="Kumta">Kumta</option>
                                        <option value="Kundgol">Kundgol</option>
                                        <option value="Kunigal">Kunigal</option>
                                        <option value="Kurgunta">
                                          Kurgunta
                                        </option>
                                        <option value="Kushalnagar">
                                          Kushalnagar
                                        </option>
                                        <option value="Kushtagi">
                                          Kushtagi
                                        </option>
                                        <option value="Lakshmeshwar">
                                          Lakshmeshwar
                                        </option>
                                        <option value="Lingsugur">
                                          Lingsugur
                                        </option>
                                        <option value="Londa">Londa</option>
                                        <option value="Madhugiri">
                                          Madhugiri
                                        </option>
                                        <option value="Maddur">Maddur</option>
                                        <option value="Madikeri">
                                          Madikeri
                                        </option>
                                        <option value="Magadi">Magadi</option>
                                        <option value="Mahalingpur">
                                          Mahalingpur
                                        </option>
                                        <option value="Malavalli">
                                          Malavalli
                                        </option>
                                        <option value="Malpe">Malpe</option>
                                        <option value="Malur">Malur</option>
                                        <option value="Mandya">Mandya</option>
                                        <option value="Mangalore">
                                          Mangalore
                                        </option>
                                        <option value="Manipal">Manipal</option>
                                        <option value="Manvi">Manvi</option>
                                        <option value="Mayakonda">
                                          Mayakonda
                                        </option>
                                        <option value="Melukote">
                                          Melukote
                                        </option>
                                        <option value="Mudbidri">
                                          Mudbidri
                                        </option>
                                        <option value="Muddebihal">
                                          Muddebihal
                                        </option>
                                        <option value="Mudgal">Mudgal</option>
                                        <option value="Mudgere">Mudgere</option>
                                        <option value="Mudhol">Mudhol</option>
                                        <option value="Mulbagal">
                                          Mulbagal
                                        </option>
                                        <option value="Mulgund">Mulgund</option>
                                        <option value="Mulki">Mulki</option>
                                        <option value="Mundargi">
                                          Mundargi
                                        </option>
                                        <option value="Mundgod">Mundgod</option>
                                        <option value="Munirabad">
                                          Munirabad
                                        </option>
                                        <option value="Murudeshwara">
                                          Murudeshwara
                                        </option>
                                        <option value="Mysore">Mysore</option>
                                        <option value="Nagamangala">
                                          Nagamangala
                                        </option>
                                        <option value="Nanjangud">
                                          Nanjangud
                                        </option>
                                        <option value="Narasimharajapura">
                                          Narasimharajapura
                                        </option>
                                        <option value="Naregal">Naregal</option>
                                        <option value="Nargund">Nargund</option>
                                        <option value="Navalgund">
                                          Navalgund
                                        </option>
                                        <option value="Nelamangala">
                                          Nelamangala
                                        </option>
                                        <option value="Nyamti">Nyamti</option>
                                        <option value="Pangala">Pangala</option>
                                        <option value="Pavugada">
                                          Pavugada
                                        </option>
                                        <option value="Piriyapatna">
                                          Piriyapatna
                                        </option>
                                        <option value="Ponnampet">
                                          Ponnampet
                                        </option>
                                        <option value="Puttur">Puttur</option>
                                        <option value="Rabkavi">Rabkavi</option>
                                        <option value="Raichur">Raichur</option>
                                        <option value="Ramanagara">
                                          Ramanagara
                                        </option>
                                        <option value="Ranibennur">
                                          Ranibennur
                                        </option>
                                        <option value="Raybag">Raybag</option>
                                        <option value="Robertsonpet">
                                          Robertsonpet
                                        </option>
                                        <option value="Ron">Ron</option>
                                        <option value="Sadalgi">Sadalgi</option>
                                        <option value="Sagar">Sagar</option>
                                        <option value="Sakleshpur">
                                          Sakleshpur
                                        </option>
                                        <option value="Sandur">Sandur</option>
                                        <option value="Sanivarsante">
                                          Sanivarsante
                                        </option>
                                        <option value="Sankeshwar">
                                          Sankeshwar
                                        </option>
                                        <option value="Sargur">Sargur</option>
                                        <option value="Saundatti">
                                          Saundatti
                                        </option>
                                        <option value="Savanur">Savanur</option>
                                        <option value="Seram">Seram</option>
                                        <option value="Shahabad">
                                          Shahabad
                                        </option>
                                        <option value="Shahpur">Shahpur</option>
                                        <option value="Shiggaon">
                                          Shiggaon
                                        </option>
                                        <option value="Shikarpur">
                                          Shikarpur
                                        </option>
                                        <option value="Shimoga">Shimoga</option>
                                        <option value="Shirhatti">
                                          Shirhatti
                                        </option>
                                        <option value="Shorapur">
                                          Shorapur
                                        </option>
                                        <option value="Shrirangapattana">
                                          Shrirangapattana
                                        </option>
                                        <option value="Siddapur">
                                          Siddapur
                                        </option>
                                        <option value="Sidlaghatta">
                                          Sidlaghatta
                                        </option>
                                        <option value="Sindgi">Sindgi</option>
                                        <option value="Sindhnur">
                                          Sindhnur
                                        </option>
                                        <option value="Sira">Sira</option>
                                        <option value="Sirsi">Sirsi</option>
                                        <option value="Siruguppa">
                                          Siruguppa
                                        </option>
                                        <option value="Someshwar">
                                          Someshwar
                                        </option>
                                        <option value="Somvarpet">
                                          Somvarpet
                                        </option>
                                        <option value="Sorab">Sorab</option>
                                        <option value="Sravana Belgola">
                                          Sravana Belgola
                                        </option>
                                        <option value="Sringeri">
                                          Sringeri
                                        </option>
                                        <option value="Srinivaspur">
                                          Srinivaspur
                                        </option>
                                        <option value="Sulya">Sulya</option>
                                        <option value="Suntikoppa">
                                          Suntikoppa
                                        </option>
                                        <option value="Talikota">
                                          Talikota
                                        </option>
                                        <option value="Tarikere">
                                          Tarikere
                                        </option>
                                        <option value="Tekkalakote">
                                          Tekkalakote
                                        </option>
                                        <option value="Terdal">Terdal</option>
                                        <option value="Tiptur">Tiptur</option>
                                        <option value="Tirthahalli">
                                          Tirthahalli
                                        </option>
                                        <option value="Tirumakudal Narsipur">
                                          Tirumakudal Narsipur
                                        </option>
                                        <option value="Tumkur">Tumkur</option>
                                        <option value="Turuvekere">
                                          Turuvekere
                                        </option>
                                        <option value="Udupi">Udupi</option>
                                        <option value="Ullal">Ullal</option>
                                        <option value="Uttar Kannada">
                                          Uttar Kannada
                                        </option>
                                        <option value="Vadigenhalli">
                                          Vadigenhalli
                                        </option>
                                        <option value="Virarajendrapet">
                                          Virarajendrapet
                                        </option>
                                        <option value="Wadi">Wadi</option>
                                        <option value="Yadgir">Yadgir</option>
                                        <option value="Yelahanka">
                                          Yelahanka
                                        </option>
                                        <option value="Yelandur">
                                          Yelandur
                                        </option>
                                        <option value="Yelbarga">
                                          Yelbarga
                                        </option>
                                        <option value="Yellapur">
                                          Yellapur
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state ===
                                      "Andaman and Nicobar Islands" && (
                                        <>
                                          <option value="Bamboo Flat">
                                            Bamboo Flat
                                          </option>
                                          <option value="Nicobar">Nicobar</option>
                                          <option value="Port Blair">
                                            Port Blair
                                          </option>
                                          <option value="South Andaman">
                                            South Andaman
                                          </option>
                                        </>
                                      )}
                                    {shippingAddress.state ===
                                      "Andhra Pradesh" && (
                                        <>
                                          <option value="Addanki">Addanki</option>
                                          <option value="Adoni">Adoni</option>
                                          <option value="Akasahebpet">
                                            Akasahebpet
                                          </option>
                                          <option value="Akividu">Akividu</option>
                                          <option value="Akkarampalle">
                                            Akkarampalle
                                          </option>
                                          <option value="Amalapuram">
                                            Amalapuram
                                          </option>
                                          <option value="Amudalavalasa">
                                            Amudalavalasa
                                          </option>
                                          <option value="Anakapalle">
                                            Anakapalle
                                          </option>
                                          <option value="Anantapur">
                                            Anantapur
                                          </option>
                                          <option value="Atmakur">Atmakur</option>
                                          <option value="Attili">Attili</option>
                                          <option value="Avanigadda">
                                            Avanigadda
                                          </option>
                                          <option value="Badvel">Badvel</option>
                                          <option value="Banganapalle">
                                            Banganapalle
                                          </option>
                                          <option value="Bapatla">Bapatla</option>
                                          <option value="Betamcherla">
                                            Betamcherla
                                          </option>
                                          <option value="Bhattiprolu">
                                            Bhattiprolu
                                          </option>
                                          <option value="Bhimavaram">
                                            Bhimavaram
                                          </option>
                                          <option value="Bhimunipatnam">
                                            Bhimunipatnam
                                          </option>
                                          <option value="Bobbili">Bobbili</option>
                                          <option value="Challapalle">
                                            Challapalle
                                          </option>
                                          <option value="Chemmumiahpet">
                                            Chemmumiahpet
                                          </option>
                                          <option value="Chilakalurupet">
                                            Chilakalurupet
                                          </option>
                                          <option value="Chinnachowk">
                                            Chinnachowk
                                          </option>
                                          <option value="Chipurupalle">
                                            Chipurupalle
                                          </option>
                                          <option value="Chirala">Chirala</option>
                                          <option value="Chittoor">
                                            Chittoor
                                          </option>
                                          <option value="Chodavaram">
                                            Chodavaram
                                          </option>
                                          <option value="Cuddapah">
                                            Cuddapah
                                          </option>
                                          <option value="Cumbum">Cumbum</option>
                                          <option value="Darsi">Darsi</option>
                                          <option value="Dharmavaram">
                                            Dharmavaram
                                          </option>
                                          <option value="Dhone">Dhone</option>
                                          <option value="Diguvametta">
                                            Diguvametta
                                          </option>
                                          <option value="East Godavari">
                                            East Godavari
                                          </option>
                                          <option value="Elamanchili">
                                            Elamanchili
                                          </option>
                                          <option value="Ellore">Ellore</option>
                                          <option value="Emmiganur">
                                            Emmiganur
                                          </option>
                                          <option value="Erraguntla">
                                            Erraguntla
                                          </option>
                                          <option value="Etikoppaka">
                                            Etikoppaka
                                          </option>
                                          <option value="Gajuwaka">
                                            Gajuwaka
                                          </option>
                                          <option value="Ganguvada">
                                            Ganguvada
                                          </option>
                                          <option value="Gannavaram">
                                            Gannavaram
                                          </option>
                                          <option value="Giddalur">
                                            Giddalur
                                          </option>
                                          <option value="Gokavaram">
                                            Gokavaram
                                          </option>
                                          <option value="Gorantla">
                                            Gorantla
                                          </option>
                                          <option value="Govindapuram,Chilakaluripet,Guntur">
                                            Govindapuram,Chilakaluripet,Guntur
                                          </option>
                                          <option value="Gudivada">
                                            Gudivada
                                          </option>
                                          <option value="Gudlavalleru">
                                            Gudlavalleru
                                          </option>
                                          <option value="Gudur">Gudur</option>
                                          <option value="Guntakal Junction">
                                            Guntakal Junction
                                          </option>
                                          <option value="Guntur">Guntur</option>
                                          <option value="Hindupur">
                                            Hindupur
                                          </option>
                                          <option value="Ichchapuram">
                                            Ichchapuram
                                          </option>
                                          <option value="Jaggayyapeta">
                                            Jaggayyapeta
                                          </option>
                                          <option value="Jammalamadugu">
                                            Jammalamadugu
                                          </option>
                                          <option value="Kadiri">Kadiri</option>
                                          <option value="Kaikalur">
                                            Kaikalur
                                          </option>
                                          <option value="Kakinada">
                                            Kakinada
                                          </option>
                                          <option value="Kalyandurg">
                                            Kalyandurg
                                          </option>
                                          <option value="Kamalapuram">
                                            Kamalapuram
                                          </option>
                                          <option value="Kandukur">
                                            Kandukur
                                          </option>
                                          <option value="Kanigiri">
                                            Kanigiri
                                          </option>
                                          <option value="Kankipadu">
                                            Kankipadu
                                          </option>
                                          <option value="Kanuru">Kanuru</option>
                                          <option value="Kavali">Kavali</option>
                                          <option value="Kolanukonda">
                                            Kolanukonda
                                          </option>
                                          <option value="Kondapalle">
                                            Kondapalle
                                          </option>
                                          <option value="Korukollu">
                                            Korukollu
                                          </option>
                                          <option value="Kosigi">Kosigi</option>
                                          <option value="Kovvur">Kovvur</option>
                                          <option value="Krishna">Krishna</option>
                                          <option value="Kuppam">Kuppam</option>
                                          <option value="Kurnool">Kurnool</option>
                                          <option value="Macherla">
                                            Macherla
                                          </option>
                                          <option value="Machilipatnam">
                                            Machilipatnam
                                          </option>
                                          <option value="Madanapalle">
                                            Madanapalle
                                          </option>
                                          <option value="Madugula">
                                            Madugula
                                          </option>
                                          <option value="Mandapeta">
                                            Mandapeta
                                          </option>
                                          <option value="Mandasa">Mandasa</option>
                                          <option value="Mangalagiri">
                                            Mangalagiri
                                          </option>
                                          <option value="Markapur">
                                            Markapur
                                          </option>
                                          <option value="Nagari">Nagari</option>
                                          <option value="Nagireddipalli">
                                            Nagireddipalli
                                          </option>
                                          <option value="Nandigama">
                                            Nandigama
                                          </option>
                                          <option value="Nandikotkur">
                                            Nandikotkur
                                          </option>
                                          <option value="Nandyal">Nandyal</option>
                                          <option value="Narasannapeta">
                                            Narasannapeta
                                          </option>
                                          <option value="Narasapur">
                                            Narasapur
                                          </option>
                                          <option value="Narasaraopet">
                                            Narasaraopet
                                          </option>
                                          <option value="Narasingapuram">
                                            Narasingapuram
                                          </option>
                                          <option value="Narayanavanam">
                                            Narayanavanam
                                          </option>
                                          <option value="Narsipatnam">
                                            Narsipatnam
                                          </option>
                                          <option value="Nayudupet">
                                            Nayudupet
                                          </option>
                                          <option value="Nellore">Nellore</option>
                                          <option value="Nidadavole">
                                            Nidadavole
                                          </option>
                                          <option value="Nuzvid">Nuzvid</option>
                                          <option value="Ongole">Ongole</option>
                                          <option value="Pakala">Pakala</option>
                                          <option value="Palakollu">
                                            Palakollu
                                          </option>
                                          <option value="Palasa">Palasa</option>
                                          <option value="Palkonda">
                                            Palkonda
                                          </option>
                                          <option value="Pallevada">
                                            Pallevada
                                          </option>
                                          <option value="Palmaner">
                                            Palmaner
                                          </option>
                                          <option value="Parlakimidi">
                                            Parlakimidi
                                          </option>
                                          <option value="Parvatipuram">
                                            Parvatipuram
                                          </option>
                                          <option value="Pavuluru">
                                            Pavuluru
                                          </option>
                                          <option value="Pedana">Pedana</option>
                                          <option value="pedda nakkalapalem">
                                            pedda nakkalapalem
                                          </option>
                                          <option value="Peddapuram">
                                            Peddapuram
                                          </option>
                                          <option value="Penugonda">
                                            Penugonda
                                          </option>
                                          <option value="Penukonda">
                                            Penukonda
                                          </option>
                                          <option value="Phirangipuram">
                                            Phirangipuram
                                          </option>
                                          <option value="Pippara">Pippara</option>
                                          <option value="Pithapuram">
                                            Pithapuram
                                          </option>
                                          <option value="Polavaram">
                                            Polavaram
                                          </option>
                                          <option value="Ponnur">Ponnur</option>
                                          <option value="Ponnuru">Ponnuru</option>
                                          <option value="Prakasam">
                                            Prakasam
                                          </option>
                                          <option value="Proddatur">
                                            Proddatur
                                          </option>
                                          <option value="Pulivendla">
                                            Pulivendla
                                          </option>
                                          <option value="Punganuru">
                                            Punganuru
                                          </option>
                                          <option value="Puttaparthi">
                                            Puttaparthi
                                          </option>
                                          <option value="Puttur">Puttur</option>
                                          <option value="Rajahmundry">
                                            Rajahmundry
                                          </option>
                                          <option value="Ramachandrapuram">
                                            Ramachandrapuram
                                          </option>
                                          <option value="Ramanayyapeta">
                                            Ramanayyapeta
                                          </option>
                                          <option value="Ramapuram">
                                            Ramapuram
                                          </option>
                                          <option value="Rampachodavaram">
                                            Rampachodavaram
                                          </option>
                                          <option value="Rayachoti">
                                            Rayachoti
                                          </option>
                                          <option value="Rayadrug">
                                            Rayadrug
                                          </option>
                                          <option value="Razam">Razam</option>
                                          <option value="Razampeta">
                                            Razampeta
                                          </option>
                                          <option value="Razole">Razole</option>
                                          <option value="Renigunta">
                                            Renigunta
                                          </option>
                                          <option value="Repalle">Repalle</option>
                                          <option value="Salur">Salur</option>
                                          <option value="Samalkot">
                                            Samalkot
                                          </option>
                                          <option value="Sattenapalle">
                                            Sattenapalle
                                          </option>
                                          <option value="Singarayakonda">
                                            Singarayakonda
                                          </option>
                                          <option value="Sompeta">Sompeta</option>
                                          <option value="Srikakulam">
                                            Srikakulam
                                          </option>
                                          <option value="Srisailain">
                                            Srisailain
                                          </option>
                                          <option value="Suluru">Suluru</option>
                                          <option value="Tadepalle">
                                            Tadepalle
                                          </option>
                                          <option value="Tadepallegudem">
                                            Tadepallegudem
                                          </option>
                                          <option value="Tadpatri">
                                            Tadpatri
                                          </option>
                                          <option value="Tanuku">Tanuku</option>
                                          <option value="Tekkali">Tekkali</option>
                                          <option value="Tirumala">
                                            Tirumala
                                          </option>
                                          <option value="Tirupati">
                                            Tirupati
                                          </option>
                                          <option value="Tuni">Tuni</option>
                                          <option value="Uravakonda">
                                            Uravakonda
                                          </option>
                                          <option value="vadlamuru">
                                            vadlamuru
                                          </option>
                                          <option value="Vadlapudi">
                                            Vadlapudi
                                          </option>
                                          <option value="Venkatagiri">
                                            Venkatagiri
                                          </option>
                                          <option value="Vepagunta">
                                            Vepagunta
                                          </option>
                                          <option value="Vetapalem">
                                            Vetapalem
                                          </option>
                                          <option value="Vijayawada">
                                            Vijayawada
                                          </option>
                                          <option value="Vinukonda">
                                            Vinukonda
                                          </option>
                                          <option value="Visakhapatnam">
                                            Visakhapatnam
                                          </option>
                                          <option value="Vizianagaram">
                                            Vizianagaram
                                          </option>
                                          <option value="Vizianagaram District">
                                            Vizianagaram District
                                          </option>
                                          <option value="Vuyyuru">Vuyyuru</option>
                                          <option value="West Godavari">
                                            West Godavari
                                          </option>
                                          <option value="Yanam">Yanam</option>
                                          <option value="Yanamalakuduru">
                                            Yanamalakuduru
                                          </option>
                                          <option value="Yarada">Yarada</option>
                                        </>
                                      )}
                                    {shippingAddress.state ===
                                      "Arunachal Pradesh" && (
                                        <>
                                          <option value="Along">Along</option>
                                          <option value="Anjaw">Anjaw</option>
                                          <option value="Basar">Basar</option>
                                          <option value="Bomdila">Bomdila</option>
                                          <option value="Changlang">
                                            Changlang
                                          </option>
                                          <option value="Dibang Valley">
                                            Dibang Valley
                                          </option>
                                          <option value="East Kameng">
                                            East Kameng
                                          </option>
                                          <option value="East Siang">
                                            East Siang
                                          </option>
                                          <option value="Hayuliang">
                                            Hayuliang
                                          </option>
                                          <option value="Itanagar">
                                            Itanagar
                                          </option>
                                          <option value="Khonsa">Khonsa</option>
                                          <option value="Kurung Kumey">
                                            Kurung Kumey
                                          </option>
                                          <option value="Lohit District">
                                            Lohit District
                                          </option>
                                          <option value="Lower Dibang Valley">
                                            Lower Dibang Valley
                                          </option>
                                          <option value="Lower Subansiri">
                                            Lower Subansiri
                                          </option>
                                          <option value="Margherita">
                                            Margherita
                                          </option>
                                          <option value="Naharlagun">
                                            Naharlagun
                                          </option>
                                          <option value="Pasighat">
                                            Pasighat
                                          </option>
                                          <option value="Tawang">Tawang</option>
                                          <option value="Tezu">Tezu</option>
                                          <option value="Tirap">Tirap</option>
                                          <option value="Upper Siang">
                                            Upper Siang
                                          </option>
                                          <option value="Upper Subansiri">
                                            Upper Subansiri
                                          </option>
                                          <option value="West Kameng">
                                            West Kameng
                                          </option>
                                          <option value="West Siang">
                                            West Siang
                                          </option>
                                          <option value="Ziro">Ziro</option>
                                        </>
                                      )}
                                    {shippingAddress.state === "Assam" && (
                                      <>
                                        {" "}
                                        <option value="Abhayapuri">
                                          Abhayapuri
                                        </option>
                                        <option value="Amguri">Amguri</option>
                                        <option value="Badarpur">
                                          Badarpur
                                        </option>
                                        <option value="Baksa">Baksa</option>
                                        <option value="Barpathar">
                                          Barpathar
                                        </option>
                                        <option value="Barpeta">Barpeta</option>
                                        <option value="Barpeta Road">
                                          Barpeta Road
                                        </option>
                                        <option value="Basugaon">
                                          Basugaon
                                        </option>
                                        <option value="Bihpuriagaon">
                                          Bihpuriagaon
                                        </option>
                                        <option value="Bijni">Bijni</option>
                                        <option value="Bilasipara">
                                          Bilasipara
                                        </option>
                                        <option value="Bokajan">Bokajan</option>
                                        <option value="Bokakhat">
                                          Bokakhat
                                        </option>
                                        <option value="Bongaigaon">
                                          Bongaigaon
                                        </option>
                                        <option value="Cachar">Cachar</option>
                                        <option value="Chabua">Chabua</option>
                                        <option value="Chapar">Chapar</option>
                                        <option value="Chirang">Chirang</option>
                                        <option value="Darrang">Darrang</option>
                                        <option value="Dergaon">Dergaon</option>
                                        <option value="Dhekiajuli">
                                          Dhekiajuli
                                        </option>
                                        <option value="Dhemaji">Dhemaji</option>
                                        <option value="Dhing">Dhing</option>
                                        <option value="Dhubri">Dhubri</option>
                                        <option value="Dibrugarh">
                                          Dibrugarh
                                        </option>
                                        <option value="Digboi">Digboi</option>
                                        <option value="Dima Hasao District">
                                          Dima Hasao District
                                        </option>
                                        <option value="Diphu">Diphu</option>
                                        <option value="Dispur">Dispur</option>
                                        <option value="Duliagaon">
                                          Duliagaon
                                        </option>
                                        <option value="Dum Duma">
                                          Dum Duma
                                        </option>
                                        <option value="Gauripur">
                                          Gauripur
                                        </option>
                                        <option value="Goalpara">
                                          Goalpara
                                        </option>
                                        <option value="Gohpur">Gohpur</option>
                                        <option value="Golaghat">
                                          Golaghat
                                        </option>
                                        <option value="Golakganj">
                                          Golakganj
                                        </option>
                                        <option value="Goshaingaon">
                                          Goshaingaon
                                        </option>
                                        <option value="Guwahati">
                                          Guwahati
                                        </option>
                                        <option value="Haflong">Haflong</option>
                                        <option value="Hailakandi">
                                          Hailakandi
                                        </option>
                                        <option value="Hajo">Hajo</option>
                                        <option value="Hojai">Hojai</option>
                                        <option value="Howli">Howli</option>
                                        <option value="Jogighopa">
                                          Jogighopa
                                        </option>
                                        <option value="Jorhat">Jorhat</option>
                                        <option value="Kamrup">Kamrup</option>
                                        <option value="Kamrup Metropolitan">
                                          Kamrup Metropolitan
                                        </option>
                                        <option value="Karbi Anglong">
                                          Karbi Anglong
                                        </option>
                                        <option value="Karimganj">
                                          Karimganj
                                        </option>
                                        <option value="Kharupatia">
                                          Kharupatia
                                        </option>
                                        <option value="Kokrajhar">
                                          Kokrajhar
                                        </option>
                                        <option value="Lakhimpur">
                                          Lakhimpur
                                        </option>
                                        <option value="Lakhipur">
                                          Lakhipur
                                        </option>
                                        <option value="Lala">Lala</option>
                                        <option value="Lumding Railway Colony">
                                          Lumding Railway Colony
                                        </option>
                                        <option value="Mahur">Mahur</option>
                                        <option value="Maibong">Maibong</option>
                                        <option value="Makum">Makum</option>
                                        <option value="Mangaldai">
                                          Mangaldai
                                        </option>
                                        <option value="Mariani">Mariani</option>
                                        <option value="Moranha">Moranha</option>
                                        <option value="Morigaon">
                                          Morigaon
                                        </option>
                                        <option value="Nagaon">Nagaon</option>
                                        <option value="Nahorkatiya">
                                          Nahorkatiya
                                        </option>
                                        <option value="Nalbari">Nalbari</option>
                                        <option value="Namrup">Namrup</option>
                                        <option value="Nazira">Nazira</option>
                                        <option value="North Guwahati">
                                          North Guwahati
                                        </option>
                                        <option value="North Lakhimpur">
                                          North Lakhimpur
                                        </option>
                                        <option value="Numaligarh">
                                          Numaligarh
                                        </option>
                                        <option value="Palasbari">
                                          Palasbari
                                        </option>
                                        <option value="Raha">Raha</option>
                                        <option value="Rangapara">
                                          Rangapara
                                        </option>
                                        <option value="Rangia">Rangia</option>
                                        <option value="Sapatgram">
                                          Sapatgram
                                        </option>
                                        <option value="Sarupathar">
                                          Sarupathar
                                        </option>
                                        <option value="Sibsagar">
                                          Sibsagar
                                        </option>
                                        <option value="Silapathar">
                                          Silapathar
                                        </option>
                                        <option value="Silchar">Silchar</option>
                                        <option value="Soalkuchi">
                                          Soalkuchi
                                        </option>
                                        <option value="Sonari">Sonari</option>
                                        <option value="Sonitpur">
                                          Sonitpur
                                        </option>
                                        <option value="Sorbhog">Sorbhog</option>
                                        <option value="Tezpur">Tezpur</option>
                                        <option value="Tinsukia">
                                          Tinsukia
                                        </option>
                                        <option value="Titabar">Titabar</option>
                                        <option value="Udalguri">
                                          Udalguri
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Bihar" && (
                                      <>
                                        {" "}
                                        <option value="Amarpur">Amarpur</option>
                                        <option value="Araria">Araria</option>
                                        <option value="Arrah">Arrah</option>
                                        <option value="Arwal">Arwal</option>
                                        <option value="Asarganj">
                                          Asarganj
                                        </option>
                                        <option value="Aurangabad">
                                          Aurangabad
                                        </option>
                                        <option value="Bagaha">Bagaha</option>
                                        <option value="Bahadurganj">
                                          Bahadurganj
                                        </option>
                                        <option value="Bairagnia">
                                          Bairagnia
                                        </option>
                                        <option value="Baisi">Baisi</option>
                                        <option value="Bakhtiyarpur">
                                          Bakhtiyarpur
                                        </option>
                                        <option value="Bangaon">Bangaon</option>
                                        <option value="Banka">Banka</option>
                                        <option value="Banmankhi">
                                          Banmankhi
                                        </option>
                                        <option value="Bar Bigha">
                                          Bar Bigha
                                        </option>
                                        <option value="Barauli">Barauli</option>
                                        <option value="Barh">Barh</option>
                                        <option value="Barhiya">Barhiya</option>
                                        <option value="Bariarpur">
                                          Bariarpur
                                        </option>
                                        <option value="Baruni">Baruni</option>
                                        <option value="Begusarai">
                                          Begusarai
                                        </option>
                                        <option value="Belsand">Belsand</option>
                                        <option value="Bettiah">Bettiah</option>
                                        <option value="Bhabhua">Bhabhua</option>
                                        <option value="Bhagalpur">
                                          Bhagalpur
                                        </option>
                                        <option value="Bhagirathpur">
                                          Bhagirathpur
                                        </option>
                                        <option value="Bhawanipur">
                                          Bhawanipur
                                        </option>
                                        <option value="Bhojpur">Bhojpur</option>
                                        <option value="Bihar Sharif">
                                          Bihar Sharif
                                        </option>
                                        <option value="Bihariganj">
                                          Bihariganj
                                        </option>
                                        <option value="Bikramganj">
                                          Bikramganj
                                        </option>
                                        <option value="Birpur">Birpur</option>
                                        <option value="Buddh Gaya">
                                          Buddh Gaya
                                        </option>
                                        <option value="Buxar">Buxar</option>
                                        <option value="Chakia">Chakia</option>
                                        <option value="Chapra">Chapra</option>
                                        <option value="Chhatapur">
                                          Chhatapur
                                        </option>
                                        <option value="Colgong">Colgong</option>
                                        <option value="Dalsingh Sarai">
                                          Dalsingh Sarai
                                        </option>
                                        <option value="Darbhanga">
                                          Darbhanga
                                        </option>
                                        <option value="Daudnagar">
                                          Daudnagar
                                        </option>
                                        <option value="Dehri">Dehri</option>
                                        <option value="Dhaka">Dhaka</option>
                                        <option value="Dighwara">
                                          Dighwara
                                        </option>
                                        <option value="Dinapore">
                                          Dinapore
                                        </option>
                                        <option value="Dumra">Dumra</option>
                                        <option value="Dumraon">Dumraon</option>
                                        <option value="Fatwa">Fatwa</option>
                                        <option value="Forbesganj">
                                          Forbesganj
                                        </option>
                                        <option value="Gaya">Gaya</option>
                                        <option value="Ghoga">Ghoga</option>
                                        <option value="Gopalganj">
                                          Gopalganj
                                        </option>
                                        <option value="Hajipur">Hajipur</option>
                                        <option value="Hilsa">Hilsa</option>
                                        <option value="Hisua">Hisua</option>
                                        <option value="Islampur">
                                          Islampur
                                        </option>
                                        <option value="Jagdispur">
                                          Jagdispur
                                        </option>
                                        <option value="Jahanabad">
                                          Jahanabad
                                        </option>
                                        <option value="Jamalpur">
                                          Jamalpur
                                        </option>
                                        <option value="Jamui">Jamui</option>
                                        <option value="Jaynagar">
                                          Jaynagar
                                        </option>
                                        <option value="Jehanabad">
                                          Jehanabad
                                        </option>
                                        <option value="Jha-Jha">Jha-Jha</option>
                                        <option value="Jhanjharpur">
                                          Jhanjharpur
                                        </option>
                                        <option value="Jogbani">Jogbani</option>
                                        <option value="Kaimur District">
                                          Kaimur District
                                        </option>
                                        <option value="Kasba">Kasba</option>
                                        <option value="Katihar">Katihar</option>
                                        <option value="Khagaria">
                                          Khagaria
                                        </option>
                                        <option value="Khagaul">Khagaul</option>
                                        <option value="Kharagpur">
                                          Kharagpur
                                        </option>
                                        <option value="Khusropur">
                                          Khusropur
                                        </option>
                                        <option value="Kishanganj">
                                          Kishanganj
                                        </option>
                                        <option value="Koath">Koath</option>
                                        <option value="Koelwar">Koelwar</option>
                                        <option value="Lakhisarai">
                                          Lakhisarai
                                        </option>
                                        <option value="Lalganj">Lalganj</option>
                                        <option value="Luckeesarai">
                                          Luckeesarai
                                        </option>
                                        <option value="Madhepura">
                                          Madhepura
                                        </option>
                                        <option value="Madhipura">
                                          Madhipura
                                        </option>
                                        <option value="Madhubani">
                                          Madhubani
                                        </option>
                                        <option value="Maharajgani">
                                          Maharajgani
                                        </option>
                                        <option value="Mairwa">Mairwa</option>
                                        <option value="Maner">Maner</option>
                                        <option value="Manihari">
                                          Manihari
                                        </option>
                                        <option value="Marhaura">
                                          Marhaura
                                        </option>
                                        <option value="Masaurhi Buzurg">
                                          Masaurhi Buzurg
                                        </option>
                                        <option value="Mohiuddinnagar">
                                          Mohiuddinnagar
                                        </option>
                                        <option value="Mokameh">Mokameh</option>
                                        <option value="Monghyr">Monghyr</option>
                                        <option value="Mothihari">
                                          Mothihari
                                        </option>
                                        <option value="Munger">Munger</option>
                                        <option value="Murliganj">
                                          Murliganj
                                        </option>
                                        <option value="Muzaffarpur">
                                          Muzaffarpur
                                        </option>
                                        <option value="Nabinagar">
                                          Nabinagar
                                        </option>
                                        <option value="Nalanda">Nalanda</option>
                                        <option value="Nasriganj">
                                          Nasriganj
                                        </option>
                                        <option value="Naugachhia">
                                          Naugachhia
                                        </option>
                                        <option value="Nawada">Nawada</option>
                                        <option value="Nirmali">Nirmali</option>
                                        <option value="Pashchim Champaran">
                                          Pashchim Champaran
                                        </option>
                                        <option value="Patna">Patna</option>
                                        <option value="Piro">Piro</option>
                                        <option value="Pupri">Pupri</option>
                                        <option value="Purba Champaran">
                                          Purba Champaran
                                        </option>
                                        <option value="Purnia">Purnia</option>
                                        <option value="Rafiganj">
                                          Rafiganj
                                        </option>
                                        <option value="Raghunathpur">
                                          Raghunathpur
                                        </option>
                                        <option value="Rajgir">Rajgir</option>
                                        <option value="Ramnagar">
                                          Ramnagar
                                        </option>
                                        <option value="Raxaul">Raxaul</option>
                                        <option value="Revelganj">
                                          Revelganj
                                        </option>
                                        <option value="Rohtas">Rohtas</option>
                                        <option value="Rusera">Rusera</option>
                                        <option value="Sagauli">Sagauli</option>
                                        <option value="Saharsa">Saharsa</option>
                                        <option value="Samastipur">
                                          Samastipur
                                        </option>
                                        <option value="Saran">Saran</option>
                                        <option value="Shahbazpur">
                                          Shahbazpur
                                        </option>
                                        <option value="Shahpur">Shahpur</option>
                                        <option value="Sheikhpura">
                                          Sheikhpura
                                        </option>
                                        <option value="Sheohar">Sheohar</option>
                                        <option value="Sherghati">
                                          Sherghati
                                        </option>
                                        <option value="Silao">Silao</option>
                                        <option value="Sitamarhi">
                                          Sitamarhi
                                        </option>
                                        <option value="Siwan">Siwan</option>
                                        <option value="Supaul">Supaul</option>
                                        <option value="Teghra">Teghra</option>
                                        <option value="Tekari">Tekari</option>
                                        <option value="Thakurganj">
                                          Thakurganj
                                        </option>
                                        <option value="Vaishali">
                                          Vaishali
                                        </option>
                                        <option value="Waris Aliganj">
                                          Waris Aliganj
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Chandigarh" && (
                                      <>
                                        <option value="Chandigarh">
                                          Chandigarh
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state ===
                                      "Dadra and Nagar Haveli" && (
                                        <>
                                          <option value="Amli">Amli</option>
                                          <option value="Dadra">Dadra</option>
                                          <option value="Dadra & Nagar Haveli">
                                            Dadra & Nagar Haveli
                                          </option>
                                          <option value="Silvassa">
                                            Silvassa
                                          </option>
                                        </>
                                      )}
                                    {shippingAddress.state ===
                                      "Daman and Diu" && (
                                        <>
                                          <option value="Daman">Daman</option>
                                          <option value="Daman District">
                                            Daman District
                                          </option>
                                          <option value="Diu">Diu</option>
                                        </>
                                      )}
                                    {shippingAddress.state === "Delhi" && (
                                      <>
                                        <option value="Alipur">Alipur</option>
                                        <option value="Bawana">Bawana</option>
                                        <option value="Central Delhi">
                                          Central Delhi
                                        </option>
                                        <option value="Delhi">Delhi</option>
                                        <option value="Deoli">Deoli</option>
                                        <option value="East Delhi">
                                          East Delhi
                                        </option>
                                        <option value="Karol Bagh">
                                          Karol Bagh
                                        </option>
                                        <option value="Najafgarh">
                                          Najafgarh
                                        </option>
                                        <option value="Nangloi Jat">
                                          Nangloi Jat
                                        </option>
                                        <option value="Narela">Narela</option>
                                        <option value="New Delhi">
                                          New Delhi
                                        </option>
                                        <option value="North Delhi">
                                          North Delhi
                                        </option>
                                        <option value="North East Delhi">
                                          North East Delhi
                                        </option>
                                        <option value="North West Delhi">
                                          North West Delhi
                                        </option>
                                        <option value="Pitampura">
                                          Pitampura
                                        </option>
                                        <option value="Rohini">Rohini</option>
                                        <option value="South Delhi">
                                          South Delhi
                                        </option>
                                        <option value="South West Delhi">
                                          South West Delhi
                                        </option>
                                        <option value="West Delhi">
                                          West Delhi
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Goa" && (
                                      <>
                                        <option value="Aldona">Aldona</option>
                                        <option value="Arambol">Arambol</option>
                                        <option value="Baga">Baga</option>
                                        <option value="Bambolim">
                                          Bambolim
                                        </option>
                                        <option value="Bandora">Bandora</option>
                                        <option value="Benaulim">
                                          Benaulim
                                        </option>
                                        <option value="Calangute">
                                          Calangute
                                        </option>
                                        <option value="Candolim">
                                          Candolim
                                        </option>
                                        <option value="Carapur">Carapur</option>
                                        <option value="Cavelossim">
                                          Cavelossim
                                        </option>
                                        <option value="Chicalim">
                                          Chicalim
                                        </option>
                                        <option value="Chinchinim">
                                          Chinchinim
                                        </option>
                                        <option value="Colovale">
                                          Colovale
                                        </option>
                                        <option value="Colva">Colva</option>
                                        <option value="Cortalim">
                                          Cortalim
                                        </option>
                                        <option value="Cuncolim">
                                          Cuncolim
                                        </option>
                                        <option value="Curchorem">
                                          Curchorem
                                        </option>
                                        <option value="Curti">Curti</option>
                                        <option value="Davorlim">
                                          Davorlim
                                        </option>
                                        <option value="Dicholi">Dicholi</option>
                                        <option value="Goa Velha">
                                          Goa Velha
                                        </option>
                                        <option value="Guirim">Guirim</option>
                                        <option value="Jua">Jua</option>
                                        <option value="Kankon">Kankon</option>
                                        <option value="Madgaon">Madgaon</option>
                                        <option value="Mapuca">Mapuca</option>
                                        <option value="Morjim">Morjim</option>
                                        <option value="Mormugao">
                                          Mormugao
                                        </option>
                                        <option value="Navelim">Navelim</option>
                                        <option value="North Goa">
                                          North Goa
                                        </option>
                                        <option value="Palle">Palle</option>
                                        <option value="Panaji">Panaji</option>
                                        <option value="Pernem">Pernem</option>
                                        <option value="Ponda">Ponda</option>
                                        <option value="Quepem">Quepem</option>
                                        <option value="Queula">Queula</option>
                                        <option value="Raia">Raia</option>
                                        <option value="Saligao">Saligao</option>
                                        <option value="Sancoale">
                                          Sancoale
                                        </option>
                                        <option value="Sanguem">Sanguem</option>
                                        <option value="Sanquelim">
                                          Sanquelim
                                        </option>
                                        <option value="Sanvordem">
                                          Sanvordem
                                        </option>
                                        <option value="Serula">Serula</option>
                                        <option value="Solim">Solim</option>
                                        <option value="South Goa">
                                          South Goa
                                        </option>
                                        <option value="Taleigao">
                                          Taleigao
                                        </option>
                                        <option value="Vagator">Vagator</option>
                                        <option value="Valpoy">Valpoy</option>
                                        <option value="Varca">Varca</option>
                                        <option value="Vasco da Gama">
                                          Vasco da Gama
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Gujarat" && (
                                      <>
                                        <option value="Abrama">Abrama</option>
                                        <option value="Adalaj">Adalaj</option>
                                        <option value="Ahmedabad">
                                          Ahmedabad
                                        </option>
                                        <option value="Ahwa">Ahwa</option>
                                        <option value="Amod">Amod</option>
                                        <option value="Amreli">Amreli</option>
                                        <option value="Amroli">Amroli</option>
                                        <option value="Anand">Anand</option>
                                        <option value="Anjar">Anjar</option>
                                        <option value="Ankleshwar">
                                          Ankleshwar
                                        </option>
                                        <option value="Babra">Babra</option>
                                        <option value="Bagasara">
                                          Bagasara
                                        </option>
                                        <option value="Bagasra">Bagasra</option>
                                        <option value="Banas Kantha">
                                          Banas Kantha
                                        </option>
                                        <option value="Bantva">Bantva</option>
                                        <option value="Bardoli">Bardoli</option>
                                        <option value="Bedi">Bedi</option>
                                        <option value="Bhachau">Bhachau</option>
                                        <option value="Bhanvad">Bhanvad</option>
                                        <option value="Bharuch">Bharuch</option>
                                        <option value="Bhavnagar">
                                          Bhavnagar
                                        </option>
                                        <option value="Bhayavadar">
                                          Bhayavadar
                                        </option>
                                        <option value="Bhuj">Bhuj</option>
                                        <option value="Bilimora">
                                          Bilimora
                                        </option>
                                        <option value="Bilkha">Bilkha</option>
                                        <option value="Borsad">Borsad</option>
                                        <option value="Botad">Botad</option>
                                        <option value="Chaklasi">
                                          Chaklasi
                                        </option>
                                        <option value="Chalala">Chalala</option>
                                        <option value="Chanasma">
                                          Chanasma
                                        </option>
                                        <option value="Chhala">Chhala</option>
                                        <option value="Chhota Udepur">
                                          Chhota Udepur
                                        </option>
                                        <option value="Chikhli">Chikhli</option>
                                        <option value="Chotila">Chotila</option>
                                        <option value="Dabhoi">Dabhoi</option>
                                        <option value="Dahegam">Dahegam</option>
                                        <option value="Dahod">Dahod</option>
                                        <option value="Dakor">Dakor</option>
                                        <option value="Damnagar">
                                          Damnagar
                                        </option>
                                        <option value="Dangs (India)">
                                          Dangs (India)
                                        </option>
                                        <option value="Dayapar">Dayapar</option>
                                        <option value="Delvada">Delvada</option>
                                        <option value="Delwada">Delwada</option>
                                        <option value="Devbhumi Dwarka">
                                          Devbhumi Dwarka
                                        </option>
                                        <option value="Devgadh Bariya">
                                          Devgadh Bariya
                                        </option>
                                        <option value="Dhandhuka">
                                          Dhandhuka
                                        </option>
                                        <option value="Dhanera">Dhanera</option>
                                        <option value="Dharampur">
                                          Dharampur
                                        </option>
                                        <option value="Dhari">Dhari</option>
                                        <option value="Dhola">Dhola</option>
                                        <option value="Dholka">Dholka</option>
                                        <option value="Dhoraji">Dhoraji</option>
                                        <option value="Dhrangadhra">
                                          Dhrangadhra
                                        </option>
                                        <option value="Dhrol">Dhrol</option>
                                        <option value="Dhuwaran">
                                          Dhuwaran
                                        </option>
                                        <option value="Disa">Disa</option>
                                        <option value="Dohad">Dohad</option>
                                        <option value="Dungarpur">
                                          Dungarpur
                                        </option>
                                        <option value="Dwarka">Dwarka</option>
                                        <option value="Gadhada">Gadhada</option>
                                        <option value="Gandevi">Gandevi</option>
                                        <option value="Gandhidham">
                                          Gandhidham
                                        </option>
                                        <option value="Gandhinagar">
                                          Gandhinagar
                                        </option>
                                        <option value="Gariadhar">
                                          Gariadhar
                                        </option>
                                        <option value="Ghogha">Ghogha</option>
                                        <option value="Gir Somnath">
                                          Gir Somnath
                                        </option>
                                        <option value="Godhra">Godhra</option>
                                        <option value="Gondal">Gondal</option>
                                        <option value="Halol">Halol</option>
                                        <option value="Halvad">Halvad</option>
                                        <option value="Hansot">Hansot</option>
                                        <option value="Harij">Harij</option>
                                        <option value="Himatnagar">
                                          Himatnagar
                                        </option>
                                        <option value="Jalalpore">
                                          Jalalpore
                                        </option>
                                        <option value="Jalalpur">
                                          Jalalpur
                                        </option>
                                        <option value="Jambusar">
                                          Jambusar
                                        </option>
                                        <option value="Jamnagar">
                                          Jamnagar
                                        </option>
                                        <option value="Jasdan">Jasdan</option>
                                        <option value="Jetalsar">
                                          Jetalsar
                                        </option>
                                        <option value="Jetpur">Jetpur</option>
                                        <option value="Jhulasan">
                                          Jhulasan
                                        </option>
                                        <option value="Jodhpur">Jodhpur</option>
                                        <option value="Jodia">Jodia</option>
                                        <option value="Jodiya Bandar">
                                          Jodiya Bandar
                                        </option>
                                        <option value="Junagadh">
                                          Junagadh
                                        </option>
                                        <option value="Kachchh">Kachchh</option>
                                        <option value="Kadi">Kadi</option>
                                        <option value="Kadod">Kadod</option>
                                        <option value="Kalavad">Kalavad</option>
                                        <option value="Kalol">Kalol</option>
                                        <option value="Kandla">Kandla</option>
                                        <option value="Kanodar">Kanodar</option>
                                        <option value="Kapadvanj">
                                          Kapadvanj
                                        </option>
                                        <option value="Karamsad">
                                          Karamsad
                                        </option>
                                        <option value="Kathor">Kathor</option>
                                        <option value="Katpur">Katpur</option>
                                        <option value="Kavant">Kavant</option>
                                        <option value="Kawant">Kawant</option>
                                        <option value="Keshod">Keshod</option>
                                        <option value="Khambhalia">
                                          Khambhalia
                                        </option>
                                        <option value="Khambhat">
                                          Khambhat
                                        </option>
                                        <option value="Kheda">Kheda</option>
                                        <option value="Khedbrahma">
                                          Khedbrahma
                                        </option>
                                        <option value="Kheralu">Kheralu</option>
                                        <option value="Kodinar">Kodinar</option>
                                        <option value="Kosamba">Kosamba</option>
                                        <option value="Kundla">Kundla</option>
                                        <option value="Kutch district">
                                          Kutch district
                                        </option>
                                        <option value="Kutiyana">
                                          Kutiyana
                                        </option>
                                        <option value="Lakhtar">Lakhtar</option>
                                        <option value="Lalpur">Lalpur</option>
                                        <option value="Lathi">Lathi</option>
                                        <option value="Limbdi">Limbdi</option>
                                        <option value="Lunavada">
                                          Lunavada
                                        </option>
                                        <option value="Mahemdavad">
                                          Mahemdavad
                                        </option>
                                        <option value="Mahesana">
                                          Mahesana
                                        </option>
                                        <option value="Mahudha">Mahudha</option>
                                        <option value="Malpur">Malpur</option>
                                        <option value="Manavadar">
                                          Manavadar
                                        </option>
                                        <option value="Mandal">Mandal</option>
                                        <option value="Mandvi">Mandvi</option>
                                        <option value="Mandvi (Surat)">
                                          Mandvi (Surat)
                                        </option>
                                        <option value="Mangrol">Mangrol</option>
                                        <option value="Mansa">Mansa</option>
                                        <option value="Meghraj">Meghraj</option>
                                        <option value="Mehsana">Mehsana</option>
                                        <option value="Mendarda">
                                          Mendarda
                                        </option>
                                        <option value="Modasa">Modasa</option>
                                        <option value="Morbi">Morbi</option>
                                        <option value="Morva (Hadaf)">
                                          Morva (Hadaf)
                                        </option>
                                        <option value="Morwa">Morwa</option>
                                        <option value="Mundra">Mundra</option>
                                        <option value="Nadiad">Nadiad</option>
                                        <option value="Naliya">Naliya</option>
                                        <option value="Narmada">Narmada</option>
                                        <option value="Naroda">Naroda</option>
                                        <option value="Navsari">Navsari</option>
                                        <option value="Okha">Okha</option>
                                        <option value="Olpad">Olpad</option>
                                        <option value="Paddhari">
                                          Paddhari
                                        </option>
                                        <option value="Padra">Padra</option>
                                        <option value="Palanpur">
                                          Palanpur
                                        </option>
                                        <option value="Palitana">
                                          Palitana
                                        </option>
                                        <option value="Paliyad">Paliyad</option>
                                        <option value="Panch Mahals">
                                          Panch Mahals
                                        </option>
                                        <option value="Panchmahal district">
                                          Panchmahal district
                                        </option>
                                        <option value="Pardi">Pardi</option>
                                        <option value="Parnera">Parnera</option>
                                        <option value="Patan">Patan</option>
                                        <option value="Pavi Jetpur">
                                          Pavi Jetpur
                                        </option>
                                        <option value="Petlad">Petlad</option>
                                        <option value="Porbandar">
                                          Porbandar
                                        </option>
                                        <option value="Radhanpur">
                                          Radhanpur
                                        </option>
                                        <option value="Rajkot">Rajkot</option>
                                        <option value="Rajpipla">
                                          Rajpipla
                                        </option>
                                        <option value="Rajula">Rajula</option>
                                        <option value="Ranavav">Ranavav</option>
                                        <option value="Rapar">Rapar</option>
                                        <option value="Roha">Roha</option>
                                        <option value="Sabar Kantha">
                                          Sabar Kantha
                                        </option>
                                        <option value="Sachin">Sachin</option>
                                        <option value="Salaya">Salaya</option>
                                        <option value="Sanand">Sanand</option>
                                        <option value="Sankheda">
                                          Sankheda
                                        </option>
                                        <option value="Sarkhej">Sarkhej</option>
                                        <option value="Savarkundla">
                                          Savarkundla
                                        </option>
                                        <option value="Sayla">Sayla</option>
                                        <option value="Shahpur">Shahpur</option>
                                        <option value="Shivrajpur">
                                          Shivrajpur
                                        </option>
                                        <option value="Siddhpur">
                                          Siddhpur
                                        </option>
                                        <option value="Sihor">Sihor</option>
                                        <option value="Sikka">Sikka</option>
                                        <option value="Sinor">Sinor</option>
                                        <option value="Sojitra">Sojitra</option>
                                        <option value="Songadh">Songadh</option>
                                        <option value="Surat">Surat</option>
                                        <option value="Surendranagar">
                                          Surendranagar
                                        </option>
                                        <option value="Talaja">Talaja</option>
                                        <option value="Tankara">Tankara</option>
                                        <option value="Tapi">Tapi</option>
                                        <option value="Than">Than</option>
                                        <option value="Thangadh">
                                          Thangadh
                                        </option>
                                        <option value="Tharad">Tharad</option>
                                        <option value="Thasra">Thasra</option>
                                        <option value="The Dangs">
                                          The Dangs
                                        </option>
                                        <option value="Umrala">Umrala</option>
                                        <option value="Umreth">Umreth</option>
                                        <option value="Un">Un</option>
                                        <option value="Una">Una</option>
                                        <option value="Unjha">Unjha</option>
                                        <option value="Upleta">Upleta</option>
                                        <option value="Utran">Utran</option>
                                        <option value="Vadnagar">
                                          Vadnagar
                                        </option>
                                        <option value="Vadodara">
                                          Vadodara
                                        </option>
                                        <option value="Vaghodia">
                                          Vaghodia
                                        </option>
                                        <option value="Vallabh Vidyanagar">
                                          Vallabh Vidyanagar
                                        </option>
                                        <option value="Vallabhipur">
                                          Vallabhipur
                                        </option>
                                        <option value="Valsad">Valsad</option>
                                        <option value="Vansda">Vansda</option>
                                        <option value="Vapi">Vapi</option>
                                        <option value="Vartej">Vartej</option>
                                        <option value="Vasa">Vasa</option>
                                        <option value="Vaso">Vaso</option>
                                        <option value="Vejalpur">
                                          Vejalpur
                                        </option>
                                        <option value="Veraval">Veraval</option>
                                        <option value="Vijapur">Vijapur</option>
                                        <option value="Vinchhiya">
                                          Vinchhiya
                                        </option>
                                        <option value="Vinchia">Vinchia</option>
                                        <option value="Virpur">Virpur</option>
                                        <option value="Visavadar">
                                          Visavadar
                                        </option>
                                        <option value="Visnagar">
                                          Visnagar
                                        </option>
                                        <option value="Vyara">Vyara</option>
                                        <option value="Wadhai">Wadhai</option>
                                        <option value="Wadhwan">Wadhwan</option>
                                        <option value="Waghai">Waghai</option>
                                        <option value="Wankaner">
                                          Wankaner
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Haryana" && (
                                      <>
                                        {" "}
                                        <option value="Ambala">Ambala</option>
                                        <option value="Asandh">Asandh</option>
                                        <option value="Ateli Mandi">
                                          Ateli Mandi
                                        </option>
                                        <option value="Bahadurgarh">
                                          Bahadurgarh
                                        </option>
                                        <option value="Bara Uchana">
                                          Bara Uchana
                                        </option>
                                        <option value="Barwala">Barwala</option>
                                        <option value="Bawal">Bawal</option>
                                        <option value="Beri Khas">
                                          Beri Khas
                                        </option>
                                        <option value="Bhiwani">Bhiwani</option>
                                        <option value="Bilaspur">
                                          Bilaspur
                                        </option>
                                        <option value="Buriya">Buriya</option>
                                        <option value="Charkhi Dadri">
                                          Charkhi Dadri
                                        </option>
                                        <option value="Chhachhrauli">
                                          Chhachhrauli
                                        </option>
                                        <option value="Dabwali">Dabwali</option>
                                        <option value="Dharuhera">
                                          Dharuhera
                                        </option>
                                        <option value="Ellenabad">
                                          Ellenabad
                                        </option>
                                        <option value="Faridabad">
                                          Faridabad
                                        </option>
                                        <option value="Faridabad District">
                                          Faridabad District
                                        </option>
                                        <option value="Farrukhnagar">
                                          Farrukhnagar
                                        </option>
                                        <option value="Fatehabad">
                                          Fatehabad
                                        </option>
                                        <option value="Fatehabad District">
                                          Fatehabad District
                                        </option>
                                        <option value="Firozpur Jhirka">
                                          Firozpur Jhirka
                                        </option>
                                        <option value="Gharaunda">
                                          Gharaunda
                                        </option>
                                        <option value="Gohana">Gohana</option>
                                        <option value="Gorakhpur">
                                          Gorakhpur
                                        </option>
                                        <option value="Gurgaon">Gurgaon</option>
                                        <option value="Hansi">Hansi</option>
                                        <option value="Hasanpur">
                                          Hasanpur
                                        </option>
                                        <option value="Hisar">Hisar</option>
                                        <option value="Hodal">Hodal</option>
                                        <option value="Inda Chhoi">
                                          Inda Chhoi
                                        </option>
                                        <option value="Indri">Indri</option>
                                        <option value="Jagadhri">
                                          Jagadhri
                                        </option>
                                        <option value="Jakhal">Jakhal</option>
                                        <option value="Jhajjar">Jhajjar</option>
                                        <option value="Jind">Jind</option>
                                        <option value="Kaithal">Kaithal</option>
                                        <option value="Kalanaur">
                                          Kalanaur
                                        </option>
                                        <option value="Kalanwali">
                                          Kalanwali
                                        </option>
                                        <option value="Kanina Khas">
                                          Kanina Khas
                                        </option>
                                        <option value="Karnal">Karnal</option>
                                        <option value="Kharkhauda">
                                          Kharkhauda
                                        </option>
                                        <option value="Kheri Sampla">
                                          Kheri Sampla
                                        </option>
                                        <option value="Kurukshetra">
                                          Kurukshetra
                                        </option>
                                        <option value="Ladwa">Ladwa</option>
                                        <option value="Loharu">Loharu</option>
                                        <option value="Maham">Maham</option>
                                        <option value="Mahendragarh">
                                          Mahendragarh
                                        </option>
                                        <option value="Mandholi Kalan">
                                          Mandholi Kalan
                                        </option>
                                        <option value="Mustafabad">
                                          Mustafabad
                                        </option>
                                        <option value="Narayangarh">
                                          Narayangarh
                                        </option>
                                        <option value="Narnaul">Narnaul</option>
                                        <option value="Narnaund">
                                          Narnaund
                                        </option>
                                        <option value="Narwana">Narwana</option>
                                        <option value="Nilokheri">
                                          Nilokheri
                                        </option>
                                        <option value="Nuh">Nuh</option>
                                        <option value="Palwal">Palwal</option>
                                        <option value="Panchkula">
                                          Panchkula
                                        </option>
                                        <option value="Panipat">Panipat</option>
                                        <option value="Pataudi">Pataudi</option>
                                        <option value="Pehowa">Pehowa</option>
                                        <option value="Pinjaur">Pinjaur</option>
                                        <option value="Punahana">
                                          Punahana
                                        </option>
                                        <option value="Pundri">Pundri</option>
                                        <option value="Radaur">Radaur</option>
                                        <option value="Rania">Rania</option>
                                        <option value="Ratia">Ratia</option>
                                        <option value="Rewari">Rewari</option>
                                        <option value="Rewari District">
                                          Rewari District
                                        </option>
                                        <option value="Rohtak">Rohtak</option>
                                        <option value="Safidon">Safidon</option>
                                        <option value="Samalkha">
                                          Samalkha
                                        </option>
                                        <option value="Shadipur Julana">
                                          Shadipur Julana
                                        </option>
                                        <option value="Shahabad">
                                          Shahabad
                                        </option>
                                        <option value="Sirsa">Sirsa</option>
                                        <option value="Sohna">Sohna</option>
                                        <option value="Sonipat">Sonipat</option>
                                        <option value="Taoru">Taoru</option>
                                        <option value="Thanesar">
                                          Thanesar
                                        </option>
                                        <option value="Tohana">Tohana</option>
                                        <option value="Tosham">Tosham</option>
                                        <option value="Uklana">Uklana</option>
                                        <option value="Yamunanagar">
                                          Yamunanagar
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state ===
                                      "Himachal Pradesh" && (
                                        <>
                                          <option value="Arki">Arki</option>
                                          <option value="Baddi">Baddi</option>
                                          <option value="Banjar">Banjar</option>
                                          <option value="Bilaspur">
                                            Bilaspur
                                          </option>
                                          <option value="Chamba">Chamba</option>
                                          <option value="Chaupal">Chaupal</option>
                                          <option value="Chowari">Chowari</option>
                                          <option value="Chuari Khas">
                                            Chuari Khas
                                          </option>
                                          <option value="Dagshai">Dagshai</option>
                                          <option value="Dalhousie">
                                            Dalhousie
                                          </option>
                                          <option value="Daulatpur">
                                            Daulatpur
                                          </option>
                                          <option value="Dera Gopipur">
                                            Dera Gopipur
                                          </option>
                                          <option value="Dharamsala">
                                            Dharamsala
                                          </option>
                                          <option value="Gagret">Gagret</option>
                                          <option value="Ghumarwin">
                                            Ghumarwin
                                          </option>
                                          <option value="Hamirpur">
                                            Hamirpur
                                          </option>
                                          <option value="Jawala Mukhi">
                                            Jawala Mukhi
                                          </option>
                                          <option value="Jogindarnagar">
                                            Jogindarnagar
                                          </option>
                                          <option value="Jubbal">Jubbal</option>
                                          <option value="Jutogh">Jutogh</option>
                                          <option value="Kalka">Kalka</option>
                                          <option value="Kangar">Kangar</option>
                                          <option value="Kangra">Kangra</option>
                                          <option value="Kasauli">Kasauli</option>
                                          <option value="Kinnaur">Kinnaur</option>
                                          <option value="Kotkhai">Kotkhai</option>
                                          <option value="Kotla">Kotla</option>
                                          <option value="Kulu">Kulu</option>
                                          <option value="Kyelang">Kyelang</option>
                                          <option value="Lahul and Spiti">
                                            Lahul and Spiti
                                          </option>
                                          <option value="Manali">Manali</option>
                                          <option value="Mandi">Mandi</option>
                                          <option value="Nadaun">Nadaun</option>
                                          <option value="Nagar">Nagar</option>
                                          <option value="Nagrota">Nagrota</option>
                                          <option value="Nahan">Nahan</option>
                                          <option value="Nalagarh">
                                            Nalagarh
                                          </option>
                                          <option value="Palampur">
                                            Palampur
                                          </option>
                                          <option value="Pandoh">Pandoh</option>
                                          <option value="Paonta Sahib">
                                            Paonta Sahib
                                          </option>
                                          <option value="Parwanoo">
                                            Parwanoo
                                          </option>
                                          <option value="Rajgarh">Rajgarh</option>
                                          <option value="Rampur">Rampur</option>
                                          <option value="Rohru">Rohru</option>
                                          <option value="Sabathu">Sabathu</option>
                                          <option value="Santokhgarh">
                                            Santokhgarh
                                          </option>
                                          <option value="Sarahan">Sarahan</option>
                                          <option value="Sarka Ghat">
                                            Sarka Ghat
                                          </option>
                                          <option value="Seoni">Seoni</option>
                                          <option value="Shimla">Shimla</option>
                                          <option value="Sirmaur">Sirmaur</option>
                                          <option value="Solan">Solan</option>
                                          <option value="Sundarnagar">
                                            Sundarnagar
                                          </option>
                                          <option value="Theog">Theog</option>
                                          <option value="Tira Sujanpur">
                                            Tira Sujanpur
                                          </option>
                                          <option value="Una">Una</option>
                                          <option value="Yol">Yol</option>
                                        </>
                                      )}
                                    {shippingAddress.state ===
                                      "Jammu and Kashmir" && (
                                        <>
                                          <option value="Akhnur">Akhnur</option>
                                          <option value="Anantnag">
                                            Anantnag
                                          </option>
                                          <option value="Awantipur">
                                            Awantipur
                                          </option>
                                          <option value="Badgam">Badgam</option>
                                          <option value="Bandipore">
                                            Bandipore
                                          </option>
                                          <option value="Bandipura">
                                            Bandipura
                                          </option>
                                          <option value="Banihal">Banihal</option>
                                          <option value="Baramula">
                                            Baramula
                                          </option>
                                          <option value="Batoti">Batoti</option>
                                          <option value="Bhadarwah">
                                            Bhadarwah
                                          </option>
                                          <option value="Bijbehara">
                                            Bijbehara
                                          </option>
                                          <option value="Bishnah">Bishnah</option>
                                          <option value="Doda">Doda</option>
                                          <option value="Gandarbal">
                                            Gandarbal
                                          </option>
                                          <option value="Ganderbal">
                                            Ganderbal
                                          </option>
                                          <option value="Gho Brahmanan de">
                                            Gho Brahmanan de
                                          </option>
                                          <option value="Hajan">Hajan</option>
                                          <option value="Hiranagar">
                                            Hiranagar
                                          </option>
                                          <option value="Jammu">Jammu</option>
                                          <option value="Jaurian">Jaurian</option>
                                          <option value="Kathua">Kathua</option>
                                          <option value="Katra">Katra</option>
                                          <option value="Khaur">Khaur</option>
                                          <option value="Kishtwar">
                                            Kishtwar
                                          </option>
                                          <option value="Kud">Kud</option>
                                          <option value="Kulgam">Kulgam</option>
                                          <option value="Kupwara">Kupwara</option>
                                          <option value="Ladakh">Ladakh</option>
                                          <option value="Magam">Magam</option>
                                          <option value="Nawanshahr">
                                            Nawanshahr
                                          </option>
                                          <option value="Noria">Noria</option>
                                          <option value="Padam">Padam</option>
                                          <option value="Pahlgam">Pahlgam</option>
                                          <option value="Parol">Parol</option>
                                          <option value="Pattan">Pattan</option>
                                          <option value="Pulwama">Pulwama</option>
                                          <option value="Punch">Punch</option>
                                          <option value="Qazigund">
                                            Qazigund
                                          </option>
                                          <option value="Rajaori">Rajaori</option>
                                          <option value="Rajauri">Rajauri</option>
                                          <option value="Ramban">Ramban</option>
                                          <option value="Ramgarh">Ramgarh</option>
                                          <option value="Ramnagar">
                                            Ramnagar
                                          </option>
                                          <option value="Riasi">Riasi</option>
                                          <option value="Samba">Samba</option>
                                          <option value="Shupiyan">
                                            Shupiyan
                                          </option>
                                          <option value="Sopur">Sopur</option>
                                          <option value="Soyibug">Soyibug</option>
                                          <option value="Srinagar">
                                            Srinagar
                                          </option>
                                          <option value="Sumbal">Sumbal</option>
                                          <option value="Thang">Thang</option>
                                          <option value="Thanna Mandi">
                                            Thanna Mandi
                                          </option>
                                          <option value="Tral">Tral</option>
                                          <option value="Tsrar Sharif">
                                            Tsrar Sharif
                                          </option>
                                          <option value="Udhampur">
                                            Udhampur
                                          </option>
                                          <option value="Uri">Uri</option>
                                        </>
                                      )}
                                    {shippingAddress.state === "Jharkhand" && (
                                      <>
                                        <option value="Bagra">Bagra</option>
                                        <option value="Barka Kana">
                                          Barka Kana
                                        </option>
                                        <option value="Barki Saria">
                                          Barki Saria
                                        </option>
                                        <option value="Barwadih">
                                          Barwadih
                                        </option>
                                        <option value="Bhojudih">
                                          Bhojudih
                                        </option>
                                        <option value="Bokaro">Bokaro</option>
                                        <option value="Bundu">Bundu</option>
                                        <option value="Chaibasa">
                                          Chaibasa
                                        </option>
                                        <option value="Chakradharpur">
                                          Chakradharpur
                                        </option>
                                        <option value="Chakulia">
                                          Chakulia
                                        </option>
                                        <option value="Chandil">Chandil</option>
                                        <option value="Chas">Chas</option>
                                        <option value="Chatra">Chatra</option>
                                        <option value="Chiria">Chiria</option>
                                        <option value="Daltonganj">
                                          Daltonganj
                                        </option>
                                        <option value="Deogarh">Deogarh</option>
                                        <option value="Dhanbad">Dhanbad</option>
                                        <option value="Dhanwar">Dhanwar</option>
                                        <option value="Dugda">Dugda</option>
                                        <option value="Dumka">Dumka</option>
                                        <option value="Garhwa">Garhwa</option>
                                        <option value="Ghatsila">
                                          Ghatsila
                                        </option>
                                        <option value="Giridih">Giridih</option>
                                        <option value="Gobindpur">
                                          Gobindpur
                                        </option>
                                        <option value="Godda">Godda</option>
                                        <option value="Gomoh">Gomoh</option>
                                        <option value="Gopinathpur">
                                          Gopinathpur
                                        </option>
                                        <option value="Gua">Gua</option>
                                        <option value="Gumia">Gumia</option>
                                        <option value="Gumla">Gumla</option>
                                        <option value="Hazaribag">
                                          Hazaribag
                                        </option>
                                        <option value="Hazaribagh">
                                          Hazaribagh
                                        </option>
                                        <option value="Hesla">Hesla</option>
                                        <option value="Husainabad">
                                          Husainabad
                                        </option>
                                        <option value="Jagannathpur">
                                          Jagannathpur
                                        </option>
                                        <option value="Jamadoba">
                                          Jamadoba
                                        </option>
                                        <option value="Jamshedpur">
                                          Jamshedpur
                                        </option>
                                        <option value="Jamtara">Jamtara</option>
                                        <option value="Jasidih">Jasidih</option>
                                        <option value="Jharia">Jharia</option>
                                        <option value="Jugsalai">
                                          Jugsalai
                                        </option>
                                        <option value="Jumri Tilaiya">
                                          Jumri Tilaiya
                                        </option>
                                        <option value="Kalikapur">
                                          Kalikapur
                                        </option>
                                        <option value="Kandra">Kandra</option>
                                        <option value="Kanke">Kanke</option>
                                        <option value="Katras">Katras</option>
                                        <option value="Kenduadih">
                                          Kenduadih
                                        </option>
                                        <option value="Kharsawan">
                                          Kharsawan
                                        </option>
                                        <option value="Khunti">Khunti</option>
                                        <option value="Kodarma">Kodarma</option>
                                        <option value="Kuju">Kuju</option>
                                        <option value="Latehar">Latehar</option>
                                        <option value="Lohardaga">
                                          Lohardaga
                                        </option>
                                        <option value="Madhupur">
                                          Madhupur
                                        </option>
                                        <option value="Malkera">Malkera</option>
                                        <option value="Manoharpur">
                                          Manoharpur
                                        </option>
                                        <option value="Mugma">Mugma</option>
                                        <option value="Mushabani">
                                          Mushabani
                                        </option>
                                        <option value="Neturhat">
                                          Neturhat
                                        </option>
                                        <option value="Nirsa">Nirsa</option>
                                        <option value="Noamundi">
                                          Noamundi
                                        </option>
                                        <option value="Pakur">Pakur</option>
                                        <option value="Palamu">Palamu</option>
                                        <option value="Pashchim Singhbhum">
                                          Pashchim Singhbhum
                                        </option>
                                        <option value="patamda">patamda</option>
                                        <option value="Pathardih">
                                          Pathardih
                                        </option>
                                        <option value="Purba Singhbhum">
                                          Purba Singhbhum
                                        </option>
                                        <option value="Ramgarh">Ramgarh</option>
                                        <option value="Ranchi">Ranchi</option>
                                        <option value="Ray">Ray</option>
                                        <option value="Sahibganj">
                                          Sahibganj
                                        </option>
                                        <option value="Saraikela">
                                          Saraikela
                                        </option>
                                        <option value="Sarubera">
                                          Sarubera
                                        </option>
                                        <option value="Sijua">Sijua</option>
                                        <option value="Simdega">Simdega</option>
                                        <option value="Sini">Sini</option>
                                        <option value="Topchanchi">
                                          Topchanchi
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Kerala" && (
                                      <>
                                        <option value="Adur">Adur</option>
                                        <option value="Alappuzha">
                                          Alappuzha
                                        </option>
                                        <option value="Aluva">Aluva</option>
                                        <option value="Alwaye">Alwaye</option>
                                        <option value="Angamali">
                                          Angamali
                                        </option>
                                        <option value="Aroor">Aroor</option>
                                        <option value="Arukutti">
                                          Arukutti
                                        </option>
                                        <option value="Attingal">
                                          Attingal
                                        </option>
                                        <option value="Avanoor">Avanoor</option>
                                        <option value="Azhikkal">
                                          Azhikkal
                                        </option>
                                        <option value="Badagara">
                                          Badagara
                                        </option>
                                        <option value="Beypore">Beypore</option>
                                        <option value="Changanacheri">
                                          Changanacheri
                                        </option>
                                        <option value="Chēlakara">
                                          Chēlakara
                                        </option>
                                        <option value="Chengannur">
                                          Chengannur
                                        </option>
                                        <option value="Cherpulassery">
                                          Cherpulassery
                                        </option>
                                        <option value="Cherthala">
                                          Cherthala
                                        </option>
                                        <option value="Chetwayi">
                                          Chetwayi
                                        </option>
                                        <option value="Chittur">Chittur</option>
                                        <option value="Cochin">Cochin</option>
                                        <option value="Dharmadam">
                                          Dharmadam
                                        </option>
                                        <option value="Edakkulam">
                                          Edakkulam
                                        </option>
                                        <option value="Elur">Elur</option>
                                        <option value="Erattupetta">
                                          Erattupetta
                                        </option>
                                        <option value="Ernakulam">
                                          Ernakulam
                                        </option>
                                        <option value="Ferokh">Ferokh</option>
                                        <option value="Guruvayur">
                                          Guruvayur
                                        </option>
                                        <option value="Idukki">Idukki</option>
                                        <option value="Iringal">Iringal</option>
                                        <option value="Irinjalakuda">
                                          Irinjalakuda
                                        </option>
                                        <option value="Kadakkavoor">
                                          Kadakkavoor
                                        </option>
                                        <option value="Kalamassery">
                                          Kalamassery
                                        </option>
                                        <option value="Kalavoor">
                                          Kalavoor
                                        </option>
                                        <option value="Kalpatta">
                                          Kalpatta
                                        </option>
                                        <option value="Kannangad">
                                          Kannangad
                                        </option>
                                        <option value="Kannavam">
                                          Kannavam
                                        </option>
                                        <option value="Kannur">Kannur</option>
                                        <option value="Kasaragod">
                                          Kasaragod
                                        </option>
                                        <option value="Kasaragod District">
                                          Kasaragod District
                                        </option>
                                        <option value="Kattanam">
                                          Kattanam
                                        </option>
                                        <option value="Kayankulam">
                                          Kayankulam
                                        </option>
                                        <option value="Kizhake Chalakudi">
                                          Kizhake Chalakudi
                                        </option>
                                        <option value="Kodungallur">
                                          Kodungallur
                                        </option>
                                        <option value="Kollam">Kollam</option>
                                        <option value="Kotamangalam">
                                          Kotamangalam
                                        </option>
                                        <option value="Kottayam">
                                          Kottayam
                                        </option>
                                        <option value="Kovalam">Kovalam</option>
                                        <option value="Kozhikode">
                                          Kozhikode
                                        </option>
                                        <option value="Kumbalam">
                                          Kumbalam
                                        </option>
                                        <option value="Kunnamangalam">
                                          Kunnamangalam
                                        </option>
                                        <option value="Kunnamkulam">
                                          Kunnamkulam
                                        </option>
                                        <option value="Kunnumma">
                                          Kunnumma
                                        </option>
                                        <option value="Kutiatodu">
                                          Kutiatodu
                                        </option>
                                        <option value="Kuttampuzha">
                                          Kuttampuzha
                                        </option>
                                        <option value="Lalam">Lalam</option>
                                        <option value="Mahē">Mahē</option>
                                        <option value="Malappuram">
                                          Malappuram
                                        </option>
                                        <option value="Manjeri">Manjeri</option>
                                        <option value="Manjēshvar">
                                          Manjēshvar
                                        </option>
                                        <option value="Mannarakkat">
                                          Mannarakkat
                                        </option>
                                        <option value="Marayur">Marayur</option>
                                        <option value="Mattanur">
                                          Mattanur
                                        </option>
                                        <option value="Mavelikara">
                                          Mavelikara
                                        </option>
                                        <option value="Mavoor">Mavoor</option>
                                        <option value="Muluppilagadu">
                                          Muluppilagadu
                                        </option>
                                        <option value="Munnar">Munnar</option>
                                        <option value="Muvattupula">
                                          Muvattupula
                                        </option>
                                        <option value="Muvattupuzha">
                                          Muvattupuzha
                                        </option>
                                        <option value="Nadapuram">
                                          Nadapuram
                                        </option>
                                        <option value="Naduvannur">
                                          Naduvannur
                                        </option>
                                        <option value="Nedumangad">
                                          Nedumangad
                                        </option>
                                        <option value="Neyyattinkara">
                                          Neyyattinkara
                                        </option>
                                        <option value="Nilēshwar">
                                          Nilēshwar
                                        </option>
                                        <option value="Ottappalam">
                                          Ottappalam
                                        </option>
                                        <option value="Palackattumala">
                                          Palackattumala
                                        </option>
                                        <option value="Palakkad district">
                                          Palakkad district
                                        </option>
                                        <option value="Palghat">Palghat</option>
                                        <option value="Panamaram">
                                          Panamaram
                                        </option>
                                        <option value="Pappinisshēri">
                                          Pappinisshēri
                                        </option>
                                        <option value="Paravur Tekkumbhagam">
                                          Paravur Tekkumbhagam
                                        </option>
                                        <option value="Pariyapuram">
                                          Pariyapuram
                                        </option>
                                        <option value="Pathanamthitta">
                                          Pathanamthitta
                                        </option>
                                        <option value="Pattanamtitta">
                                          Pattanamtitta
                                        </option>
                                        <option value="Payyannur">
                                          Payyannur
                                        </option>
                                        <option value="Perumbavoor">
                                          Perumbavoor
                                        </option>
                                        <option value="Perumpavur">
                                          Perumpavur
                                        </option>
                                        <option value="Perya">Perya</option>
                                        <option value="Piravam">Piravam</option>
                                        <option value="Ponmana">Ponmana</option>
                                        <option value="Ponnani">Ponnani</option>
                                        <option value="Punalur">Punalur</option>
                                        <option value="Ramamangalam">
                                          Ramamangalam
                                        </option>
                                        <option value="Shertallai">
                                          Shertallai
                                        </option>
                                        <option value="Shōranur">
                                          Shōranur
                                        </option>
                                        <option value="Talipparamba">
                                          Talipparamba
                                        </option>
                                        <option value="Tellicherry">
                                          Tellicherry
                                        </option>
                                        <option value="Thanniyam">
                                          Thanniyam
                                        </option>
                                        <option value="Thiruvananthapuram">
                                          Thiruvananthapuram
                                        </option>
                                        <option value="Thrissur">
                                          Thrissur
                                        </option>
                                        <option value="Thrissur District">
                                          Thrissur District
                                        </option>
                                        <option value="Tirur">Tirur</option>
                                        <option value="Tiruvalla">
                                          Tiruvalla
                                        </option>
                                        <option value="Vaikam">Vaikam</option>
                                        <option value="Varkala">Varkala</option>
                                        <option value="Vayalar">Vayalar</option>
                                        <option value="Vettur">Vettur</option>
                                        <option value="Wayanad">Wayanad</option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Ladakh" && (
                                      <>
                                        <option value="Kargil">Kargil</option>
                                        <option value="Leh">Leh</option>
                                      </>
                                    )}
                                    {shippingAddress.state ===
                                      "Lakshadweep" && (
                                        <>
                                          <option value="Kavaratti">
                                            Kavaratti
                                          </option>
                                          <option value="Lakshadweep">
                                            Lakshadweep
                                          </option>
                                        </>
                                      )}
                                    {shippingAddress.state ===
                                      "Madhya Pradesh" && (
                                        <>
                                          {" "}
                                          <option value="Agar">Agar</option>
                                          <option value="Ajaigarh">
                                            Ajaigarh
                                          </option>
                                          <option value="Akodia">Akodia</option>
                                          <option value="Alampur">Alampur</option>
                                          <option value="Alirajpur">
                                            Alirajpur
                                          </option>
                                          <option value="Alot">Alot</option>
                                          <option value="Amanganj">
                                            Amanganj
                                          </option>
                                          <option value="Amarkantak">
                                            Amarkantak
                                          </option>
                                          <option value="Amarpatan">
                                            Amarpatan
                                          </option>
                                          <option value="Amarwara">
                                            Amarwara
                                          </option>
                                          <option value="Ambah">Ambah</option>
                                          <option value="Amla">Amla</option>
                                          <option value="Anjad">Anjad</option>
                                          <option value="Antri">Antri</option>
                                          <option value="Anuppur">Anuppur</option>
                                          <option value="Aron">Aron</option>
                                          <option value="Ashoknagar">
                                            Ashoknagar
                                          </option>
                                          <option value="Ashta">Ashta</option>
                                          <option value="Babai">Babai</option>
                                          <option value="Badarwas">
                                            Badarwas
                                          </option>
                                          <option value="Badnawar">
                                            Badnawar
                                          </option>
                                          <option value="Bag">Bag</option>
                                          <option value="Bagli">Bagli</option>
                                          <option value="Baihar">Baihar</option>
                                          <option value="Baikunthpur">
                                            Baikunthpur
                                          </option>
                                          <option value="Bakshwaho">
                                            Bakshwaho
                                          </option>
                                          <option value="Balaghat">
                                            Balaghat
                                          </option>
                                          <option value="Baldeogarh">
                                            Baldeogarh
                                          </option>
                                          <option value="Bamna">Bamna</option>
                                          <option value="Bamor Kalan">
                                            Bamor Kalan
                                          </option>
                                          <option value="Bamora">Bamora</option>
                                          <option value="Banda">Banda</option>
                                          <option value="Barela">Barela</option>
                                          <option value="Barghat">Barghat</option>
                                          <option value="Bargi">Bargi</option>
                                          <option value="Barhi">Barhi</option>
                                          <option value="Barwani">Barwani</option>
                                          <option value="Basoda">Basoda</option>
                                          <option value="Begamganj">
                                            Begamganj
                                          </option>
                                          <option value="Beohari">Beohari</option>
                                          <option value="Berasia">Berasia</option>
                                          <option value="Betma">Betma</option>
                                          <option value="Betul">Betul</option>
                                          <option value="Betul Bazar">
                                            Betul Bazar
                                          </option>
                                          <option value="Bhabhra">Bhabhra</option>
                                          <option value="Bhainsdehi">
                                            Bhainsdehi
                                          </option>
                                          <option value="Bhander">Bhander</option>
                                          <option value="Bhanpura">
                                            Bhanpura
                                          </option>
                                          <option value="Bhawaniganj">
                                            Bhawaniganj
                                          </option>
                                          <option value="Bhikangaon">
                                            Bhikangaon
                                          </option>
                                          <option value="Bhind">Bhind</option>
                                          <option value="Bhitarwar">
                                            Bhitarwar
                                          </option>
                                          <option value="Bhopal">Bhopal</option>
                                          <option value="Biaora">Biaora</option>
                                          <option value="Bijawar">Bijawar</option>
                                          <option value="Bijrauni">
                                            Bijrauni
                                          </option>
                                          <option value="Bodri">Bodri</option>
                                          <option value="Burhanpur">
                                            Burhanpur
                                          </option>
                                          <option value="Burhar">Burhar</option>
                                          <option value="Chanderi">
                                            Chanderi
                                          </option>
                                          <option value="Chandia">Chandia</option>
                                          <option value="Chandla">Chandla</option>
                                          <option value="Chhatarpur">
                                            Chhatarpur
                                          </option>
                                          <option value="Chhindwara">
                                            Chhindwara
                                          </option>
                                          <option value="Chichli">Chichli</option>
                                          <option value="Chorhat">Chorhat</option>
                                          <option value="Daboh">Daboh</option>
                                          <option value="Dabra">Dabra</option>
                                          <option value="Damoh">Damoh</option>
                                          <option value="Datia">Datia</option>
                                          <option value="Deori Khas">
                                            Deori Khas
                                          </option>
                                          <option value="Depalpur">
                                            Depalpur
                                          </option>
                                          <option value="Dewas">Dewas</option>
                                          <option value="Dhamnod">Dhamnod</option>
                                          <option value="Dhana">Dhana</option>
                                          <option value="Dhar">Dhar</option>
                                          <option value="Dharampuri">
                                            Dharampuri
                                          </option>
                                          <option value="Dindori">Dindori</option>
                                          <option value="Etawa">Etawa</option>
                                          <option value="Gadarwara">
                                            Gadarwara
                                          </option>
                                          <option value="Garha Brahman">
                                            Garha Brahman
                                          </option>
                                          <option value="Garhakota">
                                            Garhakota
                                          </option>
                                          <option value="Gautampura">
                                            Gautampura
                                          </option>
                                          <option value="Ghansor">Ghansor</option>
                                          <option value="Gogapur">Gogapur</option>
                                          <option value="Gohadi">Gohadi</option>
                                          <option value="Govindgarh">
                                            Govindgarh
                                          </option>
                                          <option value="Guna">Guna</option>
                                          <option value="Gurh">Gurh</option>
                                          <option value="Gwalior">Gwalior</option>
                                          <option value="Harda">Harda</option>
                                          <option value="Harda Khas">
                                            Harda Khas
                                          </option>
                                          <option value="Harpalpur">
                                            Harpalpur
                                          </option>
                                          <option value="Harrai">Harrai</option>
                                          <option value="Harsud">Harsud</option>
                                          <option value="Hatod">Hatod</option>
                                          <option value="Hatta">Hatta</option>
                                          <option value="Hindoria">
                                            Hindoria
                                          </option>
                                          <option value="Hoshangabad">
                                            Hoshangabad
                                          </option>
                                          <option value="Iawar">Iawar</option>
                                          <option value="Ichhawar">
                                            Ichhawar
                                          </option>
                                          <option value="Iklehra">Iklehra</option>
                                          <option value="Indore">Indore</option>
                                          <option value="Isagarh">Isagarh</option>
                                          <option value="Itarsi">Itarsi</option>
                                          <option value="Jabalpur">
                                            Jabalpur
                                          </option>
                                          <option value="Jaisinghnagar">
                                            Jaisinghnagar
                                          </option>
                                          <option value="Jaithari">
                                            Jaithari
                                          </option>
                                          <option value="Jamai">Jamai</option>
                                          <option value="Jaora">Jaora</option>
                                          <option value="Jatara">Jatara</option>
                                          <option value="Jawad">Jawad</option>
                                          <option value="Jhabua">Jhabua</option>
                                          <option value="Jiran">Jiran</option>
                                          <option value="Jobat">Jobat</option>
                                          <option value="Kailaras">
                                            Kailaras
                                          </option>
                                          <option value="Kaimori">Kaimori</option>
                                          <option value="Kannod">Kannod</option>
                                          <option value="Kareli">Kareli</option>
                                          <option value="Karera">Karera</option>
                                          <option value="Karrapur">
                                            Karrapur
                                          </option>
                                          <option value="Kasrawad">
                                            Kasrawad
                                          </option>
                                          <option value="Katangi">Katangi</option>
                                          <option value="Katni">Katni</option>
                                          <option value="Khachrod">
                                            Khachrod
                                          </option>
                                          <option value="Khailar">Khailar</option>
                                          <option value="Khajuraho Group of Monuments">
                                            Khajuraho Group of Monuments
                                          </option>
                                          <option value="Khamaria">
                                            Khamaria
                                          </option>
                                          <option value="Khandwa">Khandwa</option>
                                          <option value="Khandwa district">
                                            Khandwa district
                                          </option>
                                          <option value="Khargapur">
                                            Khargapur
                                          </option>
                                          <option value="Khargone">
                                            Khargone
                                          </option>
                                          <option value="Khategaon">
                                            Khategaon
                                          </option>
                                          <option value="Khilchipur">
                                            Khilchipur
                                          </option>
                                          <option value="Khirkiyan">
                                            Khirkiyan
                                          </option>
                                          <option value="Khujner">Khujner</option>
                                          <option value="Khurai">Khurai</option>
                                          <option value="Kolaras">Kolaras</option>
                                          <option value="Korwai">Korwai</option>
                                          <option value="Kotar">Kotar</option>
                                          <option value="Kothi">Kothi</option>
                                          <option value="Kotma">Kotma</option>
                                          <option value="Kotwa">Kotwa</option>
                                          <option value="Kukshi">Kukshi</option>
                                          <option value="Kumbhraj">
                                            Kumbhraj
                                          </option>
                                          <option value="Lahar">Lahar</option>
                                          <option value="Lakhnadon">
                                            Lakhnadon
                                          </option>
                                          <option value="Leteri">Leteri</option>
                                          <option value="Lodhikheda">
                                            Lodhikheda
                                          </option>
                                          <option value="Machalpur">
                                            Machalpur
                                          </option>
                                          <option value="Madhogarh">
                                            Madhogarh
                                          </option>
                                          <option value="Maheshwar">
                                            Maheshwar
                                          </option>
                                          <option value="Mahgawan">
                                            Mahgawan
                                          </option>
                                          <option value="Maihar">Maihar</option>
                                          <option value="Majholi">Majholi</option>
                                          <option value="Maksi">Maksi</option>
                                          <option value="Malhargarh">
                                            Malhargarh
                                          </option>
                                          <option value="Manasa">Manasa</option>
                                          <option value="Manawar">Manawar</option>
                                          <option value="Mandideep">
                                            Mandideep
                                          </option>
                                          <option value="Mandla">Mandla</option>
                                          <option value="Mandleshwar">
                                            Mandleshwar
                                          </option>
                                          <option value="Mandsaur">
                                            Mandsaur
                                          </option>
                                          <option value="Mangawan">
                                            Mangawan
                                          </option>
                                          <option value="Manpur">Manpur</option>
                                          <option value="Mau">Mau</option>
                                          <option value="Mauganj">Mauganj</option>
                                          <option value="Mihona">Mihona</option>
                                          <option value="Mohgaon">Mohgaon</option>
                                          <option value="Morar">Morar</option>
                                          <option value="Morena">Morena</option>
                                          <option value="Multai">Multai</option>
                                          <option value="Mundi">Mundi</option>
                                          <option value="Mungaoli">
                                            Mungaoli
                                          </option>
                                          <option value="Murwara">Murwara</option>
                                          <option value="Nagda">Nagda</option>
                                          <option value="Nagod">Nagod</option>
                                          <option value="Naigarhi">
                                            Naigarhi
                                          </option>
                                          <option value="Nainpur">Nainpur</option>
                                          <option value="Namli">Namli</option>
                                          <option value="Naraini">Naraini</option>
                                          <option value="Narayangarh">
                                            Narayangarh
                                          </option>
                                          <option value="Narsimhapur">
                                            Narsimhapur
                                          </option>
                                          <option value="Narsinghgarh">
                                            Narsinghgarh
                                          </option>
                                          <option value="Narwar">Narwar</option>
                                          <option value="Nasrullahganj">
                                            Nasrullahganj
                                          </option>
                                          <option value="Neemuch">Neemuch</option>
                                          <option value="Nepanagar">
                                            Nepanagar
                                          </option>
                                          <option value="Orchha">Orchha</option>
                                          <option value="Pachmarhi">
                                            Pachmarhi
                                          </option>
                                          <option value="Palera">Palera</option>
                                          <option value="Pali">Pali</option>
                                          <option value="Panagar">Panagar</option>
                                          <option value="Panara">Panara</option>
                                          <option value="Pandhana">
                                            Pandhana
                                          </option>
                                          <option value="Pandhurna">
                                            Pandhurna
                                          </option>
                                          <option value="Panna">Panna</option>
                                          <option value="Pansemal">
                                            Pansemal
                                          </option>
                                          <option value="Parasia">Parasia</option>
                                          <option value="Patan">Patan</option>
                                          <option value="Patharia">
                                            Patharia
                                          </option>
                                          <option value="Pawai">Pawai</option>
                                          <option value="Petlawad">
                                            Petlawad
                                          </option>
                                          <option value="Piploda">Piploda</option>
                                          <option value="Pithampur">
                                            Pithampur
                                          </option>
                                          <option value="Porsa">Porsa</option>
                                          <option value="Punasa">Punasa</option>
                                          <option value="Raghogarh">
                                            Raghogarh
                                          </option>
                                          <option value="Rahatgarh">
                                            Rahatgarh
                                          </option>
                                          <option value="Raisen">Raisen</option>
                                          <option value="Rajgarh">Rajgarh</option>
                                          <option value="Rajnagar">
                                            Rajnagar
                                          </option>
                                          <option value="Rajpur">Rajpur</option>
                                          <option value="Rampura">Rampura</option>
                                          <option value="Ranapur">Ranapur</option>
                                          <option value="Ratangarh">
                                            Ratangarh
                                          </option>
                                          <option value="Ratlam">Ratlam</option>
                                          <option value="Rehli">Rehli</option>
                                          <option value="Rehti">Rehti</option>
                                          <option value="Rewa">Rewa</option>
                                          <option value="Sabalgarh">
                                            Sabalgarh
                                          </option>
                                          <option value="Sagar">Sagar</option>
                                          <option value="Sailana">Sailana</option>
                                          <option value="Sanawad">Sanawad</option>
                                          <option value="Sanchi">Sanchi</option>
                                          <option value="Sanwer">Sanwer</option>
                                          <option value="Sarangpur">
                                            Sarangpur
                                          </option>
                                          <option value="Satna">Satna</option>
                                          <option value="Satwas">Satwas</option>
                                          <option value="Saugor">Saugor</option>
                                          <option value="Sausar">Sausar</option>
                                          <option value="Sehore">Sehore</option>
                                          <option value="Sendhwa">Sendhwa</option>
                                          <option value="Seondha">Seondha</option>
                                          <option value="Seoni">Seoni</option>
                                          <option value="Seoni Malwa">
                                            Seoni Malwa
                                          </option>
                                          <option value="Shahdol">Shahdol</option>
                                          <option value="Shahgarh">
                                            Shahgarh
                                          </option>
                                          <option value="Shahpur">Shahpur</option>
                                          <option value="Shahpura">
                                            Shahpura
                                          </option>
                                          <option value="Shajapur">
                                            Shajapur
                                          </option>
                                          <option value="Shamgarh">
                                            Shamgarh
                                          </option>
                                          <option value="Sheopur">Sheopur</option>
                                          <option value="Shivpuri">
                                            Shivpuri
                                          </option>
                                          <option value="Shujalpur">
                                            Shujalpur
                                          </option>
                                          <option value="Sidhi">Sidhi</option>
                                          <option value="Sihora">Sihora</option>
                                          <option value="Simaria">Simaria</option>
                                          <option value="Singoli">Singoli</option>
                                          <option value="Singrauli">
                                            Singrauli
                                          </option>
                                          <option value="Sirmaur">Sirmaur</option>
                                          <option value="Sironj">Sironj</option>
                                          <option value="Sitamau">Sitamau</option>
                                          <option value="Sohagi">Sohagi</option>
                                          <option value="Sohagpur">
                                            Sohagpur
                                          </option>
                                          <option value="Sultanpur">
                                            Sultanpur
                                          </option>
                                          <option value="Susner">Susner</option>
                                          <option value="Tal">Tal</option>
                                          <option value="Talen">Talen</option>
                                          <option value="Tarana">Tarana</option>
                                          <option value="Tekanpur">
                                            Tekanpur
                                          </option>
                                          <option value="Tendukheda">
                                            Tendukheda
                                          </option>
                                          <option value="Teonthar">
                                            Teonthar
                                          </option>
                                          <option value="Thandla">Thandla</option>
                                          <option value="Tikamgarh">
                                            Tikamgarh
                                          </option>
                                          <option value="Tirodi">Tirodi</option>
                                          <option value="Udaipura">
                                            Udaipura
                                          </option>
                                          <option value="Ujjain">Ujjain</option>
                                          <option value="Ukwa">Ukwa</option>
                                          <option value="Umaria">Umaria</option>
                                          <option value="Umaria District">
                                            Umaria District
                                          </option>
                                          <option value="Umri">Umri</option>
                                          <option value="Unhel">Unhel</option>
                                          <option value="Vidisha">Vidisha</option>
                                          <option value="Waraseoni">
                                            Waraseoni
                                          </option>
                                        </>
                                      )}
                                    {shippingAddress.state ===
                                      "Maharashtra" && (
                                        <>
                                          <option value="Achalpur">
                                            Achalpur
                                          </option>
                                          <option value="Ahiri">Ahiri</option>
                                          <option value="Ahmadnagar">
                                            Ahmadnagar
                                          </option>
                                          <option value="Ahmadpur">
                                            Ahmadpur
                                          </option>
                                          <option value="Airoli">Airoli</option>
                                          <option value="Ajra">Ajra</option>
                                          <option value="Akalkot">Akalkot</option>
                                          <option value="Akola">Akola</option>
                                          <option value="Akot">Akot</option>
                                          <option value="Alandi">Alandi</option>
                                          <option value="Alibag">Alibag</option>
                                          <option value="Allapalli">
                                            Allapalli
                                          </option>
                                          <option value="Amalner">Amalner</option>
                                          <option value="Amarnath">
                                            Amarnath
                                          </option>
                                          <option value="Ambad">Ambad</option>
                                          <option value="Ambajogai">
                                            Ambajogai
                                          </option>
                                          <option value="Amravati">
                                            Amravati
                                          </option>
                                          <option value="Amravati Division">
                                            Amravati Division
                                          </option>
                                          <option value="Anjangaon">
                                            Anjangaon
                                          </option>
                                          <option value="Anshing">Anshing</option>
                                          <option value="Arangaon">
                                            Arangaon
                                          </option>
                                          <option value="Artist Village">
                                            Artist Village
                                          </option>
                                          <option value="Arvi">Arvi</option>
                                          <option value="Ashta">Ashta</option>
                                          <option value="Ashti">Ashti</option>
                                          <option value="Aurangabad">
                                            Aurangabad
                                          </option>
                                          <option value="Ausa">Ausa</option>
                                          <option value="Badlapur">
                                            Badlapur
                                          </option>
                                          <option value="Balapur">Balapur</option>
                                          <option value="Ballalpur">
                                            Ballalpur
                                          </option>
                                          <option value="Baramati">
                                            Baramati
                                          </option>
                                          <option value="Barsi">Barsi</option>
                                          <option value="Basmat">Basmat</option>
                                          <option value="Beed">Beed</option>
                                          <option value="Bhandara">
                                            Bhandara
                                          </option>
                                          <option value="Bhayandar">
                                            Bhayandar
                                          </option>
                                          <option value="Bhigvan">Bhigvan</option>
                                          <option value="Bhiwandi">
                                            Bhiwandi
                                          </option>
                                          <option value="Bhor">Bhor</option>
                                          <option value="Bhudgaon">
                                            Bhudgaon
                                          </option>
                                          <option value="Bhum">Bhum</option>
                                          <option value="Bhusaval">
                                            Bhusaval
                                          </option>
                                          <option value="Bid">Bid</option>
                                          <option value="Biloli">Biloli</option>
                                          <option value="Boisar">Boisar</option>
                                          <option value="Borivli">Borivli</option>
                                          <option value="Buldana">Buldana</option>
                                          <option value="Chakan">Chakan</option>
                                          <option value="Chalisgaon">
                                            Chalisgaon
                                          </option>
                                          <option value="Chanda">Chanda</option>
                                          <option value="Chandor">Chandor</option>
                                          <option value="Chandrapur">
                                            Chandrapur
                                          </option>
                                          <option value="Chandur">Chandur</option>
                                          <option value="Chandur Bazar">
                                            Chandur Bazar
                                          </option>
                                          <option value="Chicholi">
                                            Chicholi
                                          </option>
                                          <option value="Chikhli">Chikhli</option>
                                          <option value="Chinchani">
                                            Chinchani
                                          </option>
                                          <option value="Chiplun">Chiplun</option>
                                          <option value="Chopda">Chopda</option>
                                          <option value="Dabhol">Dabhol</option>
                                          <option value="Dahanu">Dahanu</option>
                                          <option value="Darwha">Darwha</option>
                                          <option value="Daryapur">
                                            Daryapur
                                          </option>
                                          <option value="Dattapur">
                                            Dattapur
                                          </option>
                                          <option value="Daulatabad">
                                            Daulatabad
                                          </option>
                                          <option value="Daund">Daund</option>
                                          <option value="Dehu">Dehu</option>
                                          <option value="Deolali">Deolali</option>
                                          <option value="Deoli">Deoli</option>
                                          <option value="Deulgaon Raja">
                                            Deulgaon Raja
                                          </option>
                                          <option value="Dharangaon">
                                            Dharangaon
                                          </option>
                                          <option value="Dharmabad">
                                            Dharmabad
                                          </option>
                                          <option value="Dharur">Dharur</option>
                                          <option value="Dhule">Dhule</option>
                                          <option value="Dhulia">Dhulia</option>
                                          <option value="Diglur">Diglur</option>
                                          <option value="Digras">Digras</option>
                                          <option value="Dombivli">
                                            Dombivli
                                          </option>
                                          <option value="Dondaicha">
                                            Dondaicha
                                          </option>
                                          <option value="Dudhani">Dudhani</option>
                                          <option value="Durgapur">
                                            Durgapur
                                          </option>
                                          <option value="Erandol">Erandol</option>
                                          <option value="Faizpur">Faizpur</option>
                                          <option value="Gadchiroli">
                                            Gadchiroli
                                          </option>
                                          <option value="Gadhinglaj">
                                            Gadhinglaj
                                          </option>
                                          <option value="Gangakher">
                                            Gangakher
                                          </option>
                                          <option value="Gangapur">
                                            Gangapur
                                          </option>
                                          <option value="Gevrai">Gevrai</option>
                                          <option value="Ghatanji">
                                            Ghatanji
                                          </option>
                                          <option value="Ghoti Budrukh">
                                            Ghoti Budrukh
                                          </option>
                                          <option value="Ghugus">Ghugus</option>
                                          <option value="Gondiya">Gondiya</option>
                                          <option value="Goregaon">
                                            Goregaon
                                          </option>
                                          <option value="Guhagar">Guhagar</option>
                                          <option value="Hadgaon">Hadgaon</option>
                                          <option value="Harnai">Harnai</option>
                                          <option value="Hinganghat">
                                            Hinganghat
                                          </option>
                                          <option value="Hingoli">Hingoli</option>
                                          <option value="Hirapur Hamesha">
                                            Hirapur Hamesha
                                          </option>
                                          <option value="Ichalkaranji">
                                            Ichalkaranji
                                          </option>
                                          <option value="Igatpuri">
                                            Igatpuri
                                          </option>
                                          <option value="Indapur">Indapur</option>
                                          <option value="Jaisingpur">
                                            Jaisingpur
                                          </option>
                                          <option value="Jalgaon">Jalgaon</option>
                                          <option value="Jalgaon Jamod">
                                            Jalgaon Jamod
                                          </option>
                                          <option value="Jalna">Jalna</option>
                                          <option value="Jawhar">Jawhar</option>
                                          <option value="Jejuri">Jejuri</option>
                                          <option value="Jintur">Jintur</option>
                                          <option value="Junnar">Junnar</option>
                                          <option value="Kagal">Kagal</option>
                                          <option value="Kalamb">Kalamb</option>
                                          <option value="Kalamnuri">
                                            Kalamnuri
                                          </option>
                                          <option value="Kalas">Kalas</option>
                                          <option value="Kalmeshwar">
                                            Kalmeshwar
                                          </option>
                                          <option value="Kalundri">
                                            Kalundri
                                          </option>
                                          <option value="Kalyan">Kalyan</option>
                                          <option value="Kamthi">Kamthi</option>
                                          <option value="Kandri">Kandri</option>
                                          <option value="Kankauli">
                                            Kankauli
                                          </option>
                                          <option value="Kannad">Kannad</option>
                                          <option value="Karad">Karad</option>
                                          <option value="Karanja">Karanja</option>
                                          <option value="Karjat">Karjat</option>
                                          <option value="Karmala">Karmala</option>
                                          <option value="Kati">Kati</option>
                                          <option value="Katol">Katol</option>
                                          <option value="Khadki">Khadki</option>
                                          <option value="Khamgaon">
                                            Khamgaon
                                          </option>
                                          <option value="Khapa">Khapa</option>
                                          <option value="Kharakvasla">
                                            Kharakvasla
                                          </option>
                                          <option value="Khed">Khed</option>
                                          <option value="Khetia">Khetia</option>
                                          <option value="Khopoli">Khopoli</option>
                                          <option value="Khuldabad">
                                            Khuldabad
                                          </option>
                                          <option value="Kinwat">Kinwat</option>
                                          <option value="Kodoli">Kodoli</option>
                                          <option value="Kolhapur">
                                            Kolhapur
                                          </option>
                                          <option value="Kondalwadi">
                                            Kondalwadi
                                          </option>
                                          <option value="Kopargaon">
                                            Kopargaon
                                          </option>
                                          <option value="Koradi">Koradi</option>
                                          <option value="Koregaon">
                                            Koregaon
                                          </option>
                                          <option value="Koynanagar">
                                            Koynanagar
                                          </option>
                                          <option value="Kudal">Kudal</option>
                                          <option value="Kurandvad">
                                            Kurandvad
                                          </option>
                                          <option value="Kurduvadi">
                                            Kurduvadi
                                          </option>
                                          <option value="Lanja">Lanja</option>
                                          <option value="Lasalgaon">
                                            Lasalgaon
                                          </option>
                                          <option value="Latur">Latur</option>
                                          <option value="Lohogaon">
                                            Lohogaon
                                          </option>
                                          <option value="Lonar">Lonar</option>
                                          <option value="Lonavla">Lonavla</option>
                                          <option value="Mahabaleshwar">
                                            Mahabaleshwar
                                          </option>
                                          <option value="Mahad">Mahad</option>
                                          <option value="Maindargi">
                                            Maindargi
                                          </option>
                                          <option value="Majalgaon">
                                            Majalgaon
                                          </option>
                                          <option value="Makhjan">Makhjan</option>
                                          <option value="Malegaon">
                                            Malegaon
                                          </option>
                                          <option value="Malkapur">
                                            Malkapur
                                          </option>
                                          <option value="Malvan">Malvan</option>
                                          <option value="Manchar">Manchar</option>
                                          <option value="Mangrul Pir">
                                            Mangrul Pir
                                          </option>
                                          <option value="Manmad">Manmad</option>
                                          <option value="Manor">Manor</option>
                                          <option value="Mansar">Mansar</option>
                                          <option value="Manwat">Manwat</option>
                                          <option value="Matheran">
                                            Matheran
                                          </option>
                                          <option value="Mehekar">Mehekar</option>
                                          <option value="Mhasla">Mhasla</option>
                                          <option value="Mhasvad">Mhasvad</option>
                                          <option value="Mohpa">Mohpa</option>
                                          <option value="Moram">Moram</option>
                                          <option value="Morsi">Morsi</option>
                                          <option value="Mowad">Mowad</option>
                                          <option value="Mudkhed">Mudkhed</option>
                                          <option value="Mukher">Mukher</option>
                                          <option value="Mul">Mul</option>
                                          <option value="Mumbai">Mumbai</option>
                                          <option value="Mumbai Suburban">
                                            Mumbai Suburban
                                          </option>
                                          <option value="Murbad">Murbad</option>
                                          <option value="Murgud">Murgud</option>
                                          <option value="Murtajapur">
                                            Murtajapur
                                          </option>
                                          <option value="Murud">Murud</option>
                                          <option value="Nagothana">
                                            Nagothana
                                          </option>
                                          <option value="Nagpur">Nagpur</option>
                                          <option value="Nagpur Division">
                                            Nagpur Division
                                          </option>
                                          <option value="Naldurg">Naldurg</option>
                                          <option value="Nanded">Nanded</option>
                                          <option value="Nandgaon">
                                            Nandgaon
                                          </option>
                                          <option value="Nandura Buzurg">
                                            Nandura Buzurg
                                          </option>
                                          <option value="Nandurbar">
                                            Nandurbar
                                          </option>
                                          <option value="Nashik">Nashik</option>
                                          <option value="Nashik Division">
                                            Nashik Division
                                          </option>
                                          <option value="Navi Mumbai">
                                            Navi Mumbai
                                          </option>
                                          <option value="Neral">Neral</option>
                                          <option value="Nilanga">Nilanga</option>
                                          <option value="Nipani">Nipani</option>
                                          <option value="Osmanabad">
                                            Osmanabad
                                          </option>
                                          <option value="Ozar">Ozar</option>
                                          <option value="Pachora">Pachora</option>
                                          <option value="Paithan">Paithan</option>
                                          <option value="Palghar">Palghar</option>
                                          <option value="Panchgani">
                                            Panchgani
                                          </option>
                                          <option value="Pandharpur">
                                            Pandharpur
                                          </option>
                                          <option value="Panhala">Panhala</option>
                                          <option value="Panvel">Panvel</option>
                                          <option value="Parbhani">
                                            Parbhani
                                          </option>
                                          <option value="Parli Vaijnath">
                                            Parli Vaijnath
                                          </option>
                                          <option value="Parola">Parola</option>
                                          <option value="Partur">Partur</option>
                                          <option value="Patan">Patan</option>
                                          <option value="Pathardi">
                                            Pathardi
                                          </option>
                                          <option value="Pathri">Pathri</option>
                                          <option value="Patur">Patur</option>
                                          <option value="Pawni">Pawni</option>
                                          <option value="Pen">Pen</option>
                                          <option value="Phaltan">Phaltan</option>
                                          <option value="Pimpri">Pimpri</option>
                                          <option value="Pipri">Pipri</option>
                                          <option value="Powai">Powai</option>
                                          <option value="Pulgaon">Pulgaon</option>
                                          <option value="Pune">Pune</option>
                                          <option value="Pune Division">
                                            Pune Division
                                          </option>
                                          <option value="Purna">Purna</option>
                                          <option value="Pusad">Pusad</option>
                                          <option value="Rahimatpur">
                                            Rahimatpur
                                          </option>
                                          <option value="Rahuri">Rahuri</option>
                                          <option value="Raigarh">Raigarh</option>
                                          <option value="Rajapur">Rajapur</option>
                                          <option value="Rajgurunagar">
                                            Rajgurunagar
                                          </option>
                                          <option value="Rajur">Rajur</option>
                                          <option value="Rajura">Rajura</option>
                                          <option value="Ramtek">Ramtek</option>
                                          <option value="Ratnagiri">
                                            Ratnagiri
                                          </option>
                                          <option value="Raver">Raver</option>
                                          <option value="Revadanda">
                                            Revadanda
                                          </option>
                                          <option value="Risod">Risod</option>
                                          <option value="Roha">Roha</option>
                                          <option value="Sangamner">
                                            Sangamner
                                          </option>
                                          <option value="Sangli">Sangli</option>
                                          <option value="Sangola">Sangola</option>
                                          <option value="Saoner">Saoner</option>
                                          <option value="Sasvad">Sasvad</option>
                                          <option value="Satana">Satana</option>
                                          <option value="Satara">Satara</option>
                                          <option value="Satara Division">
                                            Satara Division
                                          </option>
                                          <option value="Savantvadi">
                                            Savantvadi
                                          </option>
                                          <option value="Savda">Savda</option>
                                          <option value="Selu">Selu</option>
                                          <option value="Shahada">Shahada</option>
                                          <option value="Shahapur">
                                            Shahapur
                                          </option>
                                          <option value="Shegaon">Shegaon</option>
                                          <option value="Shiraguppi">
                                            Shiraguppi
                                          </option>
                                          <option value="Shirdi">Shirdi</option>
                                          <option value="Shirgaon">
                                            Shirgaon
                                          </option>
                                          <option value="Shirpur">Shirpur</option>
                                          <option value="Shirwal">Shirwal</option>
                                          <option value="Shivaji Nagar">
                                            Shivaji Nagar
                                          </option>
                                          <option value="Shrigonda">
                                            Shrigonda
                                          </option>
                                          <option value="Sillod">Sillod</option>
                                          <option value="Sindhudurg">
                                            Sindhudurg
                                          </option>
                                          <option value="Sindi">Sindi</option>
                                          <option value="Sinnar">Sinnar</option>
                                          <option value="Sirur">Sirur</option>
                                          <option value="Solapur">Solapur</option>
                                          <option value="Sonegaon">
                                            Sonegaon
                                          </option>
                                          <option value="Soygaon">Soygaon</option>
                                          <option value="Srivardhan">
                                            Srivardhan
                                          </option>
                                          <option value="Surgana">Surgana</option>
                                          <option value="Talegaon Dabhade">
                                            Talegaon Dabhade
                                          </option>
                                          <option value="Taloda">Taloda</option>
                                          <option value="Tarapur">Tarapur</option>
                                          <option value="Tasgaon">Tasgaon</option>
                                          <option value="Telhara">Telhara</option>
                                          <option value="Thane">Thane</option>
                                          <option value="Trimbak">Trimbak</option>
                                          <option value="Tuljapur">
                                            Tuljapur
                                          </option>
                                          <option value="Tumsar">Tumsar</option>
                                          <option value="Udgir">Udgir</option>
                                          <option value="Ulhasnagar">
                                            Ulhasnagar
                                          </option>
                                          <option value="Umarga">Umarga</option>
                                          <option value="Umarkhed">
                                            Umarkhed
                                          </option>
                                          <option value="Umred">Umred</option>
                                          <option value="Uran">Uran</option>
                                          <option value="Vada">Vada</option>
                                          <option value="Vaijapur">
                                            Vaijapur
                                          </option>
                                          <option value="Varangaon">
                                            Varangaon
                                          </option>
                                          <option value="Vasind">Vasind</option>
                                          <option value="Vengurla">
                                            Vengurla
                                          </option>
                                          <option value="Virar">Virar</option>
                                          <option value="Vite">Vite</option>
                                          <option value="Wadgaon">Wadgaon</option>
                                          <option value="Wai">Wai</option>
                                          <option value="Wani">Wani</option>
                                          <option value="Wardha">Wardha</option>
                                          <option value="Warora">Warora</option>
                                          <option value="Warud">Warud</option>
                                          <option value="Washim">Washim</option>
                                          <option value="Yaval">Yaval</option>
                                          <option value="Yavatmal">
                                            Yavatmal
                                          </option>
                                          <option value="Yeola">Yeola</option>
                                        </>
                                      )}
                                    {shippingAddress.state === "Manipur" && (
                                      <>
                                        <option value="Bishnupur">
                                          Bishnupur
                                        </option>
                                        <option value="Churachandpur">
                                          Churachandpur
                                        </option>
                                        <option value="Imphal">Imphal</option>
                                        <option value="Kakching">
                                          Kakching
                                        </option>
                                        <option value="Mayang Imphal">
                                          Mayang Imphal
                                        </option>
                                        <option value="Moirang">Moirang</option>
                                        <option value="Phek">Phek</option>
                                        <option value="Senapati">
                                          Senapati
                                        </option>
                                        <option value="Tamenglong">
                                          Tamenglong
                                        </option>
                                        <option value="Thoubal">Thoubal</option>
                                        <option value="Ukhrul">Ukhrul</option>
                                        <option value="Wangjing">
                                          Wangjing
                                        </option>
                                        <option value="Yairipok">
                                          Yairipok
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Meghalaya" && (
                                      <>
                                        <option value="Cherrapunji">
                                          Cherrapunji
                                        </option>
                                        <option value="East Garo Hills">
                                          East Garo Hills
                                        </option>
                                        <option value="East Jaintia Hills">
                                          East Jaintia Hills
                                        </option>
                                        <option value="East Khasi Hills">
                                          East Khasi Hills
                                        </option>
                                        <option value="Mairang">Mairang</option>
                                        <option value="Mankachar">
                                          Mankachar
                                        </option>
                                        <option value="Nongpoh">Nongpoh</option>
                                        <option value="Nongstoin">
                                          Nongstoin
                                        </option>
                                        <option value="North Garo Hills">
                                          North Garo Hills
                                        </option>
                                        <option value="Ri-Bhoi">Ri-Bhoi</option>
                                        <option value="Shillong">
                                          Shillong
                                        </option>
                                        <option value="South Garo Hills">
                                          South Garo Hills
                                        </option>
                                        <option value="South West Garo Hills">
                                          South West Garo Hills
                                        </option>
                                        <option value="South West Khasi Hills">
                                          South West Khasi Hills
                                        </option>
                                        <option value="Tura">Tura</option>
                                        <option value="West Garo Hills">
                                          West Garo Hills
                                        </option>
                                        <option value="West Jaintia Hills">
                                          West Jaintia Hills
                                        </option>
                                        <option value="West Khasi Hills">
                                          West Khasi Hills
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Mizoram" && (
                                      <>
                                        <option value="Aizawl">Aizawl</option>
                                        <option value="Champhai">
                                          Champhai
                                        </option>
                                        <option value="Darlawn">Darlawn</option>
                                        <option value="Khawhai">Khawhai</option>
                                        <option value="Kolasib">Kolasib</option>
                                        <option value="Kolasib district">
                                          Kolasib district
                                        </option>
                                        <option value="Lawngtlai">
                                          Lawngtlai
                                        </option>
                                        <option value="Lunglei">Lunglei</option>
                                        <option value="Mamit">Mamit</option>
                                        <option value="North Vanlaiphai">
                                          North Vanlaiphai
                                        </option>
                                        <option value="Saiha">Saiha</option>
                                        <option value="Sairang">Sairang</option>
                                        <option value="Saitlaw">Saitlaw</option>
                                        <option value="Serchhip">
                                          Serchhip
                                        </option>
                                        <option value="Thenzawl">
                                          Thenzawl
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Nagaland" && (
                                      <>
                                        <option value="Dimapur">Dimapur</option>
                                        <option value="Kohima">Kohima</option>
                                        <option value="Mokokchung">
                                          Mokokchung
                                        </option>
                                        <option value="Mon">Mon</option>
                                        <option value="Peren">Peren</option>
                                        <option value="Phek">Phek</option>
                                        <option value="Tuensang">
                                          Tuensang
                                        </option>
                                        <option value="Tuensang District">
                                          Tuensang District
                                        </option>
                                        <option value="Wokha">Wokha</option>
                                        <option value="Zunheboto">
                                          Zunheboto
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Odisha" && (
                                      <>
                                        <option value="Angul">Angul</option>
                                        <option value="Angul District">
                                          Angul District
                                        </option>
                                        <option value="Asika">Asika</option>
                                        <option value="Athagarh">
                                          Athagarh
                                        </option>
                                        <option value="Bada Barabil">
                                          Bada Barabil
                                        </option>
                                        <option value="Balangir">
                                          Balangir
                                        </option>
                                        <option value="Balasore">
                                          Balasore
                                        </option>
                                        <option value="Baleshwar">
                                          Baleshwar
                                        </option>
                                        <option value="Balimila">
                                          Balimila
                                        </option>
                                        <option value="Balugaon">
                                          Balugaon
                                        </option>
                                        <option value="Banapur">Banapur</option>
                                        <option value="Banki">Banki</option>
                                        <option value="Banposh">Banposh</option>
                                        <option value="Baragarh">
                                          Baragarh
                                        </option>
                                        <option value="Barbil">Barbil</option>
                                        <option value="Bargarh">Bargarh</option>
                                        <option value="Barpali">Barpali</option>
                                        <option value="Basudebpur">
                                          Basudebpur
                                        </option>
                                        <option value="Baud">Baud</option>
                                        <option value="Baudh">Baudh</option>
                                        <option value="Belaguntha">
                                          Belaguntha
                                        </option>
                                        <option value="Bhadrak">Bhadrak</option>
                                        <option value="Bhadrakh">
                                          Bhadrakh
                                        </option>
                                        <option value="Bhanjanagar">
                                          Bhanjanagar
                                        </option>
                                        <option value="Bhawanipatna">
                                          Bhawanipatna
                                        </option>
                                        <option value="Bhuban">Bhuban</option>
                                        <option value="Bhubaneshwar">
                                          Bhubaneshwar
                                        </option>
                                        <option value="Binka">Binka</option>
                                        <option value="Birmitrapur">
                                          Birmitrapur
                                        </option>
                                        <option value="Bolanikhodan">
                                          Bolanikhodan
                                        </option>
                                        <option value="Brahmapur">
                                          Brahmapur
                                        </option>
                                        <option value="Brajarajnagar">
                                          Brajarajnagar
                                        </option>
                                        <option value="Buguda">Buguda</option>
                                        <option value="Burla">Burla</option>
                                        <option value="Champua">Champua</option>
                                        <option value="Chandbali">
                                          Chandbali
                                        </option>
                                        <option value="Chatrapur">
                                          Chatrapur
                                        </option>
                                        <option value="Chikitigarh">
                                          Chikitigarh
                                        </option>
                                        <option value="Chittarkonda">
                                          Chittarkonda
                                        </option>
                                        <option value="Cuttack">Cuttack</option>
                                        <option value="Daitari">Daitari</option>
                                        <option value="Deogarh">Deogarh</option>
                                        <option value="Dhenkanal">
                                          Dhenkanal
                                        </option>
                                        <option value="Digapahandi">
                                          Digapahandi
                                        </option>
                                        <option value="Gajapati">
                                          Gajapati
                                        </option>
                                        <option value="Ganjam">Ganjam</option>
                                        <option value="Gopalpur">
                                          Gopalpur
                                        </option>
                                        <option value="Gudari">Gudari</option>
                                        <option value="Gunupur">Gunupur</option>
                                        <option value="Hinjilikatu">
                                          Hinjilikatu
                                        </option>
                                        <option value="Hirakud">Hirakud</option>
                                        <option value="Jagatsinghapur">
                                          Jagatsinghapur
                                        </option>
                                        <option value="Jagatsinghpur">
                                          Jagatsinghpur
                                        </option>
                                        <option value="Jajpur">Jajpur</option>
                                        <option value="Jaleshwar">
                                          Jaleshwar
                                        </option>
                                        <option value="Jatani">Jatani</option>
                                        <option value="Jeypore">Jeypore</option>
                                        <option value="Jharsuguda">
                                          Jharsuguda
                                        </option>
                                        <option value="Jharsuguda District">
                                          Jharsuguda District
                                        </option>
                                        <option value="Kaintragarh">
                                          Kaintragarh
                                        </option>
                                        <option value="Kalahandi">
                                          Kalahandi
                                        </option>
                                        <option value="Kamakhyanagar">
                                          Kamakhyanagar
                                        </option>
                                        <option value="Kandhamal">
                                          Kandhamal
                                        </option>
                                        <option value="Kantabanji">
                                          Kantabanji
                                        </option>
                                        <option value="Kantilo">Kantilo</option>
                                        <option value="Kendrapara">
                                          Kendrapara
                                        </option>
                                        <option value="Kendraparha">
                                          Kendraparha
                                        </option>
                                        <option value="Kendujhar">
                                          Kendujhar
                                        </option>
                                        <option value="Kesinga">Kesinga</option>
                                        <option value="Khallikot">
                                          Khallikot
                                        </option>
                                        <option value="Kharhial">
                                          Kharhial
                                        </option>
                                        <option value="Khordha">Khordha</option>
                                        <option value="Khurda">Khurda</option>
                                        <option value="Kiri Buru">
                                          Kiri Buru
                                        </option>
                                        <option value="Kodala">Kodala</option>
                                        <option value="Konarka">Konarka</option>
                                        <option value="Koraput">Koraput</option>
                                        <option value="Kuchaiburi">
                                          Kuchaiburi
                                        </option>
                                        <option value="Kuchinda">
                                          Kuchinda
                                        </option>
                                        <option value="Malakanagiri">
                                          Malakanagiri
                                        </option>
                                        <option value="Malkangiri">
                                          Malkangiri
                                        </option>
                                        <option value="Mayurbhanj">
                                          Mayurbhanj
                                        </option>
                                        <option value="Nabarangpur">
                                          Nabarangpur
                                        </option>
                                        <option value="Nayagarh">
                                          Nayagarh
                                        </option>
                                        <option value="Nayagarh District">
                                          Nayagarh District
                                        </option>
                                        <option value="Nilgiri">Nilgiri</option>
                                        <option value="Nimaparha">
                                          Nimaparha
                                        </option>
                                        <option value="Nowrangapur">
                                          Nowrangapur
                                        </option>
                                        <option value="Nuapada">Nuapada</option>
                                        <option value="Padampur">
                                          Padampur
                                        </option>
                                        <option value="Paradip Garh">
                                          Paradip Garh
                                        </option>
                                        <option value="Patamundai">
                                          Patamundai
                                        </option>
                                        <option value="Patnagarh">
                                          Patnagarh
                                        </option>
                                        <option value="Phulbani">
                                          Phulbani
                                        </option>
                                        <option value="Pipili">Pipili</option>
                                        <option value="Polasara">
                                          Polasara
                                        </option>
                                        <option value="Puri">Puri</option>
                                        <option value="Purushottampur">
                                          Purushottampur
                                        </option>
                                        <option value="Rambha">Rambha</option>
                                        <option value="Raurkela">
                                          Raurkela
                                        </option>
                                        <option value="Rayagada">
                                          Rayagada
                                        </option>
                                        <option value="Remuna">Remuna</option>
                                        <option value="Rengali">Rengali</option>
                                        <option value="Sambalpur">
                                          Sambalpur
                                        </option>
                                        <option value="Sonepur">Sonepur</option>
                                        <option value="Sorada">Sorada</option>
                                        <option value="Soro">Soro</option>
                                        <option value="Subarnapur">
                                          Subarnapur
                                        </option>
                                        <option value="Sundargarh">
                                          Sundargarh
                                        </option>
                                        <option value="Talcher">Talcher</option>
                                        <option value="Tarabha">Tarabha</option>
                                        <option value="Titlagarh">
                                          Titlagarh
                                        </option>
                                        <option value="Udayagiri">
                                          Udayagiri
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Puducherry" && (
                                      <>
                                        <option value="Karaikal">
                                          Karaikal
                                        </option>
                                        <option value="Mahe">Mahe</option>
                                        <option value="Puducherry">
                                          Puducherry
                                        </option>
                                        <option value="Yanam">Yanam</option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Punjab" && (
                                      <>
                                        <option value="Abohar">Abohar</option>
                                        <option value="Adampur">Adampur</option>
                                        <option value="Ajitgarh">
                                          Ajitgarh
                                        </option>
                                        <option value="Ajnala">Ajnala</option>
                                        <option value="Akalgarh">
                                          Akalgarh
                                        </option>
                                        <option value="Alawalpur">
                                          Alawalpur
                                        </option>
                                        <option value="Amloh">Amloh</option>
                                        <option value="Amritsar">
                                          Amritsar
                                        </option>
                                        <option value="Anandpur Sahib">
                                          Anandpur Sahib
                                        </option>
                                        <option value="Badhni Kalan">
                                          Badhni Kalan
                                        </option>
                                        <option value="Bagha Purana">
                                          Bagha Purana
                                        </option>
                                        <option value="Bakloh">Bakloh</option>
                                        <option value="Balachor">
                                          Balachor
                                        </option>
                                        <option value="Banga">Banga</option>
                                        <option value="Banur">Banur</option>
                                        <option value="Barnala">Barnala</option>
                                        <option value="Batala">Batala</option>
                                        <option value="Begowal">Begowal</option>
                                        <option value="Bhadaur">Bhadaur</option>
                                        <option value="Bhatinda">
                                          Bhatinda
                                        </option>
                                        <option value="Bhawanigarh">
                                          Bhawanigarh
                                        </option>
                                        <option value="Bhikhi">Bhikhi</option>
                                        <option value="Bhogpur">Bhogpur</option>
                                        <option value="Bholath">Bholath</option>
                                        <option value="Budhlada">
                                          Budhlada
                                        </option>
                                        <option value="Chima">Chima</option>
                                        <option value="Dasuya">Dasuya</option>
                                        <option value="Dera Baba Nanak">
                                          Dera Baba Nanak
                                        </option>
                                        <option value="Dera Bassi">
                                          Dera Bassi
                                        </option>
                                        <option value="Dhanaula">
                                          Dhanaula
                                        </option>
                                        <option value="Dhariwal">
                                          Dhariwal
                                        </option>
                                        <option value="Dhilwan">Dhilwan</option>
                                        <option value="Dhudi">Dhudi</option>
                                        <option value="Dhuri">Dhuri</option>
                                        <option value="Dina Nagar">
                                          Dina Nagar
                                        </option>
                                        <option value="Dirba">Dirba</option>
                                        <option value="Doraha">Doraha</option>
                                        <option value="Faridkot">
                                          Faridkot
                                        </option>
                                        <option value="Fatehgarh Churian">
                                          Fatehgarh Churian
                                        </option>
                                        <option value="Fatehgarh Sahib">
                                          Fatehgarh Sahib
                                        </option>
                                        <option value="Fazilka">Fazilka</option>
                                        <option value="Firozpur">
                                          Firozpur
                                        </option>
                                        <option value="Firozpur District">
                                          Firozpur District
                                        </option>
                                        <option value="Gardhiwala">
                                          Gardhiwala
                                        </option>
                                        <option value="Garhshankar">
                                          Garhshankar
                                        </option>
                                        <option value="Ghanaur">Ghanaur</option>
                                        <option value="Giddarbaha">
                                          Giddarbaha
                                        </option>
                                        <option value="Gurdaspur">
                                          Gurdaspur
                                        </option>
                                        <option value="Guru Har Sahai">
                                          Guru Har Sahai
                                        </option>
                                        <option value="Hajipur">Hajipur</option>
                                        <option value="Hariana">Hariana</option>
                                        <option value="Hoshiarpur">
                                          Hoshiarpur
                                        </option>
                                        <option value="Ishanpur">
                                          Ishanpur
                                        </option>
                                        <option value="Jagraon">Jagraon</option>
                                        <option value="Jaito">Jaito</option>
                                        <option value="Jalalabad">
                                          Jalalabad
                                        </option>
                                        <option value="Jalandhar">
                                          Jalandhar
                                        </option>
                                        <option value="Jandiala">
                                          Jandiala
                                        </option>
                                        <option value="Jandiala Guru">
                                          Jandiala Guru
                                        </option>
                                        <option value="Kalanaur">
                                          Kalanaur
                                        </option>
                                        <option value="Kapurthala">
                                          Kapurthala
                                        </option>
                                        <option value="Kartarpur">
                                          Kartarpur
                                        </option>
                                        <option value="Khamanon">
                                          Khamanon
                                        </option>
                                        <option value="Khanna">Khanna</option>
                                        <option value="Kharar">Kharar</option>
                                        <option value="Khemkaran">
                                          Khemkaran
                                        </option>
                                        <option value="Kot Isa Khan">
                                          Kot Isa Khan
                                        </option>
                                        <option value="Kotkapura">
                                          Kotkapura
                                        </option>
                                        <option value="Laungowal">
                                          Laungowal
                                        </option>
                                        <option value="Ludhiana">
                                          Ludhiana
                                        </option>
                                        <option value="Machhiwara">
                                          Machhiwara
                                        </option>
                                        <option value="Majitha">Majitha</option>
                                        <option value="Makhu">Makhu</option>
                                        <option value="Malaut">Malaut</option>
                                        <option value="Malerkotla">
                                          Malerkotla
                                        </option>
                                        <option value="Mansa">Mansa</option>
                                        <option value="Maur Mandi">
                                          Maur Mandi
                                        </option>
                                        <option value="Moga">Moga</option>
                                        <option value="Mohali">Mohali</option>
                                        <option value="Morinda">Morinda</option>
                                        <option value="Mukerian">
                                          Mukerian
                                        </option>
                                        <option value="Nabha">Nabha</option>
                                        <option value="Nakodar">Nakodar</option>
                                        <option value="Nangal">Nangal</option>
                                        <option value="Nawanshahr">
                                          Nawanshahr
                                        </option>
                                        <option value="Nurmahal">
                                          Nurmahal
                                        </option>
                                        <option value="Nurpur Kalan">
                                          Nurpur Kalan
                                        </option>
                                        <option value="Pathankot">
                                          Pathankot
                                        </option>
                                        <option value="Patiala">Patiala</option>
                                        <option value="Patti">Patti</option>
                                        <option value="Phagwara">
                                          Phagwara
                                        </option>
                                        <option value="Phillaur">
                                          Phillaur
                                        </option>
                                        <option value="Qadian">Qadian</option>
                                        <option value="Rahon">Rahon</option>
                                        <option value="Raikot">Raikot</option>
                                        <option value="Rajasansi">
                                          Rajasansi
                                        </option>
                                        <option value="Rajpura">Rajpura</option>
                                        <option value="Ram Das">Ram Das</option>
                                        <option value="Rampura">Rampura</option>
                                        <option value="Rupnagar">
                                          Rupnagar
                                        </option>
                                        <option value="Samrala">Samrala</option>
                                        <option value="Sanaur">Sanaur</option>
                                        <option value="Sangrur">Sangrur</option>
                                        <option value="Sardulgarh">
                                          Sardulgarh
                                        </option>
                                        <option value="Shahid Bhagat Singh Nagar">
                                          Shahid Bhagat Singh Nagar
                                        </option>
                                        <option value="Shahkot">Shahkot</option>
                                        <option value="Sham Churasi">
                                          Sham Churasi
                                        </option>
                                        <option value="Sirhind-Fategarh">
                                          Sirhind-Fategarh
                                        </option>
                                        <option value="Sri Muktsar Sahib">
                                          Sri Muktsar Sahib
                                        </option>
                                        <option value="Sultanpur Lodhi">
                                          Sultanpur Lodhi
                                        </option>
                                        <option value="Sunam">Sunam</option>
                                        <option value="Talwandi Bhai">
                                          Talwandi Bhai
                                        </option>
                                        <option value="Talwara">Talwara</option>
                                        <option value="Tarn Taran Sahib">
                                          Tarn Taran Sahib
                                        </option>
                                        <option value="Zira">Zira</option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Rajasthan" && (
                                      <>
                                        <option value="Abhaneri">
                                          Abhaneri
                                        </option>
                                        <option value="Abu">Abu</option>
                                        <option value="Abu Road">
                                          Abu Road
                                        </option>
                                        <option value="Ajmer">Ajmer</option>
                                        <option value="Aklera">Aklera</option>
                                        <option value="Alwar">Alwar</option>
                                        <option value="Amet">Amet</option>
                                        <option value="Anta">Anta</option>
                                        <option value="Anupgarh">
                                          Anupgarh
                                        </option>
                                        <option value="Asind">Asind</option>
                                        <option value="Bagar">Bagar</option>
                                        <option value="Bakani">Bakani</option>
                                        <option value="Bali">Bali</option>
                                        <option value="Balotra">Balotra</option>
                                        <option value="Bandikui">
                                          Bandikui
                                        </option>
                                        <option value="Banswara">
                                          Banswara
                                        </option>
                                        <option value="Baran">Baran</option>
                                        <option value="Bari">Bari</option>
                                        <option value="Bari Sadri">
                                          Bari Sadri
                                        </option>
                                        <option value="Barmer">Barmer</option>
                                        <option value="Basi">Basi</option>
                                        <option value="Basni">Basni</option>
                                        <option value="Baswa">Baswa</option>
                                        <option value="Bayana">Bayana</option>
                                        <option value="Beawar">Beawar</option>
                                        <option value="Begun">Begun</option>
                                        <option value="Behror">Behror</option>
                                        <option value="Bhadasar">
                                          Bhadasar
                                        </option>
                                        <option value="Bhadra">Bhadra</option>
                                        <option value="Bharatpur">
                                          Bharatpur
                                        </option>
                                        <option value="Bhasawar">
                                          Bhasawar
                                        </option>
                                        <option value="Bhilwara">
                                          Bhilwara
                                        </option>
                                        <option value="Bhindar">Bhindar</option>
                                        <option value="Bhinmal">Bhinmal</option>
                                        <option value="Bhiwadi">Bhiwadi</option>
                                        <option value="Bhuma">Bhuma</option>
                                        <option value="Bikaner">Bikaner</option>
                                        <option value="Bilara">Bilara</option>
                                        <option value="Bissau">Bissau</option>
                                        <option value="Borkhera">
                                          Borkhera
                                        </option>
                                        <option value="Bundi">Bundi</option>
                                        <option value="Chaksu">Chaksu</option>
                                        <option value="Chechat">Chechat</option>
                                        <option value="Chhabra">Chhabra</option>
                                        <option value="Chhapar">Chhapar</option>
                                        <option value="Chhoti Sadri">
                                          Chhoti Sadri
                                        </option>
                                        <option value="Chidawa">Chidawa</option>
                                        <option value="Chittaurgarh">
                                          Chittaurgarh
                                        </option>
                                        <option value="Churu">Churu</option>
                                        <option value="Dariba">Dariba</option>
                                        <option value="Dausa">Dausa</option>
                                        <option value="Deoli">Deoli</option>
                                        <option value="Deshnoke">
                                          Deshnoke
                                        </option>
                                        <option value="Devgarh">Devgarh</option>
                                        <option value="Dhaulpur">
                                          Dhaulpur
                                        </option>
                                        <option value="Didwana">Didwana</option>
                                        <option value="Dig">Dig</option>
                                        <option value="Dungarpur">
                                          Dungarpur
                                        </option>
                                        <option value="Fatehpur">
                                          Fatehpur
                                        </option>
                                        <option value="Galiakot">
                                          Galiakot
                                        </option>
                                        <option value="Ganganagar">
                                          Ganganagar
                                        </option>
                                        <option value="Gangapur">
                                          Gangapur
                                        </option>
                                        <option value="Govindgarh">
                                          Govindgarh
                                        </option>
                                        <option value="Gulabpura">
                                          Gulabpura
                                        </option>
                                        <option value="Hanumangarh">
                                          Hanumangarh
                                        </option>
                                        <option value="Hindaun">Hindaun</option>
                                        <option value="Jahazpur">
                                          Jahazpur
                                        </option>
                                        <option value="Jaipur">Jaipur</option>
                                        <option value="Jaisalmer">
                                          Jaisalmer
                                        </option>
                                        <option value="Jaitaran">
                                          Jaitaran
                                        </option>
                                        <option value="Jalor">Jalor</option>
                                        <option value="Jalore">Jalore</option>
                                        <option value="Jhalawar">
                                          Jhalawar
                                        </option>
                                        <option value="Jhalrapatan">
                                          Jhalrapatan
                                        </option>
                                        <option value="Jhunjhunun">
                                          Jhunjhunun
                                        </option>
                                        <option value="Jobner">Jobner</option>
                                        <option value="Jodhpur">Jodhpur</option>
                                        <option value="Kaman">Kaman</option>
                                        <option value="Kanor">Kanor</option>
                                        <option value="Kapren">Kapren</option>
                                        <option value="Karanpur">
                                          Karanpur
                                        </option>
                                        <option value="Karauli">Karauli</option>
                                        <option value="Kekri">Kekri</option>
                                        <option value="Keshorai Patan">
                                          Keshorai Patan
                                        </option>
                                        <option value="Khandela">
                                          Khandela
                                        </option>
                                        <option value="Khanpur">Khanpur</option>
                                        <option value="Khetri">Khetri</option>
                                        <option value="Kishangarh">
                                          Kishangarh
                                        </option>
                                        <option value="Kota">Kota</option>
                                        <option value="Kotputli">
                                          Kotputli
                                        </option>
                                        <option value="Kuchaman">
                                          Kuchaman
                                        </option>
                                        <option value="Kuchera">Kuchera</option>
                                        <option value="Kumher">Kumher</option>
                                        <option value="Kushalgarh">
                                          Kushalgarh
                                        </option>
                                        <option value="Lachhmangarh Sikar">
                                          Lachhmangarh Sikar
                                        </option>
                                        <option value="Ladnun">Ladnun</option>
                                        <option value="Lakheri">Lakheri</option>
                                        <option value="Lalsot">Lalsot</option>
                                        <option value="Losal">Losal</option>
                                        <option value="Mahwah">Mahwah</option>
                                        <option value="Makrana">Makrana</option>
                                        <option value="Malpura">Malpura</option>
                                        <option value="Mandal">Mandal</option>
                                        <option value="Mandalgarh">
                                          Mandalgarh
                                        </option>
                                        <option value="Mandawar">
                                          Mandawar
                                        </option>
                                        <option value="Mangrol">Mangrol</option>
                                        <option value="Manohar Thana">
                                          Manohar Thana
                                        </option>
                                        <option value="Manoharpur">
                                          Manoharpur
                                        </option>
                                        <option value="Meethari Marwar">
                                          Meethari Marwar
                                        </option>
                                        <option value="Merta">Merta</option>
                                        <option value="Mundwa">Mundwa</option>
                                        <option value="Nadbai">Nadbai</option>
                                        <option value="Nagar">Nagar</option>
                                        <option value="Nagaur">Nagaur</option>
                                        <option value="Nainwa">Nainwa</option>
                                        <option value="Napasar">Napasar</option>
                                        <option value="Naraina">Naraina</option>
                                        <option value="Nasirabad">
                                          Nasirabad
                                        </option>
                                        <option value="Nathdwara">
                                          Nathdwara
                                        </option>
                                        <option value="Nawa">Nawa</option>
                                        <option value="Nawalgarh">
                                          Nawalgarh
                                        </option>
                                        <option value="Neem ka Thana">
                                          Neem ka Thana
                                        </option>
                                        <option value="Nimaj">Nimaj</option>
                                        <option value="Nimbahera">
                                          Nimbahera
                                        </option>
                                        <option value="Niwai">Niwai</option>
                                        <option value="Nohar">Nohar</option>
                                        <option value="Nokha">Nokha</option>
                                        <option value="Padampur">
                                          Padampur
                                        </option>
                                        <option value="Pali">Pali</option>
                                        <option value="Partapur">
                                          Partapur
                                        </option>
                                        <option value="Parvatsar">
                                          Parvatsar
                                        </option>
                                        <option value="Phalodi">Phalodi</option>
                                        <option value="Phulera">Phulera</option>
                                        <option value="Pilani">Pilani</option>
                                        <option value="Pilibangan">
                                          Pilibangan
                                        </option>
                                        <option value="Pindwara">
                                          Pindwara
                                        </option>
                                        <option value="Pipar">Pipar</option>
                                        <option value="Pirawa">Pirawa</option>
                                        <option value="Pokaran">Pokaran</option>
                                        <option value="Pratapgarh">
                                          Pratapgarh
                                        </option>
                                        <option value="Pushkar">Pushkar</option>
                                        <option value="Raipur">Raipur</option>
                                        <option value="Raisinghnagar">
                                          Raisinghnagar
                                        </option>
                                        <option value="Rajakhera">
                                          Rajakhera
                                        </option>
                                        <option value="Rajaldesar">
                                          Rajaldesar
                                        </option>
                                        <option value="Rajgarh">Rajgarh</option>
                                        <option value="Rajsamand">
                                          Rajsamand
                                        </option>
                                        <option value="Ramganj Mandi">
                                          Ramganj Mandi
                                        </option>
                                        <option value="Ramgarh">Ramgarh</option>
                                        <option value="Rani">Rani</option>
                                        <option value="Ratangarh">
                                          Ratangarh
                                        </option>
                                        <option value="Rawatbhata">
                                          Rawatbhata
                                        </option>
                                        <option value="Rawatsar">
                                          Rawatsar
                                        </option>
                                        <option value="Ringas">Ringas</option>
                                        <option value="Sadri">Sadri</option>
                                        <option value="Salumbar">
                                          Salumbar
                                        </option>
                                        <option value="Sambhar">Sambhar</option>
                                        <option value="Samdari">Samdari</option>
                                        <option value="Sanchor">Sanchor</option>
                                        <option value="Sangaria">
                                          Sangaria
                                        </option>
                                        <option value="Sangod">Sangod</option>
                                        <option value="Sardarshahr">
                                          Sardarshahr
                                        </option>
                                        <option value="Sarwar">Sarwar</option>
                                        <option value="Sawai Madhopur">
                                          Sawai Madhopur
                                        </option>
                                        <option value="Shahpura">
                                          Shahpura
                                        </option>
                                        <option value="Sheoganj">
                                          Sheoganj
                                        </option>
                                        <option value="Sikar">Sikar</option>
                                        <option value="Sirohi">Sirohi</option>
                                        <option value="Siwana">Siwana</option>
                                        <option value="Sojat">Sojat</option>
                                        <option value="Sri Dungargarh">
                                          Sri Dungargarh
                                        </option>
                                        <option value="Sri Madhopur">
                                          Sri Madhopur
                                        </option>
                                        <option value="Sujangarh">
                                          Sujangarh
                                        </option>
                                        <option value="Suket">Suket</option>
                                        <option value="Sunel">Sunel</option>
                                        <option value="Surajgarh">
                                          Surajgarh
                                        </option>
                                        <option value="Suratgarh">
                                          Suratgarh
                                        </option>
                                        <option value="Takhatgarh">
                                          Takhatgarh
                                        </option>
                                        <option value="Taranagar">
                                          Taranagar
                                        </option>
                                        <option value="Tijara">Tijara</option>
                                        <option value="Todabhim">
                                          Todabhim
                                        </option>
                                        <option value="Todaraisingh">
                                          Todaraisingh
                                        </option>
                                        <option value="Tonk">Tonk</option>
                                        <option value="Udaipur">Udaipur</option>
                                        <option value="Udpura">Udpura</option>
                                        <option value="Uniara">Uniara</option>
                                        <option value="Wer">Wer</option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Sikkim" && (
                                      <>
                                        <option value="East District">
                                          East District
                                        </option>
                                        <option value="Gangtok">Gangtok</option>
                                        <option value="Gyalshing">
                                          Gyalshing
                                        </option>
                                        <option value="Jorethang">
                                          Jorethang
                                        </option>
                                        <option value="Mangan">Mangan</option>
                                        <option value="Namchi">Namchi</option>
                                        <option value="Naya Bazar">
                                          Naya Bazar
                                        </option>
                                        <option value="North District">
                                          North District
                                        </option>
                                        <option value="Rangpo">Rangpo</option>
                                        <option value="Singtam">Singtam</option>
                                        <option value="South District">
                                          South District
                                        </option>
                                        <option value="West District">
                                          West District
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Tamil Nadu" && (
                                      <>
                                        <option value="Abiramam">
                                          Abiramam
                                        </option>
                                        <option value="Adirampattinam">
                                          Adirampattinam
                                        </option>
                                        <option value="Aduthurai">
                                          Aduthurai
                                        </option>
                                        <option value="Alagapuram">
                                          Alagapuram
                                        </option>
                                        <option value="Alandur">Alandur</option>
                                        <option value="Alanganallur">
                                          Alanganallur
                                        </option>
                                        <option value="Alangayam">
                                          Alangayam
                                        </option>
                                        <option value="Alangudi">
                                          Alangudi
                                        </option>
                                        <option value="Alangulam">
                                          Alangulam
                                        </option>
                                        <option value="Alappakkam">
                                          Alappakkam
                                        </option>
                                        <option value="Alwa Tirunagari">
                                          Alwa Tirunagari
                                        </option>
                                        <option value="Ambasamudram">
                                          Ambasamudram
                                        </option>
                                        <option value="Ambattur">
                                          Ambattur
                                        </option>
                                        <option value="Ambur">Ambur</option>
                                        <option value="Ammapettai">
                                          Ammapettai
                                        </option>
                                        <option value="Anamalais">
                                          Anamalais
                                        </option>
                                        <option value="Andippatti">
                                          Andippatti
                                        </option>
                                        <option value="Annamalainagar">
                                          Annamalainagar
                                        </option>
                                        <option value="Annavasal">
                                          Annavasal
                                        </option>
                                        <option value="Annur">Annur</option>
                                        <option value="Anthiyur">
                                          Anthiyur
                                        </option>
                                        <option value="Arakkonam">
                                          Arakkonam
                                        </option>
                                        <option value="Arantangi">
                                          Arantangi
                                        </option>
                                        <option value="Arcot">Arcot</option>
                                        <option value="Arimalam">
                                          Arimalam
                                        </option>
                                        <option value="Ariyalur">
                                          Ariyalur
                                        </option>
                                        <option value="Arni">Arni</option>
                                        <option value="Arumbavur">
                                          Arumbavur
                                        </option>
                                        <option value="Arumuganeri">
                                          Arumuganeri
                                        </option>
                                        <option value="Aruppukkottai">
                                          Aruppukkottai
                                        </option>
                                        <option value="Aruvankad">
                                          Aruvankad
                                        </option>
                                        <option value="Attayyampatti">
                                          Attayyampatti
                                        </option>
                                        <option value="Attur">Attur</option>
                                        <option value="Auroville">
                                          Auroville
                                        </option>
                                        <option value="Avadi">Avadi</option>
                                        <option value="Avinashi">
                                          Avinashi
                                        </option>
                                        <option value="Ayakudi">Ayakudi</option>
                                        <option value="Ayyampettai">
                                          Ayyampettai
                                        </option>
                                        <option value="Belur">Belur</option>
                                        <option value="Bhavani">Bhavani</option>
                                        <option value="Bodinayakkanur">
                                          Bodinayakkanur
                                        </option>
                                        <option value="Chengam">Chengam</option>
                                        <option value="Chennai">Chennai</option>
                                        <option value="Chennimalai">
                                          Chennimalai
                                        </option>
                                        <option value="Chetput">Chetput</option>
                                        <option value="Chettipalaiyam">
                                          Chettipalaiyam
                                        </option>
                                        <option value="Cheyyar">Cheyyar</option>
                                        <option value="Cheyyur">Cheyyur</option>
                                        <option value="Chidambaram">
                                          Chidambaram
                                        </option>
                                        <option value="Chingleput">
                                          Chingleput
                                        </option>
                                        <option value="Chinna Salem">
                                          Chinna Salem
                                        </option>
                                        <option value="Chinnamanur">
                                          Chinnamanur
                                        </option>
                                        <option value="Chinnasekkadu">
                                          Chinnasekkadu
                                        </option>
                                        <option value="Cholapuram">
                                          Cholapuram
                                        </option>
                                        <option value="Coimbatore">
                                          Coimbatore
                                        </option>
                                        <option value="Colachel">
                                          Colachel
                                        </option>
                                        <option value="Cuddalore">
                                          Cuddalore
                                        </option>
                                        <option value="Cumbum">Cumbum</option>
                                        <option value="Denkanikota">
                                          Denkanikota
                                        </option>
                                        <option value="Desur">Desur</option>
                                        <option value="Devadanappatti">
                                          Devadanappatti
                                        </option>
                                        <option value="Devakottai">
                                          Devakottai
                                        </option>
                                        <option value="Dhali">Dhali</option>
                                        <option value="Dharapuram">
                                          Dharapuram
                                        </option>
                                        <option value="Dharmapuri">
                                          Dharmapuri
                                        </option>
                                        <option value="Dindigul">
                                          Dindigul
                                        </option>
                                        <option value="Dusi">Dusi</option>
                                        <option value="Elayirampannai">
                                          Elayirampannai
                                        </option>
                                        <option value="Elumalai">
                                          Elumalai
                                        </option>
                                        <option value="Eral">Eral</option>
                                        <option value="Eraniel">Eraniel</option>
                                        <option value="Erode">Erode</option>
                                        <option value="Erumaippatti">
                                          Erumaippatti
                                        </option>
                                        <option value="Ettaiyapuram">
                                          Ettaiyapuram
                                        </option>
                                        <option value="Gandhi Nagar">
                                          Gandhi Nagar
                                        </option>
                                        <option value="Gangaikondan">
                                          Gangaikondan
                                        </option>
                                        <option value="Gangavalli">
                                          Gangavalli
                                        </option>
                                        <option value="Gingee">Gingee</option>
                                        <option value="Gobichettipalayam">
                                          Gobichettipalayam
                                        </option>
                                        <option value="Gudalur">Gudalur</option>
                                        <option value="Gudiyatham">
                                          Gudiyatham
                                        </option>
                                        <option value="Guduvancheri">
                                          Guduvancheri
                                        </option>
                                        <option value="Gummidipundi">
                                          Gummidipundi
                                        </option>
                                        <option value="Harur">Harur</option>
                                        <option value="Hosur">Hosur</option>
                                        <option value="Idappadi">
                                          Idappadi
                                        </option>
                                        <option value="Ilampillai">
                                          Ilampillai
                                        </option>
                                        <option value="Iluppur">Iluppur</option>
                                        <option value="Injambakkam">
                                          Injambakkam
                                        </option>
                                        <option value="Irugur">Irugur</option>
                                        <option value="Jalakandapuram">
                                          Jalakandapuram
                                        </option>
                                        <option value="Jalarpet">
                                          Jalarpet
                                        </option>
                                        <option value="Jayamkondacholapuram">
                                          Jayamkondacholapuram
                                        </option>
                                        <option value="Kadambur">
                                          Kadambur
                                        </option>
                                        <option value="Kadayanallur">
                                          Kadayanallur
                                        </option>
                                        <option value="Kalakkadu">
                                          Kalakkadu
                                        </option>
                                        <option value="Kalavai">Kalavai</option>
                                        <option value="Kallakkurichchi">
                                          Kallakkurichchi
                                        </option>
                                        <option value="Kallidaikurichi">
                                          Kallidaikurichi
                                        </option>
                                        <option value="Kallupatti">
                                          Kallupatti
                                        </option>
                                        <option value="Kalugumalai">
                                          Kalugumalai
                                        </option>
                                        <option value="Kamuthi">Kamuthi</option>
                                        <option value="Kanadukattan">
                                          Kanadukattan
                                        </option>
                                        <option value="Kancheepuram">
                                          Kancheepuram
                                        </option>
                                        <option value="Kanchipuram">
                                          Kanchipuram
                                        </option>
                                        <option value="Kangayam">
                                          Kangayam
                                        </option>
                                        <option value="Kanniyakumari">
                                          Kanniyakumari
                                        </option>
                                        <option value="Karaikkudi">
                                          Karaikkudi
                                        </option>
                                        <option value="Karamadai">
                                          Karamadai
                                        </option>
                                        <option value="Karambakkudi">
                                          Karambakkudi
                                        </option>
                                        <option value="Kariapatti">
                                          Kariapatti
                                        </option>
                                        <option value="Karumbakkam">
                                          Karumbakkam
                                        </option>
                                        <option value="Karur">Karur</option>
                                        <option value="Katpadi">Katpadi</option>
                                        <option value="Kattivakkam">
                                          Kattivakkam
                                        </option>
                                        <option value="Kattupputtur">
                                          Kattupputtur
                                        </option>
                                        <option value="Kaveripatnam">
                                          Kaveripatnam
                                        </option>
                                        <option value="Kayalpattinam">
                                          Kayalpattinam
                                        </option>
                                        <option value="Kayattar">
                                          Kayattar
                                        </option>
                                        <option value="Keelakarai">
                                          Keelakarai
                                        </option>
                                        <option value="Kelamangalam">
                                          Kelamangalam
                                        </option>
                                        <option value="Kil Bhuvanagiri">
                                          Kil Bhuvanagiri
                                        </option>
                                        <option value="Kilvelur">
                                          Kilvelur
                                        </option>
                                        <option value="Kiranur">Kiranur</option>
                                        <option value="Kodaikanal">
                                          Kodaikanal
                                        </option>
                                        <option value="Kodumudi">
                                          Kodumudi
                                        </option>
                                        <option value="Kombai">Kombai</option>
                                        <option value="Konganapuram">
                                          Konganapuram
                                        </option>
                                        <option value="Koothanallur">
                                          Koothanallur
                                        </option>
                                        <option value="Koradachcheri">
                                          Koradachcheri
                                        </option>
                                        <option value="Korampallam">
                                          Korampallam
                                        </option>
                                        <option value="Kotagiri">
                                          Kotagiri
                                        </option>
                                        <option value="Kottaiyur">
                                          Kottaiyur
                                        </option>
                                        <option value="Kovilpatti">
                                          Kovilpatti
                                        </option>
                                        <option value="Krishnagiri">
                                          Krishnagiri
                                        </option>
                                        <option value="Kulattur">
                                          Kulattur
                                        </option>
                                        <option value="Kulittalai">
                                          Kulittalai
                                        </option>
                                        <option value="Kumaralingam">
                                          Kumaralingam
                                        </option>
                                        <option value="Kumbakonam">
                                          Kumbakonam
                                        </option>
                                        <option value="Kunnattur">
                                          Kunnattur
                                        </option>
                                        <option value="Kurinjippadi">
                                          Kurinjippadi
                                        </option>
                                        <option value="Kuttalam">
                                          Kuttalam
                                        </option>
                                        <option value="Kuzhithurai">
                                          Kuzhithurai
                                        </option>
                                        <option value="Lalgudi">Lalgudi</option>
                                        <option value="Madambakkam">
                                          Madambakkam
                                        </option>
                                        <option value="Madipakkam">
                                          Madipakkam
                                        </option>
                                        <option value="Madukkarai">
                                          Madukkarai
                                        </option>
                                        <option value="Madukkur">
                                          Madukkur
                                        </option>
                                        <option value="Madurai">Madurai</option>
                                        <option value="Madurantakam">
                                          Madurantakam
                                        </option>
                                        <option value="Mallapuram">
                                          Mallapuram
                                        </option>
                                        <option value="Mallasamudram">
                                          Mallasamudram
                                        </option>
                                        <option value="Mallur">Mallur</option>
                                        <option value="Manali">Manali</option>
                                        <option value="Manalurpettai">
                                          Manalurpettai
                                        </option>
                                        <option value="Manamadurai">
                                          Manamadurai
                                        </option>
                                        <option value="Manappakkam">
                                          Manappakkam
                                        </option>
                                        <option value="Manapparai">
                                          Manapparai
                                        </option>
                                        <option value="Manavalakurichi">
                                          Manavalakurichi
                                        </option>
                                        <option value="Mandapam">
                                          Mandapam
                                        </option>
                                        <option value="Mangalam">
                                          Mangalam
                                        </option>
                                        <option value="Mannargudi">
                                          Mannargudi
                                        </option>
                                        <option value="Marakkanam">
                                          Marakkanam
                                        </option>
                                        <option value="Marandahalli">
                                          Marandahalli
                                        </option>
                                        <option value="Masinigudi">
                                          Masinigudi
                                        </option>
                                        <option value="Mattur">Mattur</option>
                                        <option value="Mayiladuthurai">
                                          Mayiladuthurai
                                        </option>
                                        <option value="Melur">Melur</option>
                                        <option value="Mettuppalaiyam">
                                          Mettuppalaiyam
                                        </option>
                                        <option value="Mettur">Mettur</option>
                                        <option value="Minjur">Minjur</option>
                                        <option value="Mohanur">Mohanur</option>
                                        <option value="Mudukulattur">
                                          Mudukulattur
                                        </option>
                                        <option value="Mulanur">Mulanur</option>
                                        <option value="Musiri">Musiri</option>
                                        <option value="Muttupet">
                                          Muttupet
                                        </option>
                                        <option value="Naduvattam">
                                          Naduvattam
                                        </option>
                                        <option value="Nagapattinam">
                                          Nagapattinam
                                        </option>
                                        <option value="Nagercoil">
                                          Nagercoil
                                        </option>
                                        <option value="Namagiripettai">
                                          Namagiripettai
                                        </option>
                                        <option value="Namakkal">
                                          Namakkal
                                        </option>
                                        <option value="Nambiyur">
                                          Nambiyur
                                        </option>
                                        <option value="Nambutalai">
                                          Nambutalai
                                        </option>
                                        <option value="Nandambakkam">
                                          Nandambakkam
                                        </option>
                                        <option value="Nangavalli">
                                          Nangavalli
                                        </option>
                                        <option value="Nangilickondan">
                                          Nangilickondan
                                        </option>
                                        <option value="Nanguneri">
                                          Nanguneri
                                        </option>
                                        <option value="Nannilam">
                                          Nannilam
                                        </option>
                                        <option value="Naravarikuppam">
                                          Naravarikuppam
                                        </option>
                                        <option value="Nattam">Nattam</option>
                                        <option value="Nattarasankottai">
                                          Nattarasankottai
                                        </option>
                                        <option value="Needamangalam">
                                          Needamangalam
                                        </option>
                                        <option value="Neelankarai">
                                          Neelankarai
                                        </option>
                                        <option value="Negapatam">
                                          Negapatam
                                        </option>
                                        <option value="Nellikkuppam">
                                          Nellikkuppam
                                        </option>
                                        <option value="Nilakottai">
                                          Nilakottai
                                        </option>
                                        <option value="Nilgiris">
                                          Nilgiris
                                        </option>
                                        <option value="Odugattur">
                                          Odugattur
                                        </option>
                                        <option value="Omalur">Omalur</option>
                                        <option value="Ooty">Ooty</option>
                                        <option value="Padmanabhapuram">
                                          Padmanabhapuram
                                        </option>
                                        <option value="Palakkodu">
                                          Palakkodu
                                        </option>
                                        <option value="Palamedu">
                                          Palamedu
                                        </option>
                                        <option value="Palani">Palani</option>
                                        <option value="Palavakkam">
                                          Palavakkam
                                        </option>
                                        <option value="Palladam">
                                          Palladam
                                        </option>
                                        <option value="Pallappatti">
                                          Pallappatti
                                        </option>
                                        <option value="Pallattur">
                                          Pallattur
                                        </option>
                                        <option value="Pallavaram">
                                          Pallavaram
                                        </option>
                                        <option value="Pallikondai">
                                          Pallikondai
                                        </option>
                                        <option value="Pallipattu">
                                          Pallipattu
                                        </option>
                                        <option value="Pallippatti">
                                          Pallippatti
                                        </option>
                                        <option value="Panruti">Panruti</option>
                                        <option value="Papanasam">
                                          Papanasam
                                        </option>
                                        <option value="Papireddippatti">
                                          Papireddippatti
                                        </option>
                                        <option value="Papparappatti">
                                          Papparappatti
                                        </option>
                                        <option value="Paramagudi">
                                          Paramagudi
                                        </option>
                                        <option value="Pattukkottai">
                                          Pattukkottai
                                        </option>
                                        <option value="Pennadam">
                                          Pennadam
                                        </option>
                                        <option value="Pennagaram">
                                          Pennagaram
                                        </option>
                                        <option value="Pennathur">
                                          Pennathur
                                        </option>
                                        <option value="Peraiyur">
                                          Peraiyur
                                        </option>
                                        <option value="Perambalur">
                                          Perambalur
                                        </option>
                                        <option value="Peranamallur">
                                          Peranamallur
                                        </option>
                                        <option value="Peranampattu">
                                          Peranampattu
                                        </option>
                                        <option value="Peravurani">
                                          Peravurani
                                        </option>
                                        <option value="Periyakulam">
                                          Periyakulam
                                        </option>
                                        <option value="Periyanayakkanpalaiyam">
                                          Periyanayakkanpalaiyam
                                        </option>
                                        <option value="Periyanegamam">
                                          Periyanegamam
                                        </option>
                                        <option value="Periyapatti">
                                          Periyapatti
                                        </option>
                                        <option value="Periyapattinam">
                                          Periyapattinam
                                        </option>
                                        <option value="Perundurai">
                                          Perundurai
                                        </option>
                                        <option value="Perungudi">
                                          Perungudi
                                        </option>
                                        <option value="Perur">Perur</option>
                                        <option value="Pollachi">
                                          Pollachi
                                        </option>
                                        <option value="Polur">Polur</option>
                                        <option value="Ponnamaravati">
                                          Ponnamaravati
                                        </option>
                                        <option value="Ponneri">Ponneri</option>
                                        <option value="Poonamalle">
                                          Poonamalle
                                        </option>
                                        <option value="Porur">Porur</option>
                                        <option value="Pudukkottai">
                                          Pudukkottai
                                        </option>
                                        <option value="Puduppatti">
                                          Puduppatti
                                        </option>
                                        <option value="Pudur">Pudur</option>
                                        <option value="Puduvayal">
                                          Puduvayal
                                        </option>
                                        <option value="Puliyangudi">
                                          Puliyangudi
                                        </option>
                                        <option value="Puliyur">Puliyur</option>
                                        <option value="Pullambadi">
                                          Pullambadi
                                        </option>
                                        <option value="Punjai Puliyampatti">
                                          Punjai Puliyampatti
                                        </option>
                                        <option value="Rajapalaiyam">
                                          Rajapalaiyam
                                        </option>
                                        <option value="Ramanathapuram">
                                          Ramanathapuram
                                        </option>
                                        <option value="Rameswaram">
                                          Rameswaram
                                        </option>
                                        <option value="Rasipuram">
                                          Rasipuram
                                        </option>
                                        <option value="Saint Thomas Mount">
                                          Saint Thomas Mount
                                        </option>
                                        <option value="Salem">Salem</option>
                                        <option value="Sathankulam">
                                          Sathankulam
                                        </option>
                                        <option value="Sathyamangalam">
                                          Sathyamangalam
                                        </option>
                                        <option value="Sattur">Sattur</option>
                                        <option value="Sayalkudi">
                                          Sayalkudi
                                        </option>
                                        <option value="Seven Pagodas">
                                          Seven Pagodas
                                        </option>
                                        <option value="Sholinghur">
                                          Sholinghur
                                        </option>
                                        <option value="Singanallur">
                                          Singanallur
                                        </option>
                                        <option value="Singapperumalkovil">
                                          Singapperumalkovil
                                        </option>
                                        <option value="Sirkazhi">
                                          Sirkazhi
                                        </option>
                                        <option value="Sirumugai">
                                          Sirumugai
                                        </option>
                                        <option value="Sivaganga">
                                          Sivaganga
                                        </option>
                                        <option value="Sivagiri">
                                          Sivagiri
                                        </option>
                                        <option value="Sivakasi">
                                          Sivakasi
                                        </option>
                                        <option value="Srimushnam">
                                          Srimushnam
                                        </option>
                                        <option value="Sriperumbudur">
                                          Sriperumbudur
                                        </option>
                                        <option value="Srivaikuntam">
                                          Srivaikuntam
                                        </option>
                                        <option value="Srivilliputhur">
                                          Srivilliputhur
                                        </option>
                                        <option value="Suchindram">
                                          Suchindram
                                        </option>
                                        <option value="Sulur">Sulur</option>
                                        <option value="Surandai">
                                          Surandai
                                        </option>
                                        <option value="Swamimalai">
                                          Swamimalai
                                        </option>
                                        <option value="Tambaram">
                                          Tambaram
                                        </option>
                                        <option value="Tanjore">Tanjore</option>
                                        <option value="Taramangalam">
                                          Taramangalam
                                        </option>
                                        <option value="Tattayyangarpettai">
                                          Tattayyangarpettai
                                        </option>
                                        <option value="Thanjavur">
                                          Thanjavur
                                        </option>
                                        <option value="Tharangambadi">
                                          Tharangambadi
                                        </option>
                                        <option value="Theni">Theni</option>
                                        <option value="Thenkasi">
                                          Thenkasi
                                        </option>
                                        <option value="Thirukattupalli">
                                          Thirukattupalli
                                        </option>
                                        <option value="Thiruthani">
                                          Thiruthani
                                        </option>
                                        <option value="Thiruvaiyaru">
                                          Thiruvaiyaru
                                        </option>
                                        <option value="Thiruvallur">
                                          Thiruvallur
                                        </option>
                                        <option value="Thiruvarur">
                                          Thiruvarur
                                        </option>
                                        <option value="Thiruvidaimaruthur">
                                          Thiruvidaimaruthur
                                        </option>
                                        <option value="Thoothukudi">
                                          Thoothukudi
                                        </option>
                                        <option value="Tindivanam">
                                          Tindivanam
                                        </option>
                                        <option value="Tinnanur">
                                          Tinnanur
                                        </option>
                                        <option value="Tiruchchendur">
                                          Tiruchchendur
                                        </option>
                                        <option value="Tiruchengode">
                                          Tiruchengode
                                        </option>
                                        <option value="Tiruchirappalli">
                                          Tiruchirappalli
                                        </option>
                                        <option value="Tirukkoyilur">
                                          Tirukkoyilur
                                        </option>
                                        <option value="Tirumullaivasal">
                                          Tirumullaivasal
                                        </option>
                                        <option value="Tirunelveli">
                                          Tirunelveli
                                        </option>
                                        <option value="Tirunelveli Kattabo">
                                          Tirunelveli Kattabo
                                        </option>
                                        <option value="Tiruppalaikudi">
                                          Tiruppalaikudi
                                        </option>
                                        <option value="Tirupparangunram">
                                          Tirupparangunram
                                        </option>
                                        <option value="Tiruppur">
                                          Tiruppur
                                        </option>
                                        <option value="Tiruppuvanam">
                                          Tiruppuvanam
                                        </option>
                                        <option value="Tiruttangal">
                                          Tiruttangal
                                        </option>
                                        <option value="Tiruvannamalai">
                                          Tiruvannamalai
                                        </option>
                                        <option value="Tiruvottiyur">
                                          Tiruvottiyur
                                        </option>
                                        <option value="Tisaiyanvilai">
                                          Tisaiyanvilai
                                        </option>
                                        <option value="Tondi">Tondi</option>
                                        <option value="Turaiyur">
                                          Turaiyur
                                        </option>
                                        <option value="Udangudi">
                                          Udangudi
                                        </option>
                                        <option value="Udumalaippettai">
                                          Udumalaippettai
                                        </option>
                                        <option value="Uppiliyapuram">
                                          Uppiliyapuram
                                        </option>
                                        <option value="Usilampatti">
                                          Usilampatti
                                        </option>
                                        <option value="Uttamapalaiyam">
                                          Uttamapalaiyam
                                        </option>
                                        <option value="Uttiramerur">
                                          Uttiramerur
                                        </option>
                                        <option value="Ūttukkuli">
                                          Ūttukkuli
                                        </option>
                                        <option value="V.S.K.Valasai (Dindigul-Dist.)">
                                          V.S.K.Valasai (Dindigul-Dist.)
                                        </option>
                                        <option value="Vadakku Valliyur">
                                          Vadakku Valliyur
                                        </option>
                                        <option value="Vadakku Viravanallur">
                                          Vadakku Viravanallur
                                        </option>
                                        <option value="Vadamadurai">
                                          Vadamadurai
                                        </option>
                                        <option value="Vadippatti">
                                          Vadippatti
                                        </option>
                                        <option value="Valangaiman">
                                          Valangaiman
                                        </option>
                                        <option value="Valavanur">
                                          Valavanur
                                        </option>
                                        <option value="Vallam">Vallam</option>
                                        <option value="Valparai">
                                          Valparai
                                        </option>
                                        <option value="Vandalur">
                                          Vandalur
                                        </option>
                                        <option value="Vandavasi">
                                          Vandavasi
                                        </option>
                                        <option value="Vaniyambadi">
                                          Vaniyambadi
                                        </option>
                                        <option value="Vasudevanallur">
                                          Vasudevanallur
                                        </option>
                                        <option value="Vattalkundu">
                                          Vattalkundu
                                        </option>
                                        <option value="Vedaraniyam">
                                          Vedaraniyam
                                        </option>
                                        <option value="Vedasandur">
                                          Vedasandur
                                        </option>
                                        <option value="Velankanni">
                                          Velankanni
                                        </option>
                                        <option value="Vellanur">
                                          Vellanur
                                        </option>
                                        <option value="Vellore">Vellore</option>
                                        <option value="Velur">Velur</option>
                                        <option value="Vengavasal">
                                          Vengavasal
                                        </option>
                                        <option value="Vettaikkaranpudur">
                                          Vettaikkaranpudur
                                        </option>
                                        <option value="Vettavalam">
                                          Vettavalam
                                        </option>
                                        <option value="Vijayapuri">
                                          Vijayapuri
                                        </option>
                                        <option value="Vikravandi">
                                          Vikravandi
                                        </option>
                                        <option value="Vilattikulam">
                                          Vilattikulam
                                        </option>
                                        <option value="Villupuram">
                                          Villupuram
                                        </option>
                                        <option value="Viraganur">
                                          Viraganur
                                        </option>
                                        <option value="Virudhunagar">
                                          Virudhunagar
                                        </option>
                                        <option value="Vriddhachalam">
                                          Vriddhachalam
                                        </option>
                                        <option value="Walajapet">
                                          Walajapet
                                        </option>
                                        <option value="Wallajahbad">
                                          Wallajahbad
                                        </option>
                                        <option value="Wellington">
                                          Wellington
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Telangana" && (
                                      <>
                                        <option value="Adilabad">
                                          Adilabad
                                        </option>
                                        <option value="Alampur">Alampur</option>
                                        <option value="Andol">Andol</option>
                                        <option value="Asifabad">
                                          Asifabad
                                        </option>
                                        <option value="Balapur">Balapur</option>
                                        <option value="Banswada">
                                          Banswada
                                        </option>
                                        <option value="Bellampalli">
                                          Bellampalli
                                        </option>
                                        <option value="Bhadrachalam">
                                          Bhadrachalam
                                        </option>
                                        <option value="Bhadradri Kothagudem">
                                          Bhadradri Kothagudem
                                        </option>
                                        <option value="Bhaisa">Bhaisa</option>
                                        <option value="Bhongir">Bhongir</option>
                                        <option value="Bodhan">Bodhan</option>
                                        <option value="Chandur">Chandur</option>
                                        <option value="Chatakonda">
                                          Chatakonda
                                        </option>
                                        <option value="Dasnapur">
                                          Dasnapur
                                        </option>
                                        <option value="Devarkonda">
                                          Devarkonda
                                        </option>
                                        <option value="Dornakal">
                                          Dornakal
                                        </option>
                                        <option value="Farrukhnagar">
                                          Farrukhnagar
                                        </option>
                                        <option value="Gaddi Annaram">
                                          Gaddi Annaram
                                        </option>
                                        <option value="Gadwal">Gadwal</option>
                                        <option value="Ghatkesar">
                                          Ghatkesar
                                        </option>
                                        <option value="Gopalur">Gopalur</option>
                                        <option value="Gudur">Gudur</option>
                                        <option value="Hyderabad">
                                          Hyderabad
                                        </option>
                                        <option value="Jagtial">Jagtial</option>
                                        <option value="Jangaon">Jangaon</option>
                                        <option value="Jangoan">Jangoan</option>
                                        <option value="Jayashankar Bhupalapally">
                                          Jayashankar Bhupalapally
                                        </option>
                                        <option value="Jogulamba Gadwal">
                                          Jogulamba Gadwal
                                        </option>
                                        <option value="Kagaznagar">
                                          Kagaznagar
                                        </option>
                                        <option value="Kamareddi">
                                          Kamareddi
                                        </option>
                                        <option value="Kamareddy">
                                          Kamareddy
                                        </option>
                                        <option value="Karimnagar">
                                          Karimnagar
                                        </option>
                                        <option value="Khammam">Khammam</option>
                                        <option value="Kodar">Kodar</option>
                                        <option value="Koratla">Koratla</option>
                                        <option value="Kothapet">
                                          Kothapet
                                        </option>
                                        <option value="Kottagudem">
                                          Kottagudem
                                        </option>
                                        <option value="Kottapalli">
                                          Kottapalli
                                        </option>
                                        <option value="Kukatpalli">
                                          Kukatpalli
                                        </option>
                                        <option value="Kyathampalle">
                                          Kyathampalle
                                        </option>
                                        <option value="Lakshettipet">
                                          Lakshettipet
                                        </option>
                                        <option value="Lal Bahadur Nagar">
                                          Lal Bahadur Nagar
                                        </option>
                                        <option value="Mahabubabad">
                                          Mahabubabad
                                        </option>
                                        <option value="Mahbubnagar">
                                          Mahbubnagar
                                        </option>
                                        <option value="Malkajgiri">
                                          Malkajgiri
                                        </option>
                                        <option value="Mancheral">
                                          Mancheral
                                        </option>
                                        <option value="Mandamarri">
                                          Mandamarri
                                        </option>
                                        <option value="Manthani">
                                          Manthani
                                        </option>
                                        <option value="Manuguru">
                                          Manuguru
                                        </option>
                                        <option value="Medak">Medak</option>
                                        <option value="Medchal">Medchal</option>
                                        <option value="Medchal Malkajgiri">
                                          Medchal Malkajgiri
                                        </option>
                                        <option value="Mirialguda">
                                          Mirialguda
                                        </option>
                                        <option value="Nagar Karnul">
                                          Nagar Karnul
                                        </option>
                                        <option value="Nalgonda">
                                          Nalgonda
                                        </option>
                                        <option value="Narayanpet">
                                          Narayanpet
                                        </option>
                                        <option value="Narsingi">
                                          Narsingi
                                        </option>
                                        <option value="Naspur">Naspur</option>
                                        <option value="Nirmal">Nirmal</option>
                                        <option value="Nizamabad">
                                          Nizamabad
                                        </option>
                                        <option value="Paloncha">
                                          Paloncha
                                        </option>
                                        <option value="Palwancha">
                                          Palwancha
                                        </option>
                                        <option value="Patancheru">
                                          Patancheru
                                        </option>
                                        <option value="Peddapalli">
                                          Peddapalli
                                        </option>
                                        <option value="Quthbullapur">
                                          Quthbullapur
                                        </option>
                                        <option value="Rajanna Sircilla">
                                          Rajanna Sircilla
                                        </option>
                                        <option value="Ramagundam">
                                          Ramagundam
                                        </option>
                                        <option value="Ramgundam">
                                          Ramgundam
                                        </option>
                                        <option value="Rangareddi">
                                          Rangareddi
                                        </option>
                                        <option value="Sadaseopet">
                                          Sadaseopet
                                        </option>
                                        <option value="Sangareddi">
                                          Sangareddi
                                        </option>
                                        <option value="Sathupalli">
                                          Sathupalli
                                        </option>
                                        <option value="Secunderabad">
                                          Secunderabad
                                        </option>
                                        <option value="Serilingampalle">
                                          Serilingampalle
                                        </option>
                                        <option value="Siddipet">
                                          Siddipet
                                        </option>
                                        <option value="Singapur">
                                          Singapur
                                        </option>
                                        <option value="Sirpur">Sirpur</option>
                                        <option value="Sirsilla">
                                          Sirsilla
                                        </option>
                                        <option value="Sriramnagar">
                                          Sriramnagar
                                        </option>
                                        <option value="Suriapet">
                                          Suriapet
                                        </option>
                                        <option value="Tandur">Tandur</option>
                                        <option value="Uppal Kalan">
                                          Uppal Kalan
                                        </option>
                                        <option value="Vemalwada">
                                          Vemalwada
                                        </option>
                                        <option value="Vikarabad">
                                          Vikarabad
                                        </option>
                                        <option value="Wanparti">
                                          Wanparti
                                        </option>
                                        <option value="Warangal">
                                          Warangal
                                        </option>
                                        <option value="Yellandu">
                                          Yellandu
                                        </option>
                                        <option value="Zahirabad">
                                          Zahirabad
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state === "Tripura" && (
                                      <>
                                        <option value="Agartala">
                                          Agartala
                                        </option>
                                        <option value="Amarpur">Amarpur</option>
                                        <option value="Ambasa">Ambasa</option>
                                        <option value="Barjala">Barjala</option>
                                        <option value="Belonia">Belonia</option>
                                        <option value="Dhalai">Dhalai</option>
                                        <option value="Dharmanagar">
                                          Dharmanagar
                                        </option>
                                        <option value="Gomati">Gomati</option>
                                        <option value="Kailashahar">
                                          Kailashahar
                                        </option>
                                        <option value="Kamalpur">
                                          Kamalpur
                                        </option>
                                        <option value="Khowai">Khowai</option>
                                        <option value="North Tripura">
                                          North Tripura
                                        </option>
                                        <option value="Ranir Bazar">
                                          Ranir Bazar
                                        </option>
                                        <option value="Sabrum">Sabrum</option>
                                        <option value="Sonamura">
                                          Sonamura
                                        </option>
                                        <option value="South Tripura">
                                          South Tripura
                                        </option>
                                        <option value="Udaipur">Udaipur</option>
                                        <option value="Unakoti">Unakoti</option>
                                        <option value="West Tripura">
                                          West Tripura
                                        </option>
                                      </>
                                    )}
                                    {shippingAddress.state ===
                                      "Uttar Pradesh" && (
                                        <>
                                          <option value="Achhnera">
                                            Achhnera
                                          </option>
                                          <option value="Afzalgarh">
                                            Afzalgarh
                                          </option>
                                          <option value="Agra">Agra</option>
                                          <option value="Ahraura">Ahraura</option>
                                          <option value="Ajodhya">Ajodhya</option>
                                          <option value="Akbarpur">
                                            Akbarpur
                                          </option>
                                          <option value="Aliganj">Aliganj</option>
                                          <option value="Aligarh">Aligarh</option>
                                          <option value="Allahabad">
                                            Allahabad
                                          </option>
                                          <option value="Allahganj">
                                            Allahganj
                                          </option>
                                          <option value="Amanpur">Amanpur</option>
                                          <option value="Ambahta">Ambahta</option>
                                          <option value="Ambedkar Nagar">
                                            Ambedkar Nagar
                                          </option>
                                          <option value="Amethi">Amethi</option>
                                          <option value="Amroha">Amroha</option>
                                          <option value="Anandnagar">
                                            Anandnagar
                                          </option>
                                          <option value="Antu">Antu</option>
                                          <option value="Anupshahr">
                                            Anupshahr
                                          </option>
                                          <option value="Aonla">Aonla</option>
                                          <option value="Atarra">Atarra</option>
                                          <option value="Atrauli">Atrauli</option>
                                          <option value="Atraulia">
                                            Atraulia
                                          </option>
                                          <option value="Auraiya">Auraiya</option>
                                          <option value="Auras">Auras</option>
                                          <option value="Azamgarh">
                                            Azamgarh
                                          </option>
                                          <option value="Baberu">Baberu</option>
                                          <option value="Babina">Babina</option>
                                          <option value="Babrala">Babrala</option>
                                          <option value="Babugarh">
                                            Babugarh
                                          </option>
                                          <option value="Bachhraon">
                                            Bachhraon
                                          </option>
                                          <option value="Bachhrawan">
                                            Bachhrawan
                                          </option>
                                          <option value="Baghpat">Baghpat</option>
                                          <option value="Bah">Bah</option>
                                          <option value="Baheri">Baheri</option>
                                          <option value="Bahjoi">Bahjoi</option>
                                          <option value="Bahraich">
                                            Bahraich
                                          </option>
                                          <option value="Bahraigh">
                                            Bahraigh
                                          </option>
                                          <option value="Bahsuma">Bahsuma</option>
                                          <option value="Bahua">Bahua</option>
                                          <option value="Bajna">Bajna</option>
                                          <option value="Bakewar">Bakewar</option>
                                          <option value="Baldev">Baldev</option>
                                          <option value="Ballia">Ballia</option>
                                          <option value="Balrampur">
                                            Balrampur
                                          </option>
                                          <option value="Banat">Banat</option>
                                          <option value="Banbasa">Banbasa</option>
                                          <option value="Banda">Banda</option>
                                          <option value="Bangarmau">
                                            Bangarmau
                                          </option>
                                          <option value="Bansdih">Bansdih</option>
                                          <option value="Bansgaon">
                                            Bansgaon
                                          </option>
                                          <option value="Bansi">Bansi</option>
                                          <option value="Bara Banki">
                                            Bara Banki
                                          </option>
                                          <option value="Baragaon">
                                            Baragaon
                                          </option>
                                          <option value="Baraut">Baraut</option>
                                          <option value="Bareilly">
                                            Bareilly
                                          </option>
                                          <option value="Barkhera Kalan">
                                            Barkhera Kalan
                                          </option>
                                          <option value="Barsana">Barsana</option>
                                          <option value="Basti">Basti</option>
                                          <option value="Behat">Behat</option>
                                          <option value="Bela">Bela</option>
                                          <option value="Beniganj">
                                            Beniganj
                                          </option>
                                          <option value="Beswan">Beswan</option>
                                          <option value="Bewar">Bewar</option>
                                          <option value="Bhadohi">Bhadohi</option>
                                          <option value="Bhagwantnagar">
                                            Bhagwantnagar
                                          </option>
                                          <option value="Bharthana">
                                            Bharthana
                                          </option>
                                          <option value="Bharwari">
                                            Bharwari
                                          </option>
                                          <option value="Bhinga">Bhinga</option>
                                          <option value="Bhongaon">
                                            Bhongaon
                                          </option>
                                          <option value="Bidhuna">Bidhuna</option>
                                          <option value="Bighapur Khurd">
                                            Bighapur Khurd
                                          </option>
                                          <option value="Bijnor">Bijnor</option>
                                          <option value="Bikapur">Bikapur</option>
                                          <option value="Bilari">Bilari</option>
                                          <option value="Bilariaganj">
                                            Bilariaganj
                                          </option>
                                          <option value="Bilaspur">
                                            Bilaspur
                                          </option>
                                          <option value="Bilgram">Bilgram</option>
                                          <option value="Bilhaur">Bilhaur</option>
                                          <option value="Bilsanda">
                                            Bilsanda
                                          </option>
                                          <option value="Bilsi">Bilsi</option>
                                          <option value="Bilthra">Bilthra</option>
                                          <option value="Bindki">Bindki</option>
                                          <option value="Bisalpur">
                                            Bisalpur
                                          </option>
                                          <option value="Bisauli">Bisauli</option>
                                          <option value="Bisenda Buzurg">
                                            Bisenda Buzurg
                                          </option>
                                          <option value="Bishunpur Urf Maharajganj">
                                            Bishunpur Urf Maharajganj
                                          </option>
                                          <option value="Biswan">Biswan</option>
                                          <option value="Bithur">Bithur</option>
                                          <option value="Budaun">Budaun</option>
                                          <option value="Budhana">Budhana</option>
                                          <option value="Bulandshahr">
                                            Bulandshahr
                                          </option>
                                          <option value="Captainganj">
                                            Captainganj
                                          </option>
                                          <option value="Chail">Chail</option>
                                          <option value="Chakia">Chakia</option>
                                          <option value="Chandauli">
                                            Chandauli
                                          </option>
                                          <option value="Chandauli District">
                                            Chandauli District
                                          </option>
                                          <option value="Chandpur">
                                            Chandpur
                                          </option>
                                          <option value="Chanduasi">
                                            Chanduasi
                                          </option>
                                          <option value="Charkhari">
                                            Charkhari
                                          </option>
                                          <option value="Charthawal">
                                            Charthawal
                                          </option>
                                          <option value="Chhaprauli">
                                            Chhaprauli
                                          </option>
                                          <option value="Chharra">Chharra</option>
                                          <option value="Chhata">Chhata</option>
                                          <option value="Chhibramau">
                                            Chhibramau
                                          </option>
                                          <option value="Chhutmalpur">
                                            Chhutmalpur
                                          </option>
                                          <option value="Chillupar">
                                            Chillupar
                                          </option>
                                          <option value="Chirgaon">
                                            Chirgaon
                                          </option>
                                          <option value="Chitrakoot">
                                            Chitrakoot
                                          </option>
                                          <option value="Chopan">Chopan</option>
                                          <option value="Chunar">Chunar</option>
                                          <option value="Colonelganj">
                                            Colonelganj
                                          </option>
                                          <option value="Dadri">Dadri</option>
                                          <option value="Dalmau">Dalmau</option>
                                          <option value="Dankaur">Dankaur</option>
                                          <option value="Dasna">Dasna</option>
                                          <option value="Dataganj">
                                            Dataganj
                                          </option>
                                          <option value="Daurala">Daurala</option>
                                          <option value="Dayal Bagh">
                                            Dayal Bagh
                                          </option>
                                          <option value="Deoband">Deoband</option>
                                          <option value="Deoranian">
                                            Deoranian
                                          </option>
                                          <option value="Deoria">Deoria</option>
                                          <option value="Dewa">Dewa</option>
                                          <option value="Dhampur">Dhampur</option>
                                          <option value="Dhanaura">
                                            Dhanaura
                                          </option>
                                          <option value="Dhaurahra">
                                            Dhaurahra
                                          </option>
                                          <option value="Dibai">Dibai</option>
                                          <option value="Dohrighat">
                                            Dohrighat
                                          </option>
                                          <option value="Dostpur">Dostpur</option>
                                          <option value="Dudhi">Dudhi</option>
                                          <option value="Etah">Etah</option>
                                          <option value="Etawah">Etawah</option>
                                          <option value="Faizabad">
                                            Faizabad
                                          </option>
                                          <option value="Farah">Farah</option>
                                          <option value="Faridnagar">
                                            Faridnagar
                                          </option>
                                          <option value="Faridpur">
                                            Faridpur
                                          </option>
                                          <option value="Farrukhabad">
                                            Farrukhabad
                                          </option>
                                          <option value="Fatehabad">
                                            Fatehabad
                                          </option>
                                          <option value="Fatehganj West">
                                            Fatehganj West
                                          </option>
                                          <option value="Fatehgarh">
                                            Fatehgarh
                                          </option>
                                          <option value="Fatehpur">
                                            Fatehpur
                                          </option>
                                          <option value="Fatehpur Chaurasi">
                                            Fatehpur Chaurasi
                                          </option>
                                          <option value="Fatehpur Sikri">
                                            Fatehpur Sikri
                                          </option>
                                          <option value="Firozabad">
                                            Firozabad
                                          </option>
                                          <option value="Fyzabad">Fyzabad</option>
                                          <option value="Gajraula">
                                            Gajraula
                                          </option>
                                          <option value="Gangoh">Gangoh</option>
                                          <option value="Ganj Dundwara">
                                            Ganj Dundwara
                                          </option>
                                          <option value="Ganj Muradabad">
                                            Ganj Muradabad
                                          </option>
                                          <option value="Garautha">
                                            Garautha
                                          </option>
                                          <option value="Garhi Pukhta">
                                            Garhi Pukhta
                                          </option>
                                          <option value="Garhmuktesar">
                                            Garhmuktesar
                                          </option>
                                          <option value="Gautam Buddha Nagar">
                                            Gautam Buddha Nagar
                                          </option>
                                          <option value="Gawan">Gawan</option>
                                          <option value="Ghatampur">
                                            Ghatampur
                                          </option>
                                          <option value="Ghaziabad">
                                            Ghaziabad
                                          </option>
                                          <option value="Ghazipur">
                                            Ghazipur
                                          </option>
                                          <option value="Ghiror">Ghiror</option>
                                          <option value="Ghorawal">
                                            Ghorawal
                                          </option>
                                          <option value="Ghosi">Ghosi</option>
                                          <option value="Gohand">Gohand</option>
                                          <option value="Gokul">Gokul</option>
                                          <option value="Gola Bazar">
                                            Gola Bazar
                                          </option>
                                          <option value="Gola Gokarannath">
                                            Gola Gokarannath
                                          </option>
                                          <option value="Gonda">Gonda</option>
                                          <option value="Gonda City">
                                            Gonda City
                                          </option>
                                          <option value="Gopamau">Gopamau</option>
                                          <option value="Gorakhpur">
                                            Gorakhpur
                                          </option>
                                          <option value="Goshainganj">
                                            Goshainganj
                                          </option>
                                          <option value="Govardhan">
                                            Govardhan
                                          </option>
                                          <option value="Greater Noida">
                                            Greater Noida
                                          </option>
                                          <option value="Gulaothi">
                                            Gulaothi
                                          </option>
                                          <option value="Gunnaur">Gunnaur</option>
                                          <option value="Gursahaiganj">
                                            Gursahaiganj
                                          </option>
                                          <option value="Gursarai">
                                            Gursarai
                                          </option>
                                          <option value="Gyanpur">Gyanpur</option>
                                          <option value="Haldaur">Haldaur</option>
                                          <option value="Hamirpur">
                                            Hamirpur
                                          </option>
                                          <option value="Handia">Handia</option>
                                          <option value="Hapur">Hapur</option>
                                          <option value="Haraiya">Haraiya</option>
                                          <option value="Hardoi">Hardoi</option>
                                          <option value="Harduaganj">
                                            Harduaganj
                                          </option>
                                          <option value="Hasanpur">
                                            Hasanpur
                                          </option>
                                          <option value="Hastinapur">
                                            Hastinapur
                                          </option>
                                          <option value="Hata">Hata</option>
                                          <option value="Hathras">Hathras</option>
                                          <option value="Iglas">Iglas</option>
                                          <option value="Ikauna">Ikauna</option>
                                          <option value="Indergarh">
                                            Indergarh
                                          </option>
                                          <option value="Islamnagar">
                                            Islamnagar
                                          </option>
                                          <option value="Itaunja">Itaunja</option>
                                          <option value="Itimadpur">
                                            Itimadpur
                                          </option>
                                          <option value="Jagdishpur">
                                            Jagdishpur
                                          </option>
                                          <option value="Jagnair">Jagnair</option>
                                          <option value="Jahanabad">
                                            Jahanabad
                                          </option>
                                          <option value="Jahangirabad">
                                            Jahangirabad
                                          </option>
                                          <option value="Jahangirpur">
                                            Jahangirpur
                                          </option>
                                          <option value="Jainpur">Jainpur</option>
                                          <option value="Jais">Jais</option>
                                          <option value="Jalalabad">
                                            Jalalabad
                                          </option>
                                          <option value="Jalali">Jalali</option>
                                          <option value="Jalalpur">
                                            Jalalpur
                                          </option>
                                          <option value="Jalaun">Jalaun</option>
                                          <option value="Jalesar">Jalesar</option>
                                          <option value="Jansath">Jansath</option>
                                          <option value="Jarwal">Jarwal</option>
                                          <option value="Jasrana">Jasrana</option>
                                          <option value="Jaswantnagar">
                                            Jaswantnagar
                                          </option>
                                          <option value="Jaunpur">Jaunpur</option>
                                          <option value="Jewar">Jewar</option>
                                          <option value="Jhalu">Jhalu</option>
                                          <option value="Jhansi">Jhansi</option>
                                          <option value="Jhinjhak">
                                            Jhinjhak
                                          </option>
                                          <option value="Jhinjhana">
                                            Jhinjhana
                                          </option>
                                          <option value="Jhusi">Jhusi</option>
                                          <option value="Jyotiba Phule Nagar">
                                            Jyotiba Phule Nagar
                                          </option>
                                          <option value="Kabrai">Kabrai</option>
                                          <option value="Kachhwa">Kachhwa</option>
                                          <option value="Kadaura">Kadaura</option>
                                          <option value="Kadipur">Kadipur</option>
                                          <option value="Kaimganj">
                                            Kaimganj
                                          </option>
                                          <option value="Kairana">Kairana</option>
                                          <option value="Kakori">Kakori</option>
                                          <option value="Kakrala">Kakrala</option>
                                          <option value="Kalinagar">
                                            Kalinagar
                                          </option>
                                          <option value="Kalpi">Kalpi</option>
                                          <option value="Kamalganj">
                                            Kamalganj
                                          </option>
                                          <option value="Kampil">Kampil</option>
                                          <option value="Kandhla">Kandhla</option>
                                          <option value="Kannauj">Kannauj</option>
                                          <option value="Kanpur">Kanpur</option>
                                          <option value="Kanpur Dehat">
                                            Kanpur Dehat
                                          </option>
                                          <option value="Kant">Kant</option>
                                          <option value="Kanth">Kanth</option>
                                          <option value="Karari">Karari</option>
                                          <option value="Karhal">Karhal</option>
                                          <option value="Kasganj">Kasganj</option>
                                          <option value="Katra">Katra</option>
                                          <option value="Kaushambi District">
                                            Kaushambi District
                                          </option>
                                          <option value="Kemri">Kemri</option>
                                          <option value="Khada">Khada</option>
                                          <option value="Khaga">Khaga</option>
                                          <option value="Khair">Khair</option>
                                          <option value="Khairabad">
                                            Khairabad
                                          </option>
                                          <option value="Khalilabad">
                                            Khalilabad
                                          </option>
                                          <option value="Khanpur">Khanpur</option>
                                          <option value="Kharela">Kharela</option>
                                          <option value="Khargupur">
                                            Khargupur
                                          </option>
                                          <option value="Kharkhauda">
                                            Kharkhauda
                                          </option>
                                          <option value="Khatauli">
                                            Khatauli
                                          </option>
                                          <option value="Khekra">Khekra</option>
                                          <option value="Kheri">Kheri</option>
                                          <option value="Khudaganj">
                                            Khudaganj
                                          </option>
                                          <option value="Khurja">Khurja</option>
                                          <option value="Khutar">Khutar</option>
                                          <option value="Kirakat">Kirakat</option>
                                          <option value="Kiraoli">Kiraoli</option>
                                          <option value="Kiratpur">
                                            Kiratpur
                                          </option>
                                          <option value="Kishanpur">
                                            Kishanpur
                                          </option>
                                          <option value="Kishni">Kishni</option>
                                          <option value="Kithor">Kithor</option>
                                          <option value="Konch">Konch</option>
                                          <option value="Kopaganj">
                                            Kopaganj
                                          </option>
                                          <option value="Kosi">Kosi</option>
                                          <option value="Kota">Kota</option>
                                          <option value="Kotra">Kotra</option>
                                          <option value="Kulpahar">
                                            Kulpahar
                                          </option>
                                          <option value="Kunda">Kunda</option>
                                          <option value="Kundarkhi">
                                            Kundarkhi
                                          </option>
                                          <option value="Kurara">Kurara</option>
                                          <option value="Kushinagar">
                                            Kushinagar
                                          </option>
                                          <option value="Laharpur">
                                            Laharpur
                                          </option>
                                          <option value="Lakhimpur">
                                            Lakhimpur
                                          </option>
                                          <option value="Lakhna">Lakhna</option>
                                          <option value="Lalganj">Lalganj</option>
                                          <option value="Lalitpur">
                                            Lalitpur
                                          </option>
                                          <option value="Lar">Lar</option>
                                          <option value="Lawar Khas">
                                            Lawar Khas
                                          </option>
                                          <option value="Loni">Loni</option>
                                          <option value="Lucknow">Lucknow</option>
                                          <option value="Lucknow District">
                                            Lucknow District
                                          </option>
                                          <option value="Machhlishahr">
                                            Machhlishahr
                                          </option>
                                          <option value="Madhoganj">
                                            Madhoganj
                                          </option>
                                          <option value="Madhogarh">
                                            Madhogarh
                                          </option>
                                          <option value="Maghar">Maghar</option>
                                          <option value="Mahaban">Mahaban</option>
                                          <option value="Maharajganj">
                                            Maharajganj
                                          </option>
                                          <option value="Mahmudabad">
                                            Mahmudabad
                                          </option>
                                          <option value="Mahoba">Mahoba</option>
                                          <option value="Maholi">Maholi</option>
                                          <option value="Mahroni">Mahroni</option>
                                          <option value="Mailani">Mailani</option>
                                          <option value="Mainpuri">
                                            Mainpuri
                                          </option>
                                          <option value="Malihabad">
                                            Malihabad
                                          </option>
                                          <option value="Mandawar">
                                            Mandawar
                                          </option>
                                          <option value="Maniar">Maniar</option>
                                          <option value="Manikpur">
                                            Manikpur
                                          </option>
                                          <option value="Manjhanpur">
                                            Manjhanpur
                                          </option>
                                          <option value="Mankapur">
                                            Mankapur
                                          </option>
                                          <option value="Marahra">Marahra</option>
                                          <option value="Mariahu">Mariahu</option>
                                          <option value="Mataundh">
                                            Mataundh
                                          </option>
                                          <option value="Mathura">Mathura</option>
                                          <option value="Mau">Mau</option>
                                          <option value="Mau Aimma">
                                            Mau Aimma
                                          </option>
                                          <option value="Maudaha">Maudaha</option>
                                          <option value="Mauranwan">
                                            Mauranwan
                                          </option>
                                          <option value="Mawana">Mawana</option>
                                          <option value="Meerut">Meerut</option>
                                          <option value="Mehnagar">
                                            Mehnagar
                                          </option>
                                          <option value="Mehndawal">
                                            Mehndawal
                                          </option>
                                          <option value="Milak">Milak</option>
                                          <option value="Miranpur">
                                            Miranpur
                                          </option>
                                          <option value="Miranpur Katra">
                                            Miranpur Katra
                                          </option>
                                          <option value="Mirganj">Mirganj</option>
                                          <option value="Mirzapur">
                                            Mirzapur
                                          </option>
                                          <option value="Misrikh">Misrikh</option>
                                          <option value="Mohan">Mohan</option>
                                          <option value="Mohanpur">
                                            Mohanpur
                                          </option>
                                          <option value="Moradabad">
                                            Moradabad
                                          </option>
                                          <option value="Moth">Moth</option>
                                          <option value="Mubarakpur">
                                            Mubarakpur
                                          </option>
                                          <option value="Mughal Sarai">
                                            Mughal Sarai
                                          </option>
                                          <option value="Muhammadabad">
                                            Muhammadabad
                                          </option>
                                          <option value="Muradnagar">
                                            Muradnagar
                                          </option>
                                          <option value="Mursan">Mursan</option>
                                          <option value="Musafir-Khana">
                                            Musafir-Khana
                                          </option>
                                          <option value="Muzaffarnagar">
                                            Muzaffarnagar
                                          </option>
                                          <option value="Nadigaon">
                                            Nadigaon
                                          </option>
                                          <option value="Nagina">Nagina</option>
                                          <option value="Nagram">Nagram</option>
                                          <option value="Najibabad">
                                            Najibabad
                                          </option>
                                          <option value="Nakur">Nakur</option>
                                          <option value="Nanauta">Nanauta</option>
                                          <option value="Nandgaon">
                                            Nandgaon
                                          </option>
                                          <option value="Nanpara">Nanpara</option>
                                          <option value="Narauli">Narauli</option>
                                          <option value="Naraura">Naraura</option>
                                          <option value="Nautanwa">
                                            Nautanwa
                                          </option>
                                          <option value="Nawabganj">
                                            Nawabganj
                                          </option>
                                          <option value="Nichlaul">
                                            Nichlaul
                                          </option>
                                          <option value="Nihtaur">Nihtaur</option>
                                          <option value="Niwari">Niwari</option>
                                          <option value="Nizamabad">
                                            Nizamabad
                                          </option>
                                          <option value="Noida">Noida</option>
                                          <option value="Nurpur">Nurpur</option>
                                          <option value="Obra">Obra</option>
                                          <option value="Orai">Orai</option>
                                          <option value="Oran">Oran</option>
                                          <option value="Pachperwa">
                                            Pachperwa
                                          </option>
                                          <option value="Padrauna">
                                            Padrauna
                                          </option>
                                          <option value="Pahasu">Pahasu</option>
                                          <option value="Pali">Pali</option>
                                          <option value="Palia Kalan">
                                            Palia Kalan
                                          </option>
                                          <option value="Parichha">
                                            Parichha
                                          </option>
                                          <option value="Parichhatgarh">
                                            Parichhatgarh
                                          </option>
                                          <option value="Parshadepur">
                                            Parshadepur
                                          </option>
                                          <option value="Patiali">Patiali</option>
                                          <option value="Patti">Patti</option>
                                          <option value="Pawayan">Pawayan</option>
                                          <option value="Phalauda">
                                            Phalauda
                                          </option>
                                          <option value="Phaphund">
                                            Phaphund
                                          </option>
                                          <option value="Phariha">Phariha</option>
                                          <option value="Phulpur">Phulpur</option>
                                          <option value="Pihani">Pihani</option>
                                          <option value="Pilibhit">
                                            Pilibhit
                                          </option>
                                          <option value="Pilkhua">Pilkhua</option>
                                          <option value="Pinahat">Pinahat</option>
                                          <option value="Pipraich">
                                            Pipraich
                                          </option>
                                          <option value="Pratapgarh">
                                            Pratapgarh
                                          </option>
                                          <option value="Pukhrayan">
                                            Pukhrayan
                                          </option>
                                          <option value="Puranpur">
                                            Puranpur
                                          </option>
                                          <option value="Purwa">Purwa</option>
                                          <option value="Rabupura">
                                            Rabupura
                                          </option>
                                          <option value="Radhakund">
                                            Radhakund
                                          </option>
                                          <option value="Raebareli">
                                            Raebareli
                                          </option>
                                          <option value="Rajapur">Rajapur</option>
                                          <option value="Ramkola">Ramkola</option>
                                          <option value="Ramnagar">
                                            Ramnagar
                                          </option>
                                          <option value="Rampur">Rampur</option>
                                          <option value="Rampura">Rampura</option>
                                          <option value="Ranipur">Ranipur</option>
                                          <option value="Rasra">Rasra</option>
                                          <option value="Rasulabad">
                                            Rasulabad
                                          </option>
                                          <option value="Rath">Rath</option>
                                          <option value="Raya">Raya</option>
                                          <option value="Renukut">Renukut</option>
                                          <option value="Reoti">Reoti</option>
                                          <option value="Richha">Richha</option>
                                          <option value="Robertsganj">
                                            Robertsganj
                                          </option>
                                          <option value="Rudarpur">
                                            Rudarpur
                                          </option>
                                          <option value="Rura">Rura</option>
                                          <option value="Sadabad">Sadabad</option>
                                          <option value="Sadat">Sadat</option>
                                          <option value="Safipur">Safipur</option>
                                          <option value="Saharanpur">
                                            Saharanpur
                                          </option>
                                          <option value="Sahaspur">
                                            Sahaspur
                                          </option>
                                          <option value="Sahaswan">
                                            Sahaswan
                                          </option>
                                          <option value="Sahawar">Sahawar</option>
                                          <option value="Saidpur">Saidpur</option>
                                          <option value="Sakit">Sakit</option>
                                          <option value="Salon">Salon</option>
                                          <option value="Sambhal">Sambhal</option>
                                          <option value="Samthar">Samthar</option>
                                          <option value="Sandi">Sandi</option>
                                          <option value="Sandila">Sandila</option>
                                          <option value="Sant Kabir Nagar">
                                            Sant Kabir Nagar
                                          </option>
                                          <option value="Sant Ravi Das Nagar">
                                            Sant Ravi Das Nagar
                                          </option>
                                          <option value="Sarai Akil">
                                            Sarai Akil
                                          </option>
                                          <option value="Sarai Ekdil">
                                            Sarai Ekdil
                                          </option>
                                          <option value="Sarai Mir">
                                            Sarai Mir
                                          </option>
                                          <option value="Sarauli">Sarauli</option>
                                          <option value="Sardhana">
                                            Sardhana
                                          </option>
                                          <option value="Sarila">Sarila</option>
                                          <option value="Sasni">Sasni</option>
                                          <option value="Satrikh">Satrikh</option>
                                          <option value="Saurikh">Saurikh</option>
                                          <option value="Sector">Sector</option>
                                          <option value="Seohara">Seohara</option>
                                          <option value="Shahabad">
                                            Shahabad
                                          </option>
                                          <option value="Shahganj">
                                            Shahganj
                                          </option>
                                          <option value="Shahi">Shahi</option>
                                          <option value="Shahjahanpur">
                                            Shahjahanpur
                                          </option>
                                          <option value="Shahpur">Shahpur</option>
                                          <option value="Shamli">Shamli</option>
                                          <option value="Shamsabad">
                                            Shamsabad
                                          </option>
                                          <option value="Shankargarh">
                                            Shankargarh
                                          </option>
                                          <option value="Shergarh">
                                            Shergarh
                                          </option>
                                          <option value="Sherkot">Sherkot</option>
                                          <option value="Shikarpur">
                                            Shikarpur
                                          </option>
                                          <option value="Shikohabad">
                                            Shikohabad
                                          </option>
                                          <option value="Shishgarh">
                                            Shishgarh
                                          </option>
                                          <option value="Shrawasti">
                                            Shrawasti
                                          </option>
                                          <option value="Siddharthnagar">
                                            Siddharthnagar
                                          </option>
                                          <option value="Sidhauli">
                                            Sidhauli
                                          </option>
                                          <option value="Sidhpura">
                                            Sidhpura
                                          </option>
                                          <option value="Sikandarabad">
                                            Sikandarabad
                                          </option>
                                          <option value="Sikandarpur">
                                            Sikandarpur
                                          </option>
                                          <option value="Sikandra">
                                            Sikandra
                                          </option>
                                          <option value="Sikandra Rao">
                                            Sikandra Rao
                                          </option>
                                          <option value="Sirathu">Sirathu</option>
                                          <option value="Sirsa">Sirsa</option>
                                          <option value="Sirsaganj">
                                            Sirsaganj
                                          </option>
                                          <option value="Sirsi">Sirsi</option>
                                          <option value="Sisauli">Sisauli</option>
                                          <option value="Siswa Bazar">
                                            Siswa Bazar
                                          </option>
                                          <option value="Sitapur">Sitapur</option>
                                          <option value="Sonbhadra">
                                            Sonbhadra
                                          </option>
                                          <option value="Soron">Soron</option>
                                          <option value="Suar">Suar</option>
                                          <option value="Sultanpur">
                                            Sultanpur
                                          </option>
                                          <option value="Surianwan">
                                            Surianwan
                                          </option>
                                          <option value="Tajpur">Tajpur</option>
                                          <option value="Talbahat">
                                            Talbahat
                                          </option>
                                          <option value="Talgram">Talgram</option>
                                          <option value="Tanda">Tanda</option>
                                          <option value="Thakurdwara">
                                            Thakurdwara
                                          </option>
                                          <option value="Thana Bhawan">
                                            Thana Bhawan
                                          </option>
                                          <option value="Tikaitnagar">
                                            Tikaitnagar
                                          </option>
                                          <option value="Tikri">Tikri</option>
                                          <option value="Tilhar">Tilhar</option>
                                          <option value="Tindwari">
                                            Tindwari
                                          </option>
                                          <option value="Titron">Titron</option>
                                          <option value="Tori-Fatehpur">
                                            Tori-Fatehpur
                                          </option>
                                          <option value="Tulsipur">
                                            Tulsipur
                                          </option>
                                          <option value="Tundla">Tundla</option>
                                          <option value="Ugu">Ugu</option>
                                          <option value="Ujhani">Ujhani</option>
                                          <option value="Ūn">Ūn</option>
                                          <option value="Unnao">Unnao</option>
                                          <option value="Usehat">Usehat</option>
                                          <option value="Utraula">Utraula</option>
                                          <option value="Varanasi">
                                            Varanasi
                                          </option>
                                          <option value="Vrindavan">
                                            Vrindavan
                                          </option>
                                          <option value="Wazirganj">
                                            Wazirganj
                                          </option>
                                          <option value="Zafarabad">
                                            Zafarabad
                                          </option>
                                          <option value="Zaidpur">Zaidpur</option>
                                          <option value="Zamania">Zamania</option>
                                        </>
                                      )}
                                    {shippingAddress.state ===
                                      "Uttarakhand" && (
                                        <>
                                          <option value="Almora">Almora</option>
                                          <option value="Bageshwar">
                                            Bageshwar
                                          </option>
                                          <option value="Barkot">Barkot</option>
                                          <option value="Bazpur">Bazpur</option>
                                          <option value="Bhim Tal">
                                            Bhim Tal
                                          </option>
                                          <option value="Bhowali">Bhowali</option>
                                          <option value="Birbhaddar">
                                            Birbhaddar
                                          </option>
                                          <option value="Chakrata">
                                            Chakrata
                                          </option>
                                          <option value="Chamoli">Chamoli</option>
                                          <option value="Champawat">
                                            Champawat
                                          </option>
                                          <option value="Clement Town">
                                            Clement Town
                                          </option>
                                          <option value="Dehradun">
                                            Dehradun
                                          </option>
                                          <option value="Devaprayag">
                                            Devaprayag
                                          </option>
                                          <option value="Dharchula">
                                            Dharchula
                                          </option>
                                          <option value="Doiwala">Doiwala</option>
                                          <option value="Dugadda">Dugadda</option>
                                          <option value="Dwarahat">
                                            Dwarahat
                                          </option>
                                          <option value="Garhwal">Garhwal</option>
                                          <option value="Haldwani">
                                            Haldwani
                                          </option>
                                          <option value="Harbatpur">
                                            Harbatpur
                                          </option>
                                          <option value="Haridwar">
                                            Haridwar
                                          </option>
                                          <option value="Jaspur">Jaspur</option>
                                          <option value="Joshimath">
                                            Joshimath
                                          </option>
                                          <option value="Kaladhungi">
                                            Kaladhungi
                                          </option>
                                          <option value="Kalagarh Project Colony">
                                            Kalagarh Project Colony
                                          </option>
                                          <option value="Kashipur">
                                            Kashipur
                                          </option>
                                          <option value="Khatima">Khatima</option>
                                          <option value="Kichha">Kichha</option>
                                          <option value="Kotdwara">
                                            Kotdwara
                                          </option>
                                          <option value="Laksar">Laksar</option>
                                          <option value="Lansdowne">
                                            Lansdowne
                                          </option>
                                          <option value="Lohaghat">
                                            Lohaghat
                                          </option>
                                          <option value="Manglaur">
                                            Manglaur
                                          </option>
                                          <option value="Mussoorie">
                                            Mussoorie
                                          </option>
                                          <option value="Naini Tal">
                                            Naini Tal
                                          </option>
                                          <option value="Narendranagar">
                                            Narendranagar
                                          </option>
                                          <option value="Pauri">Pauri</option>
                                          <option value="Pipalkoti">
                                            Pipalkoti
                                          </option>
                                          <option value="Pithoragarh">
                                            Pithoragarh
                                          </option>
                                          <option value="Raipur">Raipur</option>
                                          <option value="Raiwala Bara">
                                            Raiwala Bara
                                          </option>
                                          <option value="Ramnagar">
                                            Ramnagar
                                          </option>
                                          <option value="Ranikhet">
                                            Ranikhet
                                          </option>
                                          <option value="Rishikesh">
                                            Rishikesh
                                          </option>
                                          <option value="Roorkee">Roorkee</option>
                                          <option value="Rudraprayag">
                                            Rudraprayag
                                          </option>
                                          <option value="Sitarganj">
                                            Sitarganj
                                          </option>
                                          <option value="Srinagar">
                                            Srinagar
                                          </option>
                                          <option value="Sultanpur">
                                            Sultanpur
                                          </option>
                                          <option value="Tanakpur">
                                            Tanakpur
                                          </option>
                                          <option value="Tehri">Tehri</option>
                                          <option value="Tehri-Garhwal">
                                            Tehri-Garhwal
                                          </option>
                                          <option value="Udham Singh Nagar">
                                            Udham Singh Nagar
                                          </option>
                                          <option value="Uttarkashi">
                                            Uttarkashi
                                          </option>
                                          <option value="Vikasnagar">
                                            Vikasnagar
                                          </option>
                                        </>
                                      )}
                                    {shippingAddress.state ===
                                      "West Bengal" && (
                                        <>
                                          <option value="Ahmedpur">
                                            Ahmedpur
                                          </option>
                                          <option value="Aistala">Aistala</option>
                                          <option value="Aknapur">Aknapur</option>
                                          <option value="Alipurduar">
                                            Alipurduar
                                          </option>
                                          <option value="Amlagora">
                                            Amlagora
                                          </option>
                                          <option value="Amta">Amta</option>
                                          <option value="Amtala">Amtala</option>
                                          <option value="Andal">Andal</option>
                                          <option value="Arambagh community development block">
                                            Arambagh community development block
                                          </option>
                                          <option value="Asansol">Asansol</option>
                                          <option value="Ashoknagar Kalyangarh">
                                            Ashoknagar Kalyangarh
                                          </option>
                                          <option value="Badkulla">
                                            Badkulla
                                          </option>
                                          <option value="Baduria">Baduria</option>
                                          <option value="Bagdogra">
                                            Bagdogra
                                          </option>
                                          <option value="Bagnan">Bagnan</option>
                                          <option value="Bagula">Bagula</option>
                                          <option value="Bahula">Bahula</option>
                                          <option value="Baidyabati">
                                            Baidyabati
                                          </option>
                                          <option value="Bakreswar">
                                            Bakreswar
                                          </option>
                                          <option value="Balarampur">
                                            Balarampur
                                          </option>
                                          <option value="Bali Chak">
                                            Bali Chak
                                          </option>
                                          <option value="Bally">Bally</option>
                                          <option value="Balurghat">
                                            Balurghat
                                          </option>
                                          <option value="Bamangola community development block">
                                            Bamangola community development block
                                          </option>
                                          <option value="Baneswar">
                                            Baneswar
                                          </option>
                                          <option value="Bangaon">Bangaon</option>
                                          <option value="Bankra">Bankra</option>
                                          <option value="Bankura">Bankura</option>
                                          <option value="Bansberia">
                                            Bansberia
                                          </option>
                                          <option value="Bansihari community development block">
                                            Bansihari community development block
                                          </option>
                                          <option value="Barabazar">
                                            Barabazar
                                          </option>
                                          <option value="Baranagar">
                                            Baranagar
                                          </option>
                                          <option value="Barasat">Barasat</option>
                                          <option value="Bardhaman">
                                            Bardhaman
                                          </option>
                                          <option value="Barjora">Barjora</option>
                                          <option value="Barrackpore">
                                            Barrackpore
                                          </option>
                                          <option value="Baruipur">
                                            Baruipur
                                          </option>
                                          <option value="Basanti">Basanti</option>
                                          <option value="Basirhat">
                                            Basirhat
                                          </option>
                                          <option value="Bawali">Bawali</option>
                                          <option value="Begampur">
                                            Begampur
                                          </option>
                                          <option value="Belda">Belda</option>
                                          <option value="Beldanga">
                                            Beldanga
                                          </option>
                                          <option value="Beliatore">
                                            Beliatore
                                          </option>
                                          <option value="Berhampore">
                                            Berhampore
                                          </option>
                                          <option value="Bhadreswar">
                                            Bhadreswar
                                          </option>
                                          <option value="Bhandardaha">
                                            Bhandardaha
                                          </option>
                                          <option value="Bhatpara">
                                            Bhatpara
                                          </option>
                                          <option value="Birbhum district">
                                            Birbhum district
                                          </option>
                                          <option value="Birpara">Birpara</option>
                                          <option value="Bishnupur">
                                            Bishnupur
                                          </option>
                                          <option value="Bolpur">Bolpur</option>
                                          <option value="Budge Budge">
                                            Budge Budge
                                          </option>
                                          <option value="Canning">Canning</option>
                                          <option value="Chakapara">
                                            Chakapara
                                          </option>
                                          <option value="Chakdaha">
                                            Chakdaha
                                          </option>
                                          <option value="Champadanga">
                                            Champadanga
                                          </option>
                                          <option value="Champahati">
                                            Champahati
                                          </option>
                                          <option value="Champdani">
                                            Champdani
                                          </option>
                                          <option value="Chandannagar">
                                            Chandannagar
                                          </option>
                                          <option value="Chandrakona">
                                            Chandrakona
                                          </option>
                                          <option value="Chittaranjan">
                                            Chittaranjan
                                          </option>
                                          <option value="Churulia">
                                            Churulia
                                          </option>
                                          <option value="Contai">Contai</option>
                                          <option value="Cooch Behar">
                                            Cooch Behar
                                          </option>
                                          <option value="Cossimbazar">
                                            Cossimbazar
                                          </option>
                                          <option value="Dakshin Dinajpur district">
                                            Dakshin Dinajpur district
                                          </option>
                                          <option value="Dalkola">Dalkola</option>
                                          <option value="Dam Dam">Dam Dam</option>
                                          <option value="Darjeeling">
                                            Darjeeling
                                          </option>
                                          <option value="Daulatpur">
                                            Daulatpur
                                          </option>
                                          <option value="Debagram">
                                            Debagram
                                          </option>
                                          <option value="Debipur">Debipur</option>
                                          <option value="Dhaniakhali community development block">
                                            Dhaniakhali community development
                                            block
                                          </option>
                                          <option value="Dhulagari">
                                            Dhulagari
                                          </option>
                                          <option value="Dhulian">Dhulian</option>
                                          <option value="Dhupguri">
                                            Dhupguri
                                          </option>
                                          <option value="Diamond Harbour">
                                            Diamond Harbour
                                          </option>
                                          <option value="Digha">Digha</option>
                                          <option value="Dinhata">Dinhata</option>
                                          <option value="Domjur">Domjur</option>
                                          <option value="Dubrajpur">
                                            Dubrajpur
                                          </option>
                                          <option value="Durgapur">
                                            Durgapur
                                          </option>
                                          <option value="Egra">Egra</option>
                                          <option value="Falakata">
                                            Falakata
                                          </option>
                                          <option value="Farakka">Farakka</option>
                                          <option value="Fort Gloster">
                                            Fort Gloster
                                          </option>
                                          <option value="Gaighata community development block">
                                            Gaighata community development block
                                          </option>
                                          <option value="Gairkata">
                                            Gairkata
                                          </option>
                                          <option value="Gangadharpur">
                                            Gangadharpur
                                          </option>
                                          <option value="Gangarampur">
                                            Gangarampur
                                          </option>
                                          <option value="Garui">Garui</option>
                                          <option value="Garulia">Garulia</option>
                                          <option value="Ghatal">Ghatal</option>
                                          <option value="Giria">Giria</option>
                                          <option value="Gobardanga">
                                            Gobardanga
                                          </option>
                                          <option value="Gobindapur">
                                            Gobindapur
                                          </option>
                                          <option value="Gopalpur">
                                            Gopalpur
                                          </option>
                                          <option value="Gopinathpur">
                                            Gopinathpur
                                          </option>
                                          <option value="Gorubathan">
                                            Gorubathan
                                          </option>
                                          <option value="Gosaba">Gosaba</option>
                                          <option value="Gosanimari">
                                            Gosanimari
                                          </option>
                                          <option value="Gurdaha">Gurdaha</option>
                                          <option value="Guskhara">
                                            Guskhara
                                          </option>
                                          <option value="Habra">Habra</option>
                                          <option value="Haldia">Haldia</option>
                                          <option value="Haldibari">
                                            Haldibari
                                          </option>
                                          <option value="Halisahar">
                                            Halisahar
                                          </option>
                                          <option value="Harindanga">
                                            Harindanga
                                          </option>
                                          <option value="Haringhata">
                                            Haringhata
                                          </option>
                                          <option value="Haripur">Haripur</option>
                                          <option value="Hasimara">
                                            Hasimara
                                          </option>
                                          <option value="Hindusthan Cables Town">
                                            Hindusthan Cables Town
                                          </option>
                                          <option value="Hooghly district">
                                            Hooghly district
                                          </option>
                                          <option value="Howrah">Howrah</option>
                                          <option value="Ichapur">Ichapur</option>
                                          <option value="Indpur community development block">
                                            Indpur community development block
                                          </option>
                                          <option value="Ingraj Bazar">
                                            Ingraj Bazar
                                          </option>
                                          <option value="Islampur">
                                            Islampur
                                          </option>
                                          <option value="Jafarpur">
                                            Jafarpur
                                          </option>
                                          <option value="Jaigaon">Jaigaon</option>
                                          <option value="Jalpaiguri">
                                            Jalpaiguri
                                          </option>
                                          <option value="Jamuria">Jamuria</option>
                                          <option value="Jangipur">
                                            Jangipur
                                          </option>
                                          <option value="Jaynagar Majilpur">
                                            Jaynagar Majilpur
                                          </option>
                                          <option value="Jejur">Jejur</option>
                                          <option value="Jhalida">Jhalida</option>
                                          <option value="Jhargram">
                                            Jhargram
                                          </option>
                                          <option value="Jhilimili">
                                            Jhilimili
                                          </option>
                                          <option value="Kakdwip">Kakdwip</option>
                                          <option value="Kalaikunda">
                                            Kalaikunda
                                          </option>
                                          <option value="Kaliaganj">
                                            Kaliaganj
                                          </option>
                                          <option value="Kalimpong">
                                            Kalimpong
                                          </option>
                                          <option value="Kalna">Kalna</option>
                                          <option value="Kalyani">Kalyani</option>
                                          <option value="Kamarhati">
                                            Kamarhati
                                          </option>
                                          <option value="Kamarpukur">
                                            Kamarpukur
                                          </option>
                                          <option value="Kanchrapara">
                                            Kanchrapara
                                          </option>
                                          <option value="Kandi">Kandi</option>
                                          <option value="Karimpur">
                                            Karimpur
                                          </option>
                                          <option value="Katwa">Katwa</option>
                                          <option value="Kenda">Kenda</option>
                                          <option value="Keshabpur">
                                            Keshabpur
                                          </option>
                                          <option value="Kharagpur">
                                            Kharagpur
                                          </option>
                                          <option value="Kharar">Kharar</option>
                                          <option value="Kharba">Kharba</option>
                                          <option value="Khardaha">
                                            Khardaha
                                          </option>
                                          <option value="Khatra">Khatra</option>
                                          <option value="Kirnahar">
                                            Kirnahar
                                          </option>
                                          <option value="Kolkata">Kolkata</option>
                                          <option value="Konnagar">
                                            Konnagar
                                          </option>
                                          <option value="Krishnanagar">
                                            Krishnanagar
                                          </option>
                                          <option value="Krishnapur">
                                            Krishnapur
                                          </option>
                                          <option value="Kshirpai">
                                            Kshirpai
                                          </option>
                                          <option value="Kulpi">Kulpi</option>
                                          <option value="Kultali">Kultali</option>
                                          <option value="Kulti">Kulti</option>
                                          <option value="Kurseong">
                                            Kurseong
                                          </option>
                                          <option value="Lalgarh">Lalgarh</option>
                                          <option value="Lalgola">Lalgola</option>
                                          <option value="Loyabad">Loyabad</option>
                                          <option value="Madanpur">
                                            Madanpur
                                          </option>
                                          <option value="Madhyamgram">
                                            Madhyamgram
                                          </option>
                                          <option value="Mahiari">Mahiari</option>
                                          <option value="Mahishadal community development block">
                                            Mahishadal community development block
                                          </option>
                                          <option value="Mainaguri">
                                            Mainaguri
                                          </option>
                                          <option value="Manikpara">
                                            Manikpara
                                          </option>
                                          <option value="Masila">Masila</option>
                                          <option value="Mathabhanga">
                                            Mathabhanga
                                          </option>
                                          <option value="Matiali community development block">
                                            Matiali community development block
                                          </option>
                                          <option value="Matigara community development block">
                                            Matigara community development block
                                          </option>
                                          <option value="Medinipur">
                                            Medinipur
                                          </option>
                                          <option value="Mejia community development block">
                                            Mejia community development block
                                          </option>
                                          <option value="Memari">Memari</option>
                                          <option value="Mirik">Mirik</option>
                                          <option value="Mohanpur community development block">
                                            Mohanpur community development block
                                          </option>
                                          <option value="Monoharpur">
                                            Monoharpur
                                          </option>
                                          <option value="Muragacha">
                                            Muragacha
                                          </option>
                                          <option value="Muri">Muri</option>
                                          <option value="Murshidabad">
                                            Murshidabad
                                          </option>
                                          <option value="Nabadwip">
                                            Nabadwip
                                          </option>
                                          <option value="Nabagram">
                                            Nabagram
                                          </option>
                                          <option value="Nadia district">
                                            Nadia district
                                          </option>
                                          <option value="Nagarukhra">
                                            Nagarukhra
                                          </option>
                                          <option value="Nagrakata">
                                            Nagrakata
                                          </option>
                                          <option value="Naihati">Naihati</option>
                                          <option value="Naksalbari">
                                            Naksalbari
                                          </option>
                                          <option value="Nalhati">Nalhati</option>
                                          <option value="Nalpur">Nalpur</option>
                                          <option value="Namkhana community development block">
                                            Namkhana community development block
                                          </option>
                                          <option value="Nandigram">
                                            Nandigram
                                          </option>
                                          <option value="Nangi">Nangi</option>
                                          <option value="Nayagram community development block">
                                            Nayagram community development block
                                          </option>
                                          <option value="North 24 Parganas district">
                                            North 24 Parganas district
                                          </option>
                                          <option value="Odlabari">
                                            Odlabari
                                          </option>
                                          <option value="Paikpara">
                                            Paikpara
                                          </option>
                                          <option value="Panagarh">
                                            Panagarh
                                          </option>
                                          <option value="Panchla">Panchla</option>
                                          <option value="Panchmura">
                                            Panchmura
                                          </option>
                                          <option value="Pandua">Pandua</option>
                                          <option value="Panihati">
                                            Panihati
                                          </option>
                                          <option value="Panskura">
                                            Panskura
                                          </option>
                                          <option value="Parbatipur">
                                            Parbatipur
                                          </option>
                                          <option value="Paschim Medinipur district">
                                            Paschim Medinipur district
                                          </option>
                                          <option value="Patiram">Patiram</option>
                                          <option value="Patrasaer">
                                            Patrasaer
                                          </option>
                                          <option value="Patuli">Patuli</option>
                                          <option value="Pujali">Pujali</option>
                                          <option value="Puncha community development block">
                                            Puncha community development block
                                          </option>
                                          <option value="Purba Medinipur district">
                                            Purba Medinipur district
                                          </option>
                                          <option value="Purulia">Purulia</option>
                                          <option value="Raghudebbati">
                                            Raghudebbati
                                          </option>
                                          <option value="Raghunathpur">
                                            Raghunathpur
                                          </option>
                                          <option value="Raiganj">Raiganj</option>
                                          <option value="Rajmahal">
                                            Rajmahal
                                          </option>
                                          <option value="Rajnagar community development block">
                                            Rajnagar community development block
                                          </option>
                                          <option value="Ramchandrapur">
                                            Ramchandrapur
                                          </option>
                                          <option value="Ramjibanpur">
                                            Ramjibanpur
                                          </option>
                                          <option value="Ramnagar">
                                            Ramnagar
                                          </option>
                                          <option value="Rampur Hat">
                                            Rampur Hat
                                          </option>
                                          <option value="Ranaghat">
                                            Ranaghat
                                          </option>
                                          <option value="Raniganj">
                                            Raniganj
                                          </option>
                                          <option value="Raypur">Raypur</option>
                                          <option value="Rishra">Rishra</option>
                                          <option value="Sahapur">Sahapur</option>
                                          <option value="Sainthia">
                                            Sainthia
                                          </option>
                                          <option value="Salanpur community development block">
                                            Salanpur community development block
                                          </option>
                                          <option value="Sankarpur">
                                            Sankarpur
                                          </option>
                                          <option value="Sankrail">
                                            Sankrail
                                          </option>
                                          <option value="Santipur">
                                            Santipur
                                          </option>
                                          <option value="Santoshpur">
                                            Santoshpur
                                          </option>
                                          <option value="Santuri community development block">
                                            Santuri community development block
                                          </option>
                                          <option value="Sarenga">Sarenga</option>
                                          <option value="Serampore">
                                            Serampore
                                          </option>
                                          <option value="Serpur">Serpur</option>
                                          <option value="Shyamnagar, West Bengal">
                                            Shyamnagar, West Bengal
                                          </option>
                                          <option value="Siliguri">
                                            Siliguri
                                          </option>
                                          <option value="Singur">Singur</option>
                                          <option value="Sodpur">Sodpur</option>
                                          <option value="Solap">Solap</option>
                                          <option value="Sonada">Sonada</option>
                                          <option value="Sonamukhi">
                                            Sonamukhi
                                          </option>
                                          <option value="Sonarpur community development block">
                                            Sonarpur community development block
                                          </option>
                                          <option value="South 24 Parganas district">
                                            South 24 Parganas district
                                          </option>
                                          <option value="Srikhanda">
                                            Srikhanda
                                          </option>
                                          <option value="Srirampur">
                                            Srirampur
                                          </option>
                                          <option value="Suri">Suri</option>
                                          <option value="Swarupnagar community development block">
                                            Swarupnagar community development
                                            block
                                          </option>
                                          <option value="Takdah">Takdah</option>
                                          <option value="Taki">Taki</option>
                                          <option value="Tamluk">Tamluk</option>
                                          <option value="Tarakeswar">
                                            Tarakeswar
                                          </option>
                                          <option value="Titagarh">
                                            Titagarh
                                          </option>
                                          <option value="Tufanganj">
                                            Tufanganj
                                          </option>
                                          <option value="Tulin">Tulin</option>
                                          <option value="Uchalan">Uchalan</option>
                                          <option value="Ula">Ula</option>
                                          <option value="Uluberia">
                                            Uluberia
                                          </option>
                                          <option value="Uttar Dinajpur district">
                                            Uttar Dinajpur district
                                          </option>
                                          <option value="Uttarpara Kotrung">
                                            Uttarpara Kotrung
                                          </option>
                                        </>
                                      )}
                                  </>
                                )}
                              </select>
                            </>
                          ) : field === "area" ? (
                            <select
                              name="area"
                              className="form-select"
                              value={shippingAddress.area}
                              onChange={handleShippingChange}
                              required
                            >
                              <option value="">Select Area</option>
                              {stateAreaMap?.map((area) => (
                                <option key={area} value={area}>
                                  {area}
                                </option>
                              ))}
                            </select>
                          ) : (
                            // Regular Input Field
                            <input
                              type="text"
                              name={field}
                              placeholder={field
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())}
                              value={
                                field === "pinCode"
                                  ? enteredPinCode
                                  : shippingAddress[field]
                              }
                              onChange={handleShippingChange}
                              className="form-control"
                              required={field !== "addressLine2"}
                            />
                          )}
                          {field === "pinCode" &&
                            enteredPinCode.length > 0 &&
                            enteredPinCode.length !== 6 && (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                              >
                                Pincode must be exactly 6 digits.
                              </p>
                            )}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="form-check mb-4 d-flex align-items-center justify-content-between flex-wrap">
                    <div className="form-check mb-4 d-flex align-items-center">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="sameAddress"
                        checked={sameAddress}
                        onChange={() => setSameAddress(!sameAddress)}
                        style={{ marginRight: "10px", marginTop: "2px" }} // Adds space between checkbox and label
                      />
                      <label className="form-check-label" htmlFor="sameAddress">
                        Use same address for Billing
                      </label>
                    </div>

                  </div>
                </div>
                 

                <div className="card checkoutcard mb-4">
                

                  <div className="card-header">Billing Address</div>
                  <div className="card-body">
                    <div className="row">
                      {Object.keys(billingAddress).map((field) => (
                        <div key={field} className="col-md-6 ">
                          {field === "country" ? (
                            // Country Dropdown
                            <select
                              name="country"
                              value={billingAddress.country || ""}
                              onChange={handleBillingChange}
                              className="form-control"
                              disabled={sameAddress}
                              required
                            >
                              <option value="">Select Country</option>
                              <option value="USA">United States</option>
                              <option value="Canada">Canada</option>
                              <option value="India">India</option>
                              <option value="UK">United Kingdom</option>
                            </select>
                          ) : field === "state" ? (
                            // State Dropdown
                            <select
                              name="state"
                              value={billingAddress.state || ""}
                              onChange={handleBillingChange}
                              disabled={sameAddress}
                              className="form-control"
                              required
                            >
                              <option value="">Select State</option>
                              {billingAddress.country === "USA" && (
                                <>
                                  <option value="California">California</option>
                                  <option value="Texas">Texas</option>
                                  <option value="New York">New York</option>
                                </>
                              )}
                              {billingAddress.country === "India" && (
                                <>
                                  <option value="Andhra Pradesh">
                                    Andhra Pradesh
                                  </option>
                                  <option value="Arunachal Pradesh">
                                    Arunachal Pradesh
                                  </option>
                                  <option value="Assam">Assam</option>
                                  <option value="Bihar">Bihar</option>
                                  <option value="Chhattisgarh">
                                    Chhattisgarh
                                  </option>
                                  <option value="Goa">Goa</option>
                                  <option value="Gujarat">Gujarat</option>
                                  <option value="Haryana">Haryana</option>
                                  <option value="Himachal Pradesh">
                                    Himachal Pradesh
                                  </option>
                                  <option value="Jharkhand">Jharkhand</option>
                                  <option value="Karnataka">Karnataka</option>
                                  <option value="Kerala">Kerala</option>
                                  <option value="Madhya Pradesh">
                                    Madhya Pradesh
                                  </option>
                                  <option value="Maharashtra">
                                    Maharashtra
                                  </option>
                                  <option value="Manipur">Manipur</option>
                                  <option value="Meghalaya">Meghalaya</option>
                                  <option value="Mizoram">Mizoram</option>
                                  <option value="Nagaland">Nagaland</option>
                                  <option value="Odisha">Odisha</option>
                                  <option value="Punjab">Punjab</option>
                                  <option value="Rajasthan">Rajasthan</option>
                                  <option value="Sikkim">Sikkim</option>
                                  <option value="Tamil Nadu">Tamil Nadu</option>
                                  <option value="Telangana">Telangana</option>
                                  <option value="Tripura">Tripura</option>
                                  <option value="Uttar Pradesh">
                                    Uttar Pradesh
                                  </option>
                                  <option value="Uttarakhand">
                                    Uttarakhand
                                  </option>
                                  <option value="West Bengal">
                                    West Bengal
                                  </option>
                                  <option value="Andaman and Nicobar Islands">
                                    Andaman and Nicobar Islands
                                  </option>
                                  <option value="Chandigarh">Chandigarh</option>
                                  <option value="Dadra and Nagar Haveli and Daman and Diu">
                                    Dadra and Nagar Haveli and Daman and Diu
                                  </option>
                                  <option value="Lakshadweep">
                                    Lakshadweep
                                  </option>
                                  <option value="Delhi">Delhi</option>
                                  <option value="Puducherry">Puducherry</option>
                                  <option value="Jammu and Kashmir">
                                    Jammu and Kashmir
                                  </option>
                                  <option value="Ladakh">Ladakh</option>
                                </>
                              )}
                            </select>
                          ) : (
                            // Regular Input Field
                            <input
                              type="text"
                              name={field}
                              placeholder={field
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())}
                              value={billingAddress[field]}
                              onChange={handleBillingChange}
                              className="form-control"
                              disabled={sameAddress}
                              required={field !== "addressLine2"}
                            />
                          )}
                          {field === "pinCode" &&
                            billingAddress.pinCode.length > 0 &&
                            billingAddress.pinCode.length !== 6 && (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                              >
                                Pincode must be exactly 6 digits.
                              </p>
                            )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="productaddress">
            <div className="address-grid">
              <div className="mb-4 summary">
                <Link to={"/cart"}>
                  <ArrowBackIcon />
                  Review Your Cart
                </Link>
                {cartItems.map((item, index) => (
                  <div key={index} className="cart-item-row">
                    <img src={getImageUrl(item.image)} alt={item.productName} className="cart-item-img" />
                    <div className="cart-item-info">
                      <div className="cart-product-name">{item.productName}</div>
                      <div className="cart-item-meta">
                        <span>Size: <strong>{item.size}</strong></span>
                        <span>Qty: <strong>{item.quantity}</strong></span>
                        <span>Price: ₹<strong>{item.price}</strong></span>
                        <span>Total: ₹<strong>{item.price * item.quantity}</strong></span>
                      </div>
                    </div>
                  </div>
                ))}


              </div>

              <h3>Saved Addresses</h3>
              <div className="checkoutaddresslist">
                {addresses.length > 0 ? (
                  addresses.slice(0, 2).map((address, index) => (
                    <div
                      key={index}
                      className="address-card"
                      onClick={() => handleAddressClick(address)}
                    >
                      <p className="address-name">
                        <strong>{address.fullName}</strong>
                      </p>
                      <p className="address-line">{address.addressLine1}</p>
                      <p className="address-line">
                        {address.city}, {address.state} - {address.pinCode}
                      </p>
                      <p className="address-line">{address.country}</p>
                    </div>
                  ))
                ) : (
                  <p>No addresses found</p>
                )}
              </div>
            </div>
            <div className="order-summary-wrapper">
              <div className="total-section card-total-summary">
                <h3 className="section-title">Order Summary</h3>

                {/* Subtotal (Incl. GST) */}
                <div className="summary-row">
                  <span>Subtotal (Incl. GST @18%)</span>
                  <span>₹{subtotalWithGST.toFixed(2)}</span>
                </div>

                {/* GST Breakdown */}
                <div className="summary-row" style={{ fontSize: "0.9rem", color: "#555" }}>
                  <span>Excl. GST</span>
                  <span>₹{subtotalWithoutGST.toFixed(2)}</span>
                </div>
                <div className="summary-row" style={{ fontSize: "0.9rem", color: "#555" }}>
                  <span>GST @18%</span>
                  <span>₹{gstAmount.toFixed(2)}</span>
                </div>

                {/* Shipping and Handling */}
                <div className="summary-row">
                  <span>Shipping and Handling</span>
                  <span>₹{shipping}</span>
                </div>

                {/* Use GST Invoice checkbox */}
                <div className="summary-row d-flex align-items-center justify-content-between" style={{ marginTop: "15px" }}>
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="useGST"
                      checked={useGSTInvoice}
                      onChange={(e) => setUseGSTInvoice(e.target.checked)}
                      style={{ marginRight: "8px" }}
                    />
                    <label htmlFor="useGST" className="form-check-label mb-0">
                      Use GST Invoice
                    </label>
                  </div>
                </div>




                {/* GST Number Input */}
                {useGSTInvoice && (
                  <div className="summary-row" style={{ marginTop: "10px" }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter GST Number"
                      value={gstNumber}
                      onChange={(e) => setGstNumber(e.target.value)}
                      maxLength={15}
                      style={{ width: "100%" }}
                    />
                  </div>
                )}

                <hr className="divider" />

                {/* Final Total */}
                <div className="summary-row total">
                  <strong>Order Total</strong>
                  <strong>₹{finalTotal.toFixed(2)}</strong>
                </div>
              </div>
            </div>



            <button
              type="submit"
              className="btn btn-primary"
              form="paymentForm"
            >
              Pay Now
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Checkout;
